(function ($) {
  
  'use strict';
  
  /**
   * ----------------------------------------------------------------------------------------------------
   * BASE
   * ----------------------------------------------------------------------------------------------------
   */
  
  /**
   * GLOBAL VARIABLES
   */
  
  var $window = $(window),
      position = $window.scrollTop(),
      last_scroll_direction = '',
      win_height_padded = $window.height() * 1.1,
      has_faded = 0;   
  
  /**
   * HELPER FUNCTIONS
   */

  // Retourne "true" si la page actuelle est la page d'accueil
  function isHomePage() {
    var url = window.location.pathname;
    
    if(url == '/') {
      return true;
    } else {
      return false;
    }
  }

  // Retourne "true" si la page actuelle est la page "pageHandle"
  function isPage(pageHandle) {
    var url = window.location.href;
    
    if(url.indexOf(pageHandle) != -1) {
      return true;
    } else {
      return false;
    }
  }
  
  // Convertit une string en prix
  function convertToPriceFormat(amount) {
    var domain = window.location.hostname,        
        amout_without_trailing_zeros = amount,
        amout_with_trailing_zeros = amount,
        trailing_zeros = 0;
    
  	amount = amount / 100; // Met le bon format
    amout_without_trailing_zeros = amount.toFixed();
    amout_with_trailing_zeros = amount.toFixed(2);    
    trailing_zeros = amout_with_trailing_zeros - amout_without_trailing_zeros;
    
    if(trailing_zeros == 0) {
      amount = amout_without_trailing_zeros; // Retire les décimales
    } else {
      amount = amout_with_trailing_zeros; // Ajoute les décimales
    }
    amount = amount.replace('.', ','); // Remplace le point par la virgule
    
    switch (domain) {
      case 'www.soshape.com':
      case 'es.soshape.com':
      case 'de.soshape.com':
      case 'pharma.soshape.com':
        amount += '€';
        break;      
      case 'eu.soshape.com':
      case 'it.soshape.com':
      case 'pl.soshape.com':
        amount += '€';
        break;
      case 'nl.soshape.com':
        amount = '€ ' + amount;
        break;
      case 'uk.soshape.com':
        amount = '£' + amount;
        break;
      case 'us.soshape.com':
      case 'macandcheese.soshape.com':
        amount = '$' + amount;
        break;
      default:
        amount += '€';
    }
    
    return amount;
  }
  
  // Retourne la direction du scroll vertical
  function getVerticalScrollDirection() {
    var scrolled = $window.scrollTop(),
        delta = scrolled - position,
        vertical_scroll_direction = '';
    
    if(scrolled >= 20 && delta > 20) {
      vertical_scroll_direction = 'down';
    } else if(scrolled < 20 || delta < -20) {
      vertical_scroll_direction = 'up';
    }
    
    return vertical_scroll_direction;
  }
  
  // Retourne la direction du scroll vertical (DEPRECATED)
  function getVerticalScrollDirection_Deprecated() {
    var scrolled = $window.scrollTop(),
        vertical_scroll_direction = '';
    
    if(scrolled > position) {
      vertical_scroll_direction = 'down';
    } else if(scrolled < position) {
      vertical_scroll_direction = 'up';
    } else if(last_scroll_direction == 'down') {
   	  vertical_scroll_direction = 'down';
    } else if(last_scroll_direction == 'up') {
   	  vertical_scroll_direction = 'up';
    } else {
      vertical_scroll_direction = 'down';
    }
    
    position = scrolled;
    last_scroll_direction = vertical_scroll_direction;
    
    return vertical_scroll_direction;
  }
  
  // Scroll en haut de la page
  function scrollToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  
  // Scroll en haut de la popup
  function scrollToTopModal($this) {
    var modal = $this.closest('.modal').get(0);
    
	  modal.scrollIntoView(true);
  }
  
  // Scroll vers l'élément passé en paramètre
  function scrollToElement(element) {    
    $('html, body').animate({
      scrollTop: $(element).offset().top
    }, 'slow');
  }
  
  // Anime une valeur chiffrée
  function animateValue($this, e, start, end, duration) {
    let startTimestamp = null,
        domain = window.location.hostname;
    
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1),
            new_value = Math.floor(progress * (end - start) + start);
	  var new_value_formatted = new_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      
      if(domain.indexOf('us.') != -1 || domain.indexOf('uk.') != -1 || domain.indexOf('eu.') != -1) {
        new_value_formatted = new_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      
      if(domain.indexOf('de.') != -1) {
        new_value_formatted = new_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      
      $this.text(new_value_formatted);
      
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    
    window.requestAnimationFrame(step);
  }
  
  // Cache un bandeau
  function hideBand(section) {    
    if(section.length) {
      section.fadeOut();
      section.remove();
      
      if(window.innerWidth < 500 && section.hasClass('shopify-section__cookies-bar')) {
        $('#gorgias-chat-container').find('#chat-button').css('margin-bottom', '0px');
      }
    }
  }
  
  // Affiche un bandeau
  function showBand(section) { 
    if(section.length && section.children().length) {
      section.fadeIn();
      section.show();
      
      if(window.innerWidth < 500 && section.hasClass('shopify-section__cookies-bar')) {
        $('#gorgias-chat-container').find('#chat-button').css('margin-bottom', '40px');
      }
    }
  }
  
  // Enlève 1 ou 'step' à la quantité de l'item
  function subQuantity($this) { 
    var quantity = $this.closest('.product__quantity'),
    	quantity_wrapper = quantity.find('.product__quantity-wrapper'),
        quantity_min = parseInt(quantity_wrapper.data('min')),
        quantity_step = parseInt(quantity_wrapper.data('step')),
        quantity_sub_button = quantity_wrapper.find('.button--quantity-sub'),
        quantity_item = $this.siblings('.product__quantity-value'),
        quantity_value = parseInt(quantity_item.text()),
        new_value = quantity_value - quantity_step;
    
    if(new_value >= quantity_min) {
      quantity_item.text(new_value);
    }
    
    if(new_value <= quantity_min) {
      quantity_sub_button.attr('disabled', 'disabled');
      quantity_sub_button.removeAttr('data-action');

      var item_product = $this.closest('.item-product');
      if(item_product.length) {
        item_product.removeClass('selected');
      }
    }
  }
  
  // Ajoute 1 ou 'step' à la quantité de l'item
  function addQuantity($this) {
    var quantity = $this.closest('.product__quantity'),
    	quantity_wrapper = quantity.find('.product__quantity-wrapper'),
        quantity_min = parseInt(quantity_wrapper.data('min')),
        quantity_step = parseInt(quantity_wrapper.data('step')),
        quantity_sub_button = quantity_wrapper.find('.button--quantity-sub'),
        quantity_item = $this.siblings('.product__quantity-value'),
        quantity_value = parseInt(quantity_item.text()),
        new_value = quantity_value + quantity_step;
    
    quantity_item.text(new_value);
    
    if(new_value > quantity_min) {
      quantity_sub_button.removeAttr('disabled');
      quantity_sub_button.attr('data-action', 'sub-product');
      
      var item_product = $this.closest('.item-product');
      if(item_product.length) {
        item_product.addClass('selected');
      }
    }
  }
  
  /**
   * -------------------------------
   * GENERAL
   * -------------------------------
   */
  
  /**
   * ON LOAD
   */

  const updateQuantityFromCart = async (key, quantity, mainPackId = "") => {
    const itemsToUpdate = {updates: {}};

    if(mainPackId != "" && mainPackId != undefined && quantity == 0) {
      await fetch('/cart.js').then(function(response) {
        return response.json();
      }).then((data) => {
        const cartItems = data.items;
        const packItems = cartItems.filter(item => item.properties['_pack_id'] != undefined && item.properties['_pack_main'] == undefined);
        const itemsToRemove = packItems.filter(item => item.properties['_pack_id'] == mainPackId);
        itemsToRemove.forEach((item) => {
          itemsToUpdate.updates[item.key] = 0;
        });
      });
    }

    itemsToUpdate.updates[key] = quantity;

    if(Object.keys(itemsToUpdate.updates).length > 0) {
      fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify(itemsToUpdate)
      })
      .then(() => {
        window.location.reload();
      });
    }
  }

  const validateCartPage = () => {
    fetch('/cart.js').then(function(response) {
      return response.json();
    }).then(function(data) {
      const cartItems = data.items;
      const packItems = cartItems.filter(item => item.properties['_pack_id'] != undefined && item.properties['_pack_main'] == undefined);
      let itemsToRemove = {updates: {}};

      packItems.forEach((item) => {
        const packId = item.properties['_pack_id'];
        const mainPackItem = cartItems.find(item => item.properties['_pack_id'] == packId && item.properties['_pack_main'] == "true");

        if(!mainPackItem) {
          itemsToRemove.updates[item.key] = 0;
        }
      });

      if(Object.keys(itemsToRemove.updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify(itemsToRemove)
        })
        .then(() => {
          window.location.reload();
        });
      }
    });
  }

  function changeItemsQuantityFromCart() {
    const cartPage = document.querySelector('.section--cart-content');

    if (!cartPage) return;

    const allCartItems = cartPage.querySelectorAll('.item-cart');

    allCartItems.forEach((cartItem) => {
      const subButton = cartItem.querySelector('.button--quantity-sub');
      if (subButton) {
        subButton.addEventListener('click', () => {
          const quantity = Number(subButton.getAttribute('data-quantity'));
          const key = subButton.getAttribute('data-key');
          const mainPackId = subButton.getAttribute('data-main-pack-id');
          updateQuantityFromCart(key, quantity, mainPackId);
        });
      }

      const addButton = cartItem.querySelector('.button--quantity-add');
      if (addButton) {
        addButton.addEventListener('click', () => {
          const quantity = Number(addButton.getAttribute('data-quantity'));
          const key = addButton.getAttribute('data-key');
          const mainPackId = addButton.getAttribute('data-main-pack-id');
          updateQuantityFromCart(key, quantity, mainPackId);
        });
      }

      const removeButton = cartItem.querySelector('.cart-item-remove');
      if (removeButton) {
        removeButton.addEventListener('click', () => {
          const key = removeButton.getAttribute('data-key');
          const mainPackId = removeButton.getAttribute('data-main-pack-id');
          updateQuantityFromCart(key, 0, mainPackId);
        });
      }
    });
  }

  if(isPage('/cart')) {
    validateCartPage();
    changeItemsQuantityFromCart();
  }
  
  // Vérifie la temporalité des sous-messages du carousel d'annonces
  function checkAnnouncementBarDisplayMessages(carousel) {
    var announcement_bar = carousel.closest('.announcement-bar'),
        cells = carousel.find('.carousel-cell'),
        now = new Date(),
        y = now.getFullYear(),
        m = now.getMonth(),
        day = now.getDate(),
        d = now.getDay(),
        d_text = d.toString(),      
        h = now.getHours();
    
    cells.each(function() {
      var cell = $(this),
          cell_siblings = cell.siblings(),
          message = cell.find('.item-announcement'),
          sub_messages = message.find('.announcement__sub-message');
      
      sub_messages.each(function() {
        var sub_message = $(this),
            sub_message_siblings = sub_message.siblings(),
            temporality = sub_message.data('temporality'),
            temporality_split = temporality.split('/'),
            days = temporality_split[0],
            hours = temporality_split[1],
            hours_split = hours.split('-'),
            first_hour = parseInt(hours_split[0]),
            last_hour = parseInt(hours_split[1]),
            expiration_date = sub_message.data('expiration-date'),
            expiration_date_split = expiration_date.split('/'),
            y_exp = parseInt(expiration_date_split[2]),
            m_exp = parseInt(expiration_date_split[1]) - 1,
            d_exp = parseInt(expiration_date_split[0]),
            display_sub_message = true;
        
        // Vérifie si le jour et l'heure d'affichage correspondent
        if(days != 'all') {
          if(days.indexOf(d_text) == -1) {
            display_sub_message = false;
          } else {
            if(hours != 'all') {
              if(h < first_hour || h >= last_hour) {
                display_sub_message = false;
              }
            }
          }
        } else {
          if(hours != 'all') {
            if(h < first_hour || h >= last_hour) {
              display_sub_message = false;
            }
          }
        }
        
        // Vérifie si on a pas atteind la date d'expiration
        if(expiration_date != 'none' && expiration_date != '') {
          if(y >= y_exp && m >= m_exp && day >= d_exp) {
            display_sub_message = false;
          }
        }  
        
        // Vérifie quel élément supprimer ou afficher
        if(!display_sub_message) {
          if(sub_message_siblings.length == 0) {
            if(cell_siblings.length == 0) {
              announcement_bar.remove();
            } else {
              cell.remove();
              
              // Si on supprime un message, il faut ajuster le nombre d'éléments à afficher pour le carousel et pour chaque device
              var nb_cells = cell_siblings.length,
                  slides_to_show_mobile = carousel.data('slides-to-show-mobile'),
                  slides_to_show_tablet = carousel.data('slides-to-show-tablet'),
                  slides_to_show_desktop = carousel.data('slides-to-show-desktop');              
              
              if(nb_cells < slides_to_show_mobile) {
                carousel.data('slides-to-show-mobile', slides_to_show_mobile - 1);
                carousel.attr('data-slides-to-show-mobile', slides_to_show_mobile - 1);
              }
              
              if(nb_cells < slides_to_show_tablet) {
                carousel.data('slides-to-show-tablet', slides_to_show_tablet - 1);
                carousel.attr('data-slides-to-show-tablet', slides_to_show_tablet - 1);
              } 
              
              if(nb_cells < slides_to_show_desktop) {
                carousel.data('slides-to-show-desktop', slides_to_show_desktop - 1);
                carousel.attr('data-slides-to-show-desktop', slides_to_show_desktop - 1);
              }
            }
          } else {
          	sub_message.remove();
          }
        } else {
          sub_message.removeClass('hidden');
          carousel.removeClass('hidden');
          announcement_bar.removeClass('loading');
        }
      });
    });
  }
  
  // Vérifie la source du bloc d'annonces
  function checkAnnouncementBarsDisplayBlocks(carousel) {
  	var announcement_bar = carousel.closest('.announcement-bar'),
        announcement_bar_source = announcement_bar.data('source'),
        announcement_bar_utm_source = announcement_bar.data('utm-source'),
        window_search = window.location.search,
        window_search_announcement_bars_from_sources = $('.announcement-bar[data-source="' + window_search + '"]'),
        window_search_has_block_from_source = false,
        window_search_has_block_from_utm_source = false,
        remove_announcement = false;
    
    // Si un des blocs a comme source l'utm de l'url
    if(window_search_announcement_bars_from_sources.length) {
      window_search_has_block_from_source = true;
    }
    
    // Si un des blocs a comme utm_source l'utm de l'url
    announcement_bar.siblings().each(function() {
      var sibling = $(this),
          sibling_utm_source = sibling.data('utm-source');
      
      if(sibling_utm_source != "" && window_search.indexOf(sibling_utm_source) != -1) {
        window_search_has_block_from_utm_source = true;
      }
    });
    
    // Si l'utm de l'url est vide ET que la source ou l'utm_source du bloc n'est pas vide
    if(window_search == "" && (announcement_bar_source != "" || announcement_bar_utm_source != "")) {
      remove_announcement = true;
    }
    
    // Si l'utm de l'url n'est pas vide ET que la source ET l'utm_source du bloc sont vides
    if(window_search != "" && announcement_bar_source == "" && announcement_bar_utm_source == "") {
      remove_announcement = true;
    }
    
    // Si l'utm de l'url n'est pas vide ET que la source du bloc n'est pas vide ET que l'utm et la source sont différents
    if(window_search != "" && announcement_bar_source != "" && window_search != announcement_bar_source) {
      remove_announcement = true;
    }
    
    // Si l'utm de l'url n'est pas vide ET que l'utm_source du bloc n'est pas vide ET que l'utm ne contient pas l'utm_source
    if(window_search != "" && announcement_bar_utm_source != "" && window_search.indexOf(announcement_bar_utm_source) == -1) {
      remove_announcement = true;
    }
    
    // Si l'utm de l'url n'est pas vide ET que la source du bloc est vide ET que l'utm_source du bloc n'est pas vide ET que que l'utm de l'url a un bloc associé
    if(window_search != "" && announcement_bar_source == "" && announcement_bar_utm_source != "" && window_search_has_block_from_source) {
      remove_announcement = true;
    }
    
    // Si l'utm de l'url n'est pas vide ET que la source ET l'utm_source du bloc sont vides ET que l'utm de l'url n'a pas de bloc associé
    if(window_search != "" && announcement_bar_source == "" && announcement_bar_utm_source == "" && !window_search_has_block_from_source && !window_search_has_block_from_utm_source) {
      remove_announcement = false;
    }
    
    if(remove_announcement) {
      announcement_bar.remove();
    } else {
      checkAnnouncementBarDisplayMessages(carousel);
    }
  }
  
  // Affiche les barres d'annonces
  function displayAnnouncementBars(e) {    
    var carousels = $('.carousel--announcements');

    carousels.each(function() {
      var carousel = $(this);
      
      checkAnnouncementBarsDisplayBlocks(carousel);
    });

    if (carousels.length <= 0) {
      $('.announcement-bar').removeClass('loading');
    }
  }
  
  // Démarre un carousel
  function startCarousel(carousel, modal) {
    var prev_arrow = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0-11,9.82,0,19" transform="translate(12.5 2.118)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>',
        next_arrow = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0,11,9.82,0,19" transform="translate(2.118 2.118)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>';
    
    carousel.slick({
      accessibility: carousel.data('accessibility'),
      adaptiveHeight: carousel.data('adaptive-height'),
      autoplay: carousel.data('autoplay'),
      autoplaySpeed: carousel.data('autoplay-speed-desktop'),
      arrows: carousel.data('arrows-desktop'),
      centerMode: carousel.data('center-mode-desktop'),
      centerPadding: carousel.data('center-padding-desktop'),
      cssEase: carousel.data('css-ease'),
      dots: carousel.data('dots-desktop'),
      draggable: carousel.data('draggable'),
      fade: carousel.data('fade'),
      edgeFriction: carousel.data('edge-friction'),
      infinite: carousel.data('infinite'),
      initialSlide: carousel.data('initial-slide-desktop'),
      slidesToShow: carousel.data('slides-to-show-desktop'),
      slidesToScroll: carousel.data('slides-to-scroll-desktop'),
      speed: carousel.data('speed'),
      swipe: carousel.data('swipe'),
      swipeToSlide: carousel.data('swipe-to-slide'),
      touchMove: carousel.data('touch-move'),
      touchThreshold: carousel.data('touch-threshold'),
      useCss: carousel.data('use-css'),
      useTransform: carousel.data('use-transform'),
      variableWidth: carousel.data('variable-width'),
      vertical: carousel.data('vertical'),
      verticalSwiping: carousel.data('vertical-swiping'),
      prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
      nextArrow: '<button class="slick-next">' + next_arrow + '</button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            autoplaySpeed: carousel.data('autoplay-speed-tablet'),
            arrows: carousel.data('arrows-tablet'),
      		centerMode: carousel.data('center-mode-tablet'),
      		centerPadding: carousel.data('center-padding-tablet'),
            dots: carousel.data('dots-tablet'),
            initialSlide: carousel.data('initial-slide-tablet'),
            slidesToShow: carousel.data('slides-to-show-tablet'),
            slidesToScroll: carousel.data('slides-to-scroll-tablet'),
          }
        },
        {
          breakpoint: 499,
          settings: {
            autoplaySpeed: carousel.data('autoplay-speed-mobile'),
            arrows: carousel.data('arrows-mobile'),
      		centerMode: carousel.data('center-mode-mobile'),
      		centerPadding: carousel.data('center-padding-mobile'),
            dots: carousel.data('dots-mobile'),
            initialSlide: carousel.data('initial-slide-mobile'),
            slidesToShow: carousel.data('slides-to-show-mobile'),
            slidesToScroll: carousel.data('slides-to-scroll-mobile')
          }
        }
      ]
    });
    
    
    // Règle le bug qui empêche le paramètre 'slidesToScroll' de fonctionner quand le paramètre 'centerMode' est activé
    if(!modal) {
      if(window.innerWidth <= 499) {
        carousel.slick('slickSetOption', 'slidesToScroll', carousel.data('slides-to-scroll-mobile'), true);
      } else if(window.innerWidth > 499 && window.innerWidth <= 1024) {
        carousel.slick('slickSetOption', 'slidesToScroll', carousel.data('slides-to-scroll-tablet'), true);
      } else {
        carousel.slick('slickSetOption', 'slidesToScroll', carousel.data('slides-to-scroll-desktop'), true);
      }
    }
  }
  
  // Démarre les différents carousels
  function startCarousels(e, modal) {
    var carousels = $('.carousel:not(.slick-initialized)');

    carousels.each(function() {
      var carousel = $(this),
          carousel_activate_mobile = carousel.data('activate-mobile'),
          carousel_activate_tablet = carousel.data('activate-tablet'),
          carousel_activate_desktop = carousel.data('activate-desktop');         

      if(window.innerWidth < 500 && carousel_activate_mobile) {
        startCarousel(carousel, modal);
      } else if(window.innerWidth >= 500 && window.innerWidth <= 1024 && carousel_activate_tablet) {
        startCarousel(carousel, modal);
      } else if(window.innerWidth > 1024 && carousel_activate_desktop) {
        startCarousel(carousel, modal);
      }
    });
  }

  // Démarre le premier carousel challenges
  function startChallengesCarousel(e, modal) {
    var carousels = $('.carousel--products-select:not(.slick-initialized)');

    carousels.each(function() {
      var carousel = $(this),
          carousel_activate_mobile = carousel.data('activate-mobile'),
          carousel_activate_tablet = carousel.data('activate-tablet'),
          carousel_activate_desktop = carousel.data('activate-desktop');     

      if(window.innerWidth < 500 && carousel_activate_mobile) {
        startCarousel(carousel, modal);
      } else if(window.innerWidth >= 500 && window.innerWidth <= 1024 && carousel_activate_tablet) {
        startCarousel(carousel, modal);
      } else if(window.innerWidth > 1024 && carousel_activate_desktop) {
        startCarousel(carousel, modal);
      }
    });
  }
  
  // Anime les barres d'un carousel de comparaison de produit
  function animateProductCompareBars(nutrition_values, animate) {
    nutrition_values.each(function(){
      var $this = $(this),
          gauge_bar = $this.find('.gauge-bar').eq(0),
          nutrition_value = 0;

      if(animate) {
        nutrition_value = gauge_bar.data('width');
      }

      gauge_bar.animate({width: nutrition_value + '%'}, 1000);
    });
  }
  
  // Anime les carousels de comparaison de produit
  function startProductCompareBars(e, carousel, animate) {
    var compare_products_carousels = $('.carousel--products-compare');
    
    if(carousel != 'all') {
      compare_products_carousels = carousel;
    }
    
    compare_products_carousels.each(function() {
      var carousel = $(this),    
          carousel_cells = carousel.find('.carousel-cell'),
          current_slide = carousel.find('.carousel-cell.slick-current');          
      
      if(carousel_cells.length == 1) {
        current_slide = carousel_cells;
      }
      
      var nutrition_values = current_slide.find('.compare-nutrition');

      animateProductCompareBars(nutrition_values, animate);
    });
  }
  
  // Créé un countdown
  function createCountdown(countdown, countdown_date, expired_message, x) {
    var now = new Date().getTime(),
    	distance = countdown_date - now,
        days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000),
        countdown_text = days + window.languages.shortDay + " " + hours + window.languages.shortHour + " " + minutes + window.languages.shortMinute + " " + seconds + window.languages.shortSecond + " ";

    if(days == 0) {
      countdown_text = hours + window.languages.shortHour + " " + minutes + window.languages.shortMinute + " " + seconds + window.languages.shortSecond + " ";
    }
    
    countdown.text(countdown_text);

    // Si le countdown est fini, on affiche un message
    if (distance < 0) {
      clearInterval(x);
      countdown.text(expired_message);
    }
  }
  
  // Démarre les countdowns
  function startCountdowns(e) {
    var countdowns = $(".countdown");
    
    countdowns.each(function() {
      var countdown = $(this),
      	  date_value = countdown.data('date-value').split(','),
          year = parseInt(date_value[0]),
          month = parseInt(date_value[1]),
          day = parseInt(date_value[2]),
          hours = parseInt(date_value[3]),
          minutes = parseInt(date_value[4]),
          seconds = parseInt('0'),
          now = new Date();

      if(date_value[0] == '#') {
        year = parseInt(now.getFullYear());
      }

      if(date_value[1] == '#') {
        month = parseInt(now.getMonth());
      }

      if(date_value[2] == '#') {
        day = parseInt(now.getDate());
      }
      
      var countdown_date = new Date(year,month,day,hours,minutes,seconds).getTime(),
          expired_message = countdown.data('expired-message');

      // Créé un premier countdown
      createCountdown(countdown, countdown_date, expired_message, x);

      // Met à jour le countdown toutes les secondes
      var x = setInterval(function() {
        createCountdown(countdown, countdown_date, expired_message, x);
      }, 1000);
    });
  }
  
  // Lance le décompte des nombres dynamiques
  function startDynamicNumbers(e) {
    var scrolled = $window.scrollTop(),
    	dynamic_numbers = $('.dynamic-number:not(.animated)');
    
    dynamic_numbers.each(function() {      
      var $this = $(this),
          number_value_text = $this.text().replace(' ', '').replace(',', '').replace('.', ''),
          number_value = parseInt(number_value_text),
          section = $this.closest('.section'),
      	  off_set_top = section.offset().top,
          section_height = section.height();
      
      if(scrolled + win_height_padded > off_set_top && scrolled < off_set_top + section_height) {
        animateValue($this, e, 0, number_value, 2000);
        $this.addClass('animated');
      }
    });
  }

  // Vérifie si des blocs spacer du footer doivent disparaitre selon la taille de l'écran
  function checkFooter(e) {
    var footer = $('.section__page.footer'),
        footer_modules_spacer = footer.find('.footer__module--spacer');

    footer_modules_spacer.each(function() {
      var footer_module = $(this),
          span = footer_module.find('span');

      if(window.innerWidth < 500 && !span.data('show-mobile')) {
        footer_module.remove();
      }

      if(window.innerWidth >= 500 && window.innerWidth < 1025 && !span.data('show-tablet')) {
        footer_module.remove();
      }

      if(window.innerWidth >= 1025 && !span.data('show-desktop')) {
        footer_module.remove();
      }
    });
  }
  
  // Vérifie si le bandeau des cookies doit s'afficher
  function checkCookies(e) {
    var accept_cookies = window.localStorage.getItem('accept_cookies'),
        section = $('.shopify-section__cookies-bar');
    
    if(accept_cookies == null) {
      showBand(section);
    } else {
      hideBand(section);
    }
  }

  // Réactive les carousels qui étaient cachés
  function refreshCarousels(hidden_snippets) {
    hidden_snippets.each(function(index) {
      var hidden_snippet = $(this),
          carousel = hidden_snippet.find('.carousel.slick-initialized');

      if(carousel.length) {
        carousel.slick('refresh');
      }
    });
  }
  
  // Affiche les bons éléments sur la page panier
  function displayCartPage(e) {
    var sections_custom_section = $('.shopify-section__custom-section'),
        section_cart_items = $('.section__grid-cart-items');

    // Si le panier est vide
    if(section_cart_items.length == 0) {
      sections_custom_section.each(function(index) {
        var section_custom_section = $(this);

        if(index == 0) {
          var hidden_snippets = section_custom_section.find('.section__snippet[data-hide-on-load="true"]'),
              shown_snippets = section_custom_section.find('.section__snippet[data-hide-on-load="false"]'),
              carousels = $('.carousel');

          shown_snippets.remove();
          hidden_snippets.show();
          refreshCarousels(hidden_snippets);
        } else {
          section_custom_section.remove();
        }
      });
    // Si le panier n'est pas vide
    } else {        
      sections_custom_section.each(function(index) {
        var section_custom_section = $(this);

        if(index > 0) {            
          var hidden_snippets = section_custom_section.find('.section__snippet[data-hide-on-load="true"]');

          hidden_snippets.show();
          refreshCarousels(hidden_snippets);
        }
      });
    }
  }
  
  // Affiche les bons éléments sur le panier latéral
  function displayCartSidebar(e) {
    var section_cart_sidebar = $('.shopify-section__cart-sidebar'),
        section_cart_items = section_cart_sidebar.find('.section__grid-cart-items');

    // Si le panier est vide
    if(section_cart_items.length == 0) {
      var hidden_snippets = section_cart_sidebar.find('.section__snippet:not(.section__cart-reassurance):not(.section__carousel)[data-hide-on-load="true"]'),
          shown_snippets = section_cart_sidebar.find('.section__snippet[data-hide-on-load="false"]');

      shown_snippets.remove();
      hidden_snippets.show();
    // Si le panier n'est pas vide
    } else {
      var hidden_snippets = section_cart_sidebar.find('.section__snippet.section__cart-reassurance[data-hide-on-load="true"], .section__snippet.section__carousel[data-hide-on-load="true"]');

      hidden_snippets.show();
      startCarousels('', false);
      refreshCarousels(hidden_snippets);
    }
  }
  
  // Vérifie l'état du panier et son nombre d'items
  function checkCartState(e) {    
    if(isPage('/cart')) {
      displayCartPage(e);
    } else {
      displayCartSidebar(e);
    }
  }
  
  // Vérifie si un shaker payant est sans son challenge d'origine (#SoShape)
  function checkShakersWithoutChallenge(e) {
    var list_cart_items = $('.list-cart-items').eq(0),    
        items_shaker = list_cart_items.find('.item-cart[data-product-type="shaker"]'),
        items_challenge = list_cart_items.find('.item-cart[data-product-type="challenge"]');
      
    items_shaker.each(function(){
      var item_shaker = $(this),
          item_shaker_session_id = item_shaker.data('session-id'),
          item_shaker_key = item_shaker.data('cart-item-key'),
          item_to_delete = true;
      
      if(item_shaker_session_id != '') {
        items_challenge.each(function(){
          var item_challenge = $(this),
              item_challenge_session_id = item_challenge.data('session-id');
          
          if(item_shaker_session_id == item_challenge_session_id) {
            item_to_delete = false;
          }
        });
        
        if(item_to_delete) {
          changeCartItemQuantity(item_shaker, item_shaker_key, 0);
        }
      }
    });
  }

  // Supprime du carousel addons les éléments déjà présents dans le panier
  function checkAddonsContent(e) {
    if(isPage('/cart')) {
      var container = $('.main');
    } else {
      var container = $('.cart-sidebar');
    }
    
    $.getJSON(window.theme.localeRootUrl + '/cart.js').then(function(results) {
      var cart_items = results['items'];

      for(let i = 0; i < cart_items.length; i++) {
        var variant_id = cart_items[i].id,
            addon_item = container.find('.item-product-selector[data-item-style="selector"][data-variant-id="' + variant_id + '"]');
        
        if(addon_item.length) {
          var carousel = addon_item.closest('.carousel'),
              carousel_cell = addon_item.closest('.carousel-cell'),
              slide_index = carousel_cell.index(),
              style = carousel_cell.find('.carousel-cell--wrapper').next('style');

          if(style.length) {
            style.appendTo(carousel_cell.next().find('.carousel-cell--inner'));
          }

          if(carousel.hasClass('slick-initialized')) {
            carousel.slick('slickRemove', slide_index);
          } else {
            carousel_cell.remove();
          }

          // Si tous les addons ont été ajoutés, on supprime la section
          if(container.find('.item-product-selector[data-item-style="selector"]').length == 0) {            
            if(isPage('/cart')) {
              carousel.closest('.shopify-section__custom-section').remove();
            } else {
              carousel.closest('.grid__cell-snippet').prev().remove();
              carousel.closest('.grid__cell-snippet').remove();
            }
          }        
        }
      }
    });
  }
  
  // Vérifie le contenu du panier
  function checkCartContent(e) {
    checkCartState(e);
  	// checkShakersWithoutChallenge(e);
    checkAddonsContent(e);
  }

  // Gère l'affichage du sticky header
  function handleStickyHeader(e) {
    var sticky_header = $('.header-bar[data-sticky="all"]');

    if(window.innerWidth < 500) {
      sticky_header = $('.header-bar[data-sticky="all"], .header-bar[data-sticky="mobile"], .header-bar[data-sticky="portable"]');
    } else if(window.innerWidth < 1200) {
      sticky_header = $('.header-bar[data-sticky="all"], .header-bar[data-sticky="mobile"], .header-bar[data-sticky="portable"], .header-bar[data-sticky="tablet"], .header-bar[data-sticky="handheld-and-up"]');
    } else if(window.innerWidth >= 1201) {
      sticky_header = $('.header-bar[data-sticky="all"], .header-bar[data-sticky="handheld-and-up"], .header-bar[data-sticky="desktop"]');
    }

    if(sticky_header.length) {
      var shopify_section = sticky_header.closest('.shopify-section'),
          announcement_bar = $('#shopify-section-announcement-bar'),
          announcement_bar_height = announcement_bar.height();
      
      shopify_section.css('top', announcement_bar_height);
    }
  }

  // Gère l'url de la landing page
  function handleLandingPage(e) {
    var body = $('body');       

    // Sauvegarde l'url de la LP
    if(body.hasClass('template-index') || body.hasClass('template-page-lp')) {
      window.localStorage.setItem('landing_page', window.location.pathname);
    } else {
      if(window.localStorage.getItem('landing_page') == null) {
        window.localStorage.setItem('landing_page', '/');
      }
    }

    // Attribue l'url de la LP aux éléments nécessaires
    var logos = $('.logo').find('.logo__link'),        
        navigation_back = $('.navigation-back').find('.navigation-horizontal__list-link'),
        selector_step_previous = $('.selector-step--previous'),
        previous_button = selector_step_previous.find('.button'),
        pathname = window.localStorage.getItem('landing_page');
    
    logos.attr('href', pathname);

    if(navigation_back.attr('data-default-url') == 'false') {
      navigation_back.attr('href', pathname);

      // Attribue l'url de la collection pour les fiches produits
      if(body.hasClass('template-product-flavor')) {
        navigation_back.on('click', function(e) {
          e.preventDefault();
          history.back();
        });        
      }
      
      if(body.hasClass('template-product-omad')) {
        navigation_back.attr('href', '/pages/boost-remise-en-forme#section--nutrition');
      }
      
      if(body.hasClass('template-product-snack')) {
        navigation_back.attr('href', '/collections/healthy-snacks#section--routine');
      }

      if(body.hasClass('template-product-snack-mix')) {
        navigation_back.attr('href', '/collections/healthy-snacks#section--routine');
      }
  
      if(body.hasClass('template-product-walter')) {
        navigation_back.attr('href', '/collections/walter#section--routine');
      }
    }

    if(selector_step_previous.attr('data-default-url') == 'false') {
      previous_button.attr('href', pathname);
    }
  }

  // Ouvre le formulaire de contact
  function openContactForm(hash, search, section_to_scroll) {
  	var hash_value = hash.substring(1),
        section_id = '#' + section_to_scroll,
        section_class = '.' + section_to_scroll,
        section_page = $(section_class),
        contact_button = section_page.find('.button[data-action="show-hidden-blocks"]').first();

    if(section_to_scroll != '') {
      window.location.href = section_id;
    }

    if(contact_button.length) {
      contact_button[0].click();
    }
  }

  // Ouvre une catégorie
  function openCategory(hash, search, section_to_scroll) {
  	var hash_value = hash.substring(1),
        section_id = '#' + section_to_scroll,
        section_class = '.' + section_to_scroll,
        section_page = $(section_class),
        category_title = $('.category-title[data-category-handle="' + hash_value + '"]');

    if(section_to_scroll != '') {
      window.location.href = section_id;
    }

    if(category_title.length) {
      category_title.click();
    }
  }

  // Traite les paramètres dans l'url pour effectuer des actions spécifiques au load
  function handleUrlParameters(e) {
    var pathname = window.location.pathname,
        hash = window.location.hash,
        search = window.location.search;
    
    if(hash != "") {
      switch (hash) {
        case '#contact':
          openContactForm(hash, search, 'section--contact-form');
          break;
        case '#questions-frequentes': // FR
        case '#commande-livraison':
        case '#challenges-minceur':
        case '#snacks-brkfst':
        case '#mini-mix-walter':
        case '#my-routine-nutrition':
        case '#livret-so-shape':
        case '#domande-frequenti': // IT
        case '#ordini-consegne':
          openCategory(hash, search, 'section--faq');
        case '#mes-commandes': // FR
        case '#mes-abonnements':
        case '#mes-informations':
        case '#aide-pour-mon-challenge':
        case '#programme-de-parrainage':
        case '#i-miei-ordini': // IT
        case '#i-miei-dati':
        case '#aiuto-per-br-il-mio-challenge':
          openCategory(hash, search, 'section--customer-account');
          break;
        default:          
      }
    }
    
    if(search != "") {
      switch (search) {
        case '?contact_posted=true':
          openContactForm(hash, search, 'section--contact-form');
          break;
        default:          
      }
    }

    if(hash === '#recover' || window.recoverPassword === true) {
      $('[data-action="toggle-recover-form"]').trigger('click');
    }
  }
  
  // Ouvre les sidebars
  function openSidebars(e) {
  	var sidebars = $('.sidebar[data-sidebar-open="true"]');

    sidebars.each(function() {
      var sidebar = $(this),  
          sidebar_class = sidebar.attr('class').split(' ').pop(),
          trigger_selector = '[data-action="open-' + sidebar_class + '"]',
          trigger = $(trigger_selector).eq(0);

      trigger.trigger('click');
    });
  }
  
  // Au load d'une page
  function _loadListener(e) {
    // En priorité
    if(isPage('/collections/challenges')) {
      startChallengesCarousel(e, false);
    }
    displayAnnouncementBars(e);
    startCountdowns(e); 
    checkCookies(e);
    handleStickyHeader(e);
    handleLandingPage(e);
    handleUrlParameters(e);

    // Ensuite
    startCarousels(e, false);    
    startDynamicNumbers(e);
    startProductCompareBars(e, 'all', true);
    checkCartContent(e);
    checkFooter(e);        
    openSidebars(e);
  }
  
  // Au load d'une page
  $window.on('load', function(e) {
    _loadListener(e);
  });
  
  /**
   * ON SCROLL
   */

  // Gère l'affichage du toggle header
  function handleToggleHeader(e) {
    var toggle_header = $('.header-bar[data-toggle-scroll="all"]');

    if(window.innerWidth < 500) {
      toggle_header = $('.header-bar[data-toggle-scroll="all"], .header-bar[data-toggle-scroll="mobile"], .header-bar[data-toggle-scroll="portable"]');
    } else if(window.innerWidth < 1200) {
      toggle_header = $('.header-bar[data-toggle-scroll="all"], .header-bar[data-toggle-scroll="mobile"], .header-bar[data-toggle-scroll="portable"], .header-bar[data-toggle-scroll="tablet"], .header-bar[data-toggle-scroll="handheld-and-up"]');
    } else if(window.innerWidth >= 1201) {
      toggle_header = $('.header-bar[data-toggle-scroll="all"], .header-bar[data-toggle-scroll="handheld-and-up"], .header-bar[data-toggle-scroll="desktop"]');
    }

    if(toggle_header.length) {
      var shopify_section = toggle_header.closest('.shopify-section'),
          vertical_scroll_direction = getVerticalScrollDirection(),
          scrolled = $window.scrollTop();    
      
      if(vertical_scroll_direction == 'down') { 
        if(scrolled > 0) {
          toggle_header.addClass('is-sticky');
        }
        
        if(scrolled >= 250 && has_faded === 0) {
          shopify_section.stop().fadeOut('normal');
          has_faded = 1;
        }
  
        position = scrolled;        
      } else if(vertical_scroll_direction == 'up') {  
        if(scrolled == 0) {
          toggle_header.removeClass('is-sticky');
        }
        
        if(has_faded === 1) {
          shopify_section.stop().fadeIn('normal');
          has_faded = 0;
        }
  
        position = scrolled;        
      }
    }
  }
  
  // Lance les vidéos
  function startVideos(e) {
    var scrolled = $window.scrollTop(),
        videos_wrappers = '';
    
    if(window.innerWidth < 500) {
      videos_wrappers = $('.video-wrapper--file.hidden-handheld-and-up');
    } else {
      videos_wrappers = $('.video-wrapper--file.hidden-thumb');
    }
    
    videos_wrappers = videos_wrappers.add('.video-wrapper--file.all');
    
    videos_wrappers.each(function() {
      var video_wrapper = $(this),
          video_tag = video_wrapper.find('[data-play-scroll="true"]');
      
      if(video_tag.length) {
      	var video = video_tag.get(0),
            video_button = video_wrapper.find('button'),
            off_set_top = video_tag.offset().top,
            video_height = video_tag.height();

        if(scrolled + win_height_padded > off_set_top && scrolled < off_set_top + video_height) {
          if(video.paused) {
            video_button.removeClass('active');
            video.play().catch(function(error) {
              video_button.addClass('active');
            }); 
            
            if(video_tag.attr('data-unmute-scroll') == "true") {
              video.muted = false;
            }
          }
        } else {
          if(!video.paused) {
            video.pause();
            video.muted = true;
          }
        }
      }
    });
  }

  // Charge le widget de chat
  function loadChatWidget(e) {
    var chat_widget = $('#gorgias-chat-widget-install-v2');

    if(chat_widget.length == 0) {
      var body = $('body'),
          chat_widget_html_1 = '<script id="gorgias-chat-widget-install-v2" src="https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=1881" defer></script>',
          chat_widget_html_2 = '<script type="module" id="gorgias-chat-shopify-install">!function(_){_.SHOPIFY_PERMANENT_DOMAIN="",_.SHOPIFY_CUSTOMER_ID="",_.SHOPIFY_CUSTOMER_EMAIL=""}(window||{});</script>',
          chat_widget_html_3 = '<script type="module">GorgiasChat.init().then(function(){GorgiasChat.hidePoweredBy(true),GorgiasChat.setCustomBusinessHours({timezone:"Europe/Paris",businessHours:[{days:[1,2,3,4,5],fromTime:"9:30",toTime:"13:00"},{days:[1,2,3,4,5],fromTime:"14:00",toTime:"18:00"}]});</script>';
          
      body.append(chat_widget_html_1);
      body.append(chat_widget_html_2);
      body.append(chat_widget_html_3);
    }
  }
  
  // Au scroll d'une page
  function _scrollListener(e) {
    handleToggleHeader(e);
    startDynamicNumbers(e);
    startVideos(e);
    //loadChatWidget(e);
  }
  
  // Au scroll d'une page
  $window.on('scroll', function(e) {
    _scrollListener(e);
  });
  
  /**
   * ANIMATIONS
   */
  
  // Change le logo au hover
  function changeLogoHover($this, event) {
    // Uniquement sur desktop
    if(window.innerWidth >= 1025) {
      var logo_main = $this.find('.logo-main'),
          logo_hover = $this.find('.logo-hover');

      if(logo_hover.length) {
        logo_main.toggleClass('hidden');
        logo_hover.toggleClass('hidden');
      }
    }
  }
  
  // Au hover sur un logo So Shape
  function _hoverLogoListener($this, e) {
    changeLogoHover($this, e);
  }
  
  // Quand la souris entre sur un logo So Shape
  $(document).on('mouseenter', '.logo-wrapper', function(e) {
    _hoverLogoListener($(this), e);
  });
  
  // Quand la souris sort d'un logo So Shape
  $(document).on('mouseleave', '.logo-wrapper', function(e) {
    _hoverLogoListener($(this), e);
  });
  
  // Ouvre ou ferme le contenu d'un item dépliant
  function toggleCollapsibleContent($this, event) {
    var collapsible = $this.closest('.collapsible'),
        collapsible_content = collapsible.find('.collapsible-content');    
    
    collapsible_content.slideToggle(250);
    collapsible.toggleClass('opened');
  }
  
  // Au clic sur un volet dépliant
  function _clickCollapsibleHeaderListener($this, e) {
    toggleCollapsibleContent($this, e);
  }
  
  // Au clic sur un volet dépliant
  $(document).on('click', '.collapsible .collapsible-header', function(e) {
    _clickCollapsibleHeaderListener($(this), e);
  });
  
  /**
   * MODALS
   */
  
  // Ouvre une modal
  function openModal($this, e) {
    var modal_id = $this.data('modal-id');
    
    if(!modal_id) {
      modal_id = $this.parent().data('modal-id');
    }
    
    var modal_instance = $('#' + modal_id).remodal({});
    
    if (modal_instance) {
      modal_instance.open();
      
      if(e != null) {
        e.preventDefault();
      }
    }
  }
  
  // Ouvre une modal avec un id en paramètre
  function openModalWithId(modal_id, e) {
    var modal_instance = $('#' + modal_id).remodal({});
    
    if (modal_instance) {
      modal_instance.open();
      
      if(e != null) {
        e.preventDefault();
      }
    }
  }
  
  // Ferme une modal
  function closeModal($this, e) {
    var modal = $this.closest('.modal'),
        modal_instance = modal.remodal({});
    
  	if (modal_instance) {
      modal_instance.close();
      
      if(e != null) {
        e.preventDefault();
      }
    }
  }
  
  // Ferme une modal avec un id en paramètre
  function closeModalWithId(modal_id, e) {
    var modal_instance = $('#' + modal_id).remodal({});
    
    if (modal_instance) {
      modal_instance.close();
      
      if(e != null) {
        e.preventDefault();
      }
    }
  }
  
  // Au clic sur un lien qui ouvre une modal
  function _clickOpenModalListener($this, e) {
    openModal($this, e);
  }
  
  // Au clic sur un lien qui ouvre une modal dont on a specifié l'id
  function _clickOpenModalWithIdListener($this, e) {
    var action_attribute = $this.attr('data-action'),
    	modal_id = 'modal-' + action_attribute.split('open-modal-with-id-').pop();
    
    openModalWithId(modal_id, e);
  }
  
  // Au clic sur un lien qui ferme une modal
  function _clickCloseModalListener($this, e) {
    closeModal($this, e);
  }
  
  // Au clic sur un lien qui ferme une modal dont on a specifié l'id
  function _clickCloseModalWithIdListener($this, e) {
    var action_attribute = $this.attr('data-action'),
    	modal_id = 'modal-' + action_attribute.split('close-modal-with-id-').pop();
    
    closeModalWithId(modal_id, e);
  }
  
  // Au clic sur un lien qui ouvre une modal
  $(document).on('click', '[data-action="open-modal"]', function(e) {
    _clickOpenModalListener($(this), e);
  });
  
  // Au clic sur un lien qui ouvre une modal dont on a specifié l'id
  $(document).on('click', '[data-action^="open-modal-with-id"]', function(e) {
    _clickOpenModalWithIdListener($(this), e);
  });
  
  // Au clic sur un lien qui ferme une modal
  $(document).on('click', '[data-action="close-modal"]', function(e) {
    _clickCloseModalListener($(this), e);
  });
  
  // Au clic sur un lien qui ferme une modal dont on a specifié l'id
  $(document).on('click', '[data-action^="close-modal-with-id"]', function(e) {
    _clickCloseModalWithIdListener($(this), e);
  });
  
  /**
   * SELECTOR
   */
  
  // Vérifie si l'étape des saveurs est complète (#SoShape)
  function flavorsSelectionComplete($this) {
    var section_page_flavors = $('.section__page[data-page-handle="flavors"]'),
        selector_step_progression_wrapper = $('.selector-step-progression-wrapper').eq(0),
        selector_step_progression = selector_step_progression_wrapper.find('.selector-step-progression').eq(0),
        nb_meals = parseInt(selector_step_progression.attr('data-nb-meals')),
        nb_items_selected = parseInt(selector_step_progression.attr('data-nb-items-selected')),
        nb_items_max = parseInt(selector_step_progression.attr('data-nb-items-max')),
        selected_progression_items = selector_step_progression_wrapper.find('.step-progression-item.selected'),
        nb_selected_progression_items = selected_progression_items.length,
        selected_progression_items_with_sku = selector_step_progression_wrapper.find('.step-progression-item.selected[data-variant-sku]:not([data-variant-sku=""])'),
        nb_selected_progression_items_with_sku = selected_progression_items_with_sku.length;

    if (section_page_flavors.length == 0) {
      return true;
    }
    
  	// Si le nombre d'items sélectionnés est égal (ou supérieur) au nombre maximums d'items sélectionnable
    // ET que le nombre de progression item sélectionné est égal (ou supérieur) au nombre maximums d'items sélectionnable
    // ET que chaque progression item a bien une valeur de SKU
    if(nb_items_selected >= nb_meals && nb_selected_progression_items >= nb_items_max && nb_selected_progression_items_with_sku >= nb_items_max) {
      return true;
    } else {
      return false;
    }
  }
  
  // Vérifie si l'étape des shakers est complète (#SoShape)
  function shakersSelectionComplete($this) {
    var section_page_shakers = $('.section__page[data-page-handle="shakers"]'),
        items_product = section_page_shakers.find('.item-product.selected');

    const shakersSelected = section_page_shakers.find('.elkad-item-product-selector--selected');

    if (section_page_shakers.length == 0) {
      return true;
    }

    if((items_product.length > 0 || shakersSelected.length > 0) || section_page_shakers.length == 0) {
      return true;
    } else {
      return false;
    }
  }
  
  // Vérifie si toutes les étapes du sélecteur sont complètes (#SoShape)
  function selectionComplete($this) {
    if(flavorsSelectionComplete($this) && shakersSelectionComplete($this)) {
      return true;
    } else {
      return false;
    }
  }
  
  // Affiche un message d'erreur (#SoShape)
  function showErrorsMessage($this) {
    $this.removeAttr('disabled');
    $this.find('span').text($this.data('button-text'));

    if(!flavorsSelectionComplete($this) && !isPage('/products/challenge-')) {
      $this.attr('disabled', 'disabled');
    }
    
  	if(!flavorsSelectionComplete($this) && !shakersSelectionComplete($this) && isPage('/products/challenge-')) {
      alert(window.languages.alertFlavorsShaker);
    } else if(!flavorsSelectionComplete($this)) {
      alert(window.languages.alertFlavors);
    } else if(!shakersSelectionComplete($this)) {
      alert(window.languages.alertShaker);
    } else {

    }
  }
  
  /**
   * ADD TO CART
   */

  // Réinitialise la sélection effectuée
  function reinitSelection($this) {
    var section_page  = $this.closest('.section__page'),
        selector_step_progressions = $('.selector-step-progression'), 
        selector_summaries = $('.selector-summary'),
        nb_items_selected_texts = $('.nb-items-selected');

    // Selector step progression
    selector_step_progressions.each(function() {
      var selector_step_progression = $(this);
      
      selector_step_progression.find('.step-progression-item').each(function() {
        var slot = $(this);

        // Retire la couleur et les attributs d'un item de progression
        slot.removeClass('selected');
        slot.css('background', selector_step_progression.data('color-bg'));
        slot.removeAttr('data-product-handle');
        slot.removeAttr('data-variant-id');
        slot.removeAttr('data-variant-sku');
        slot.removeAttr('data-product-title');
      });
      
	  // Met à jour le nombre d'item sélectionnés
      selector_step_progression.data('nb-items-selected', 0); 
      selector_step_progression.attr('data-nb-items-selected', 0);
    });

    // Selector summaries
    selector_summaries.each(function() {
      var selector_summary = $(this);
             
      selector_summary.find('.summary-item').remove();
      selector_summary.closest('.section__snippet').attr('data-hide-on-load', true);

      // Met à jour le nombre d'item sélectionnés
      selector_summary.data('nb-items-selected', 0); 
      selector_summary.attr('data-nb-items-selected', 0);
    });   

    // Nb items selected
    nb_items_selected_texts.each(function() {
      var nb_items_selected_text = $(this);

      nb_items_selected_text.text('0');
      nb_items_selected_text.closest('.section__snippet').attr('data-hide-on-load', true);
    });
  }
  
  // Choisit quelles actions effectuer après un ajout au panier
  function handleAddToCartResult(add_to_cart_button, result) {
    var redirect_action = add_to_cart_button.attr('data-redirect-action'),
    	redirect_url = add_to_cart_button.attr('data-redirect-url');

    if(!isPage('/products/challenge-')) {
      reinitSelection(add_to_cart_button);
    }

    if(add_to_cart_button.data('action') != 'add-to-cart-products-list' && add_to_cart_button.attr('data-disabled') == 'false') {
      add_to_cart_button.removeAttr('disabled');
    }

    if(redirect_action == 'message') {
      add_to_cart_button.find('span.button-text').html(window.languages.addedToCartButton);

      // On restaure le message original du bouton après 2 secondes
      setTimeout(function() {
        add_to_cart_button.find('span.button-text').html(add_to_cart_button.data('button-text'));
        add_to_cart_button.find('span.button-price').removeClass('hidden');
      }, 2000);

      // On diffuse un événement pour que le panier latéral puisse effectuer des traitements supplémentaires, comme le réaffichage du panier latéral
      $(document).trigger('product.added.message');
    } else if(redirect_action == 'drawer') {
      add_to_cart_button.find('span.button-text').html(add_to_cart_button.data('button-text'));
      add_to_cart_button.find('span.button-price').removeClass('hidden');

      // On ferme le quick shop si une popup est ouverte
      if(window.quickShopRemodalInstance) {
        window.quickShopRemodalInstance.close();
      }

      // On diffuse un événement pour que le panier latéral puisse effectuer des traitements supplémentaires, comme le réaffichage du panier latéral
      $(document).trigger('product.added.drawer');
    } else if(redirect_action == 'page') {
      add_to_cart_button.find('span.button-text').html(add_to_cart_button.data('button-text'));
      window.location.href = redirect_url;
    } else if(redirect_action == 'checkout') {
      add_to_cart_button.find('span.button-text').html(add_to_cart_button.data('button-text'));
      window.location.href = '/checkout';
    } else {

    }
  }
  
  // Gère les actions à effectuer s'il y a une erreur après un ajout au panier
  function handleAddToCartError(add_to_cart_button, error) {
    var error_message = error.responseJSON.description;

    add_to_cart_button.find('span').text(error_message);

    // We restore original button message after 2 seconds
    setTimeout(function() {
      add_to_cart_button.find('span').text(add_to_cart_button.data('button-text'));
      add_to_cart_button.removeAttr('disabled');
    }, 2000);
  }
  
  // Pousse la file d'attente au panier
  Shopify.moveAlong = function(add_to_cart_button, updateDrawer = false) {
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift(),
          data = {};

      if(request.properties && request.selling_plan != 0) {
        data = {
          id: request.variantId,
          quantity: request.quantity,
          properties: request.properties,
          selling_plan: request.selling_plan
        };
      } else if(request.properties) {
        data = {
          id: request.variantId,
          quantity: request.quantity,
          properties: request.properties
        };
      } else if(request.selling_plan != 0) {
        data = {
          id: request.variantId,
          quantity: request.quantity,
          selling_plan: request.selling_plan
        };
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function(response) {
          if (Shopify.queue.length){
            Shopify.moveAlong(add_to_cart_button, updateDrawer);
          } else {
            if (add_to_cart_button instanceof jQuery) {
			        handleAddToCartResult(add_to_cart_button, response);
            }

            if (updateDrawer) {
              $(document).trigger('product.added.drawer');

              // Create custom event
              const event = new CustomEvent('queue.done', {
                detail: {
                  add_to_cart_button: add_to_cart_button
                }
              });

              // Dispatch the event
              document.dispatchEvent(event);
            } else {
              const event = new CustomEvent('product.added.no_cart_drawer');

              // Dispatch the event
              document.dispatchEvent(event);
            }
          }  
        },
        error: function(response) {
          if (add_to_cart_button instanceof jQuery) {
            handleAddToCartError(add_to_cart_button, response);
          }

          // Si ce n'est pas le dernier, on rappelle la fonction Move Along
          if (Shopify.queue.length){
            Shopify.moveAlong(add_to_cart_button, updateDrawer);
          }
        }
      });
    } else {
      if (add_to_cart_button instanceof jQuery) {
        handleAddToCartResult(add_to_cart_button, '');
      }

      if (updateDrawer) {
        $(document).trigger('product.added.drawer');
      }
    }
  };

  // Réinitialise le sélecteur de quantité
  function reinitQuantitySelector(element) {
    var quantity_wrapper = element.find('.product__quantity-wrapper'),
        quantity_sub = quantity_wrapper.find('.button--quantity-sub'),
        quantity_add = quantity_wrapper.find('.button--quantity-add'),
        quantity = quantity_wrapper.find('.product__quantity-value'),
        quantity_min = parseInt(quantity_wrapper.data('min')),
        quantity_initial_value = parseInt(quantity_wrapper.data('initial-value'));
      
    quantity.text(quantity_initial_value);
    quantity.val(quantity_initial_value);

    if(quantity_sub.length && quantity_initial_value <= quantity_min) {
      quantity_sub.attr('disabled', 'disabled');
    }  

    if(quantity_add.length) {
      quantity_add.removeAttr('disabled');
    }
  }
  
  // Ajoute une variante à la file d'attente
  function addVariantToQueue(id, quantity, properties, selling_plan){    
    Shopify.queue.push({
      variantId: id,
      quantity: quantity,
      properties: properties,
      selling_plan: selling_plan
    });
  }
  
  // Ajoute une variante au panier
  function addVariantToCart(add_to_cart_button, id, quantity, properties, selling_plan) {
    Shopify.queue = [];
    
    addVariantToQueue(id, quantity, properties, selling_plan);
    
    Shopify.moveAlong(add_to_cart_button);
  }
  
  // Ajoute une variante d'un challenge au panier
  function addVariantChallengeToCart(add_to_cart_button, item_product) {
  	Shopify.queue = [];
    
    var id = item_product.data('variant-id'),
        quantity = 1,
        properties = new Object(),
        selling_plan = 0;
    
    // On ajoute les properties liées aux saveurs sélectionnées
    var default_flavors = item_product.data('default-flavors-sku'),
        default_flavors_split = default_flavors.split(',');
    
    if(default_flavors != '') {
      for (var i = 0; i < default_flavors_split.length; i++) {
        var default_flavor = default_flavors_split[i],
            default_flavor_split = default_flavor.split('-'),
            flavor_sku = default_flavor_split[0],
            flavor_quantity = parseInt(default_flavor_split[1]);

        properties[flavor_sku] = flavor_quantity;
      }
    }
    
    // On ajoute la property liée au shaker par défaut
    var shaker_sku = item_product.data('default-shaker-sku');

    if(shaker_sku != '') {
      properties[shaker_sku] = 1;
    }
        
    addVariantToQueue(id, quantity, properties, selling_plan);
    
    Shopify.moveAlong(add_to_cart_button);
  }
  
  // Ajoute des variantes au panier
  function addVariantsToCart(add_to_cart_button, product_lists) {    
    Shopify.queue = [];   
    
    var nb_products_selected = 0,    
        product_form = add_to_cart_button.closest('.product__form');
    
    product_lists.each(function() {
      var product_list = $(this),
          items_product = product_list.find('.item-product');
      
      items_product.each(function() {
        var item_product = $(this),
            item_product_quantity_wrapper = item_product.find('.product__quantity-wrapper'),
            item_product_quantity = item_product_quantity_wrapper.find('.product__quantity-value'),
            id = item_product.data('variant-id'),
            quantity = parseInt(item_product_quantity.text()),
            properties = new Object(),
            selling_plan = parseInt(product_form.find('input[name="selling_plan"]').val());
        
        if(isNaN(quantity)) {
          quantity = parseInt(item_product_quantity.val());
        }

        if(isNaN(quantity) && item_product.hasClass('selected')) {
          quantity = 1;
          //selling_plan = 0;
        }

        if(isNaN(selling_plan)) {
          selling_plan = 0;
        }
        
        nb_products_selected += quantity;
        
        if($.isNumeric(quantity) && quantity > 0 && nb_products_selected <= 100) {
          addVariantToQueue(id, quantity, properties, selling_plan);
        }

        // On remet le sélecteur de quantité à sa valeur de départ
        reinitQuantitySelector(item_product);       
      });
    });    
    
    Shopify.moveAlong(add_to_cart_button);
  }

  // Ajoute des variantes en tant que properties d'un challenge au panier
  function addVariantsChallengeToCart(add_to_cart_button, product_lists) {    
    if(flavorsSelectionComplete(add_to_cart_button)) {
      Shopify.queue = [];   
      
      var product_form = add_to_cart_button.closest('.product__form');
  
      if(product_form.length == 0) {
        product_form = add_to_cart_button.closest('.section__page').find('.product__form');
      }
      
      var id = parseInt(product_form.find('.product__variants').find('input[name="id"]').val()),
          quantity = 1,
          properties = new Object(),
          selling_plan = parseInt(product_form.find('input[name="selling_plan"]').val()); 
  
      if(isNaN(selling_plan)) {
        selling_plan = 0;
      }

      // On sauvegarde le nom du bundle pour #Smartrr
      if(selling_plan != 0) {
        var bundle = SmartrrBundleInformation;

        if(typeof bundle !== 'undefined') {
          var bundle_info = {
              items: [],
              date: new Date().getTime(),
              page: window.location.toString(),
              bundle: {
                name: bundle.name,
                slug: bundle.slug
              }
            };
          
          properties["Bundle"] = bundle.name;
        }
      }
      
      product_lists.each(function() {
        var product_list = $(this),
            items_product = product_list.find('.item-product');
        
        items_product.each(function() {
          var item_product = $(this),
              item_product_quantity_wrapper = item_product.find('.product__quantity-wrapper'),
              item_product_quantity = item_product_quantity_wrapper.find('.product__quantity-value'),
              id = item_product.data('variant-id'),
              sku = item_product.data('variant-sku'),
              item_quantity = parseInt(item_product_quantity.text());
          
          if(isNaN(item_quantity)) {
            item_quantity = parseInt(item_product_quantity.val());
          }
          
          if($.isNumeric(item_quantity) && item_quantity > 0) {
            properties[sku] = item_quantity;

            // On sauvegarde le contenu du bundle pour #Smartrr
            if(typeof bundle_info !== 'undefined') {
              bundle_info.items.push({
                id: id,
                quantity: item_quantity,
                selling_plan: selling_plan,
              });
            }
          }
  
          // On remet le sélecteur de quantité à sa valeur de départ
          reinitQuantitySelector(item_product);  
        });
      }); 
  
      // On ajoute la property liée au shaker par défaut
      var shaker_sku = product_form.find('input[name="default_shaker_sku"]').val();
  
      if(shaker_sku != '') {
        properties[shaker_sku] = 1;
      }

      // On sauvegarde le nom du bundle pour #Smartrr
      if(typeof bundle_info !== 'undefined') {
        properties["_smartrr_info"] = JSON.stringify(bundle_info);
      }
  
      addVariantToQueue(id, quantity, properties, selling_plan);
      
      Shopify.moveAlong(add_to_cart_button);
    } else {
      showErrorsMessage(add_to_cart_button);
    }
  }
  
  // Ajoute les addons du sélecteur au panier (#SoShape) == EDIT ELKAD
  function addAddonsToQueue(timestamp) {
    var section_page_addons = $('.section__page[data-page-handle="addons"]'),
        items_product = section_page_addons.find('.item-product.selected, .elkad-item-product-selector--selected'),
        nb_products_selected = 0,
        selling_plan = 0;
    
    if(items_product.length) {
      var items_product_reverse_list = items_product.get().reverse(),
          items_product_reverse = $(items_product_reverse_list);

      items_product_reverse.each(function() {
        var item_product = $(this),
            item_product_quantity_wrapper = item_product.find('.product__quantity-wrapper'),
            item_product_quantity = item_product.find(".elkad-quick-add-to-cart__input").length > 0 ? item_product.find(".elkad-quick-add-to-cart__input") : item_product_quantity_wrapper.find('.product__quantity-value'),
            id = item_product.data('variant-id'),
            quantity = parseInt(item_product_quantity.text()),
            properties = new Object();

        if(isNaN(quantity)) {
          quantity = parseInt(item_product_quantity.val());
        }

        nb_products_selected += quantity;

        if($.isNumeric(quantity) && quantity > 0 && nb_products_selected < 99) {
          addVariantToQueue(id, quantity, properties, selling_plan);
        }

        // On remet le sélecteur de quantité à sa valeur de départ
        reinitQuantitySelector(item_product);
      });
    }
  }
  
  // Ajoute le shaker du sélecteur au panier (#SoShape) == EDIT ELKAD
  function addShakerToQueue(timestamp) {
    var section_page_shakers = $('.section__page[data-page-handle="shakers"]'),
        items_product = section_page_shakers.find('.item-product.selected, .elkad-item-product-selector--selected'),
        selling_plan = 0;
    
    items_product.each(function() {
      var item_product = $(this),
          price = item_product.data('variant-price'),
          id = item_product.data('variant-id'),
          quantity = 1,
          properties = new Object();

      if(price > 990) {
        properties['id'] = timestamp;
        
        addVariantToQueue(id, quantity, properties, selling_plan);
      }
    });
  }
  
  // Ajoute le challenge du sélecteur au panier (#SoShape) == EDIT ELKAD
  function addChallengeToQueue(timestamp) {
    var section_page_flavors = $('.section__page[data-page-handle="flavors"]'),
        section_page_shakers = $('.section__page[data-page-handle="shakers"]'),
        item_variant = section_page_flavors.find('.item-variant.selected'),
        step = parseInt(item_variant.data('step')),
        items_progression = $('.selector-step-progression-wrapper').eq(0).find('.step-progression-item.selected'),
        items_shaker = section_page_shakers.find('.item-product.selected, .elkad-item-product-selector--selected');
        
    if(item_variant.length) {
      var id = item_variant.data('variant-id'),
          quantity = 1,
          properties = new Object(),
          selling_plan = 0;
      
      properties['id'] = timestamp;

      // On ajoute les properties liées aux saveurs sélectionnées
      items_progression.each(function() {
        var item_progression = $(this),
            sku = item_progression.data('variant-sku');

        // Si cette saveur n'est pas déjà dans les properties, on ajoute seulement la valeur "step"
        if(properties[sku] == null) { 
          properties[sku] = step;
        } else { // Sinon, on augmente sa quantité par le montant choisi de cette saveur
          properties[sku] = properties[sku] + step;
        }        
      });
      
      if(items_shaker.length) {
        // On ajoute la property liée au shaker sélectionné, s'il est gratuit
        items_shaker.each(function() {
          var item_shaker = $(this),
              sku = item_shaker.data('variant-sku'),
              price = item_shaker.data('variant-price');

          if(price <= 990) {
            properties[sku] = 1;
          }       
        });
      } else {
        // On ajoute la property liée au shaker par défaut
        var sku = item_variant.data('default-shaker-sku');
        
        properties[sku] = 1;
      }
        
      addVariantToQueue(id, quantity, properties, selling_plan);
    }
  }
  
  // Ajoute un challenge du sélecteur au panier (#SoShape) == EDIT ELKAD
  function addSelectorToCart(add_to_cart_button) {
    if(selectionComplete(add_to_cart_button)) {
      var timestamp = $.now(); // On sauvegarde un timestamp pour associer un ajout au panier à une session de personnalisation

      Shopify.queue = [];

      addAddonsToQueue(timestamp); 
      addShakerToQueue(timestamp); 
      addChallengeToQueue(timestamp);

      Shopify.moveAlong(add_to_cart_button);
    } else {
      showErrorsMessage(add_to_cart_button);
    }
  }
  
  // Ajoute un produit au panier depuis le product form
  function addToCartFromProductForm($this) {
    var product_form = $this.closest('.product__form'),
        product_form_quantity_wrapper = product_form.find('.product__quantity-wrapper'),
        product_form_quantity = product_form_quantity_wrapper.find('.product__quantity-value'),
        add_to_cart_button = product_form.find('.product__add-to-cart'),
    	id = add_to_cart_button.data('variant-id'),
    	quantity = parseInt(product_form_quantity.text()),
    	properties = new Object(),
        selling_plan = parseInt(product_form.find('input[name="selling_plan"]').val());
    
    if(isNaN(quantity)) {
      quantity = parseInt(product_form_quantity.val());
    }

    if(isNaN(selling_plan)) {
      selling_plan = 0;
    }
    
    add_to_cart_button.find('span.button-text').text(window.languages.addingToCartButton);
    add_to_cart_button.find('span.button-price').addClass('hidden');
    add_to_cart_button.attr('disabled', 'disabled');
    
    addVariantToCart(add_to_cart_button, id, quantity, properties, selling_plan);

    // On remet le sélecteur de quantité à sa valeur de départ
    setTimeout(function(){
      reinitQuantitySelector(product_form);
    }, 3000);
  }
  
  // Ajoute un produit au panier depuis un product item
  function addToCartFromProductItem($this) {
    var item_product = $this.closest('.item-product'),
        add_to_cart_button = item_product.find('.product__button').find('.button'),
    	id = item_product.data('variant-id'),
    	quantity = 1,
    	properties = new Object(),
        selling_plan = 0;
    
    add_to_cart_button.find('span.button-text').text(window.languages.addingToCartButton);
    add_to_cart_button.find('span.button-price').addClass('hidden');
    add_to_cart_button.attr('disabled', 'disabled');
    
    addVariantToCart(add_to_cart_button, id, quantity, properties, selling_plan);
  }
  
  // Ajoute un produit au panier depuis un product item de type challenge (#SoShape)
  function addToCartFromProductItemChallenge($this) {
    var item_product = $this.closest('.item-product'),
        add_to_cart_button = item_product.find('.product__button').find('.button');
    
    add_to_cart_button.find('span.button-text').text(window.languages.addingToCartButton);
    add_to_cart_button.find('span.button-price').addClass('hidden');
    add_to_cart_button.attr('disabled', 'disabled');
    
    addVariantChallengeToCart(add_to_cart_button, item_product);
  }
  
  // Ajoute des produits au panier depuis une liste de produits
  function addToCartFromProductsList($this) {
    var section_column = $this.closest('.section-column'),
        product_lists = section_column.find('.carousel--products'),
        add_to_cart_button = $this;
    
    if(product_lists.length == 0) {
      product_lists = section_column.find('.grid__products');
    }
    
    add_to_cart_button.find('span.button-text').text(window.languages.addingToCartButton);
    add_to_cart_button.find('span.button-price').addClass('hidden');
    add_to_cart_button.attr('disabled', 'disabled');
    
    addVariantsToCart(add_to_cart_button, product_lists);
  }

  // Ajoute des produits au panier depuis le sélecteur de produits
  function addToCartFromSelectorProducts($this) {
    var main = $this.closest('.main'),
        product_lists = main.find('.carousel--products:not(.carousel--products-compare)'),
        add_to_cart_button = $this;
    
    if(product_lists.length == 0) {
      product_lists = main.find('.grid__products');
    }
    
    add_to_cart_button.find('span.button-text').text(window.languages.addingToCartButton);
    add_to_cart_button.find('span.button-price').addClass('hidden');
    add_to_cart_button.attr('disabled', 'disabled');

    // Vérifie quel genre de produit on ajoute
    if(product_lists.eq(0).find('.item-product[data-item-template-suffix="omad"]').length) {
      addVariantsChallengeToCart(add_to_cart_button, product_lists);
    } else {
      addVariantsToCart(add_to_cart_button, product_lists);
    }
  }
  
  // Ajoute des produits au panier depuis le sélecteur de challenge (#SoShape)
  function addToCartFromSelector($this) {
    var add_to_cart_button = $this;
    
    add_to_cart_button.find('span.button-text').text(window.languages.addingToCartButton);
    add_to_cart_button.find('span.button-price').addClass('hidden');
    add_to_cart_button.attr('disabled', 'disabled');
    
    addSelectorToCart(add_to_cart_button);
  }

  /**
   * ----------------------------------------------------------------------------------------------------
   * TEMPLATES
   * ----------------------------------------------------------------------------------------------------
   */

  /**
   * TEMPLATE - PRODUCT
   */

  // Ouvre une fiche produit en mode quick shop
  function openQuickShop($this) {
    var quick_shop_modal = $('.modal--quick-shop'),
        quick_shop_remodal_instance = quick_shop_modal.remodal({hashTracking: false}),
        quick_shop_url = $this.attr('data-quick-shop-url'),
        link_color = 'var(--text-color-white)';

    if(!quick_shop_url) {
      quick_shop_url = $this.parent().attr('data-quick-shop-url');
    }

    if($this.hasClass('item__image-link')) {
      link_color = 'var(--text-color-white)';
    }
      
    quick_shop_remodal_instance.open();

    $.ajax(quick_shop_url).then(function(result) {
      quick_shop_modal.find('.modal__body--inner').html(result);
      quick_shop_modal.find('.button--cross').css('color', link_color);

      // On load
      startCarousels('', true);
      startProductCompareBars('', 'all', true);
    });

    window.quickShopRemodalInstance = quick_shop_remodal_instance;
  }

  // Ferme une fiche produit en mode quick shop et en ouvre une autre
  function toggleQuickShop($this, e) {
    closeModal($this, e);
    
    setTimeout(function(){
      openQuickShop($this, e);
    }, 1000);
  }

  // A la fermeture de la popup
  function closeQuickShop($this) {
    var quick_shop_modal = $('.modal--quick-shop');
    
    quick_shop_modal.find('.modal__body--inner').html('<div class="quick-shop__spinner spinner-container spinner-container--large"><div class="spinner spinner--circle"></div></div>');
    window.quickShopRemodalInstance = null;
  }

  // Au clic sur un lien pour afficher une fiche produit en mode quick shop
  function _clickOpenQuickShopListener($this, e) {
    e.preventDefault();
    openQuickShop($this, e);
  }

  // Au clic sur un lien pour changer de fiche produit en mode quick shop
  function _clickToggleQuickShopListener($this, e) {
    e.preventDefault();
    toggleQuickShop($this, e);
  }

  // Lorsque la popup est fermée, on doit ajouter à nouveau le petit spinner
  function _closeQuickShopListener($this, e) {
    e.preventDefault();
    closeQuickShop($this);
  }

  // Au clic sur un lien pour afficher une fiche produit en mode quick shop
  $(document).on('click', '[data-action="open-quick-shop"]', function(e) {
    _clickOpenQuickShopListener($(this), e);
  });

  // Au clic sur un lien pour changer de fiche produit en mode quick shop
  $(document).on('click', '[data-action="toggle-quick-shop"]', function(e) {
    _clickToggleQuickShopListener($(this), e);
  });

  // Lorsque la popup est fermée, on doit ajouter à nouveau le petit spinner
  $(document).on('closed', '.modal--quick-shop', function(e) {
    _closeQuickShopListener($(this), e);
  });
  
  /**
   * ----------------------------------------------------------------------------------------------------
   * SECTIONS
   * ----------------------------------------------------------------------------------------------------
   */
  
  /**
   * SECTION - SELECTOR
   */
  
  // Vérifie si l'étape passée en paramètre est l'étape en cours (#SoShape)
  function isCurrentStep(step_name) {
    var section_page = $('.section__page[data-page-handle="' + step_name + '"]');
    
    if(section_page.hasClass('slick-current')) {
      return true;
    } else {
      return false;
    }
  }

  // Vérifie si l'étape en cours est la dernière étape du sélecteur (#SoShape)
  function isLastStep(selector) {
    var last_step = selector.find('.section__page.custom-section').last();
    
    if(last_step.hasClass('slick-current')) {
      return true;
    } else {
      return false;
    }
  }

  // Gère l'affichage de certains éléments lors du passage à l'étape précédente du sélecteur
  function handleSelectorPreviousStepElements($this) {
    var selector_step_progressions = $('.selector-step-progression'),
        nb_items_selected_texts = $('.nb-items-selected'),
        slick_list = $('.carousel--product-challenge').find('.slick-list');

    // Gère l'overflow du slider qui a été retiré par la colonne sticky
    if(isCurrentStep('flavors')) {
      slick_list.removeClass('no-overflow');
    }
        
    // Gère l'activation du cta flottant
    if(isCurrentStep('flavors') && flavorsSelectionComplete($this)) {
      enableNextButton($this);
    }

    // Gère l'affichage du résumé des saveurs
    if(isCurrentStep('flavors')) {
      selector_step_progressions.show();
      nb_items_selected_texts.closest('.section__snippet').show();
    }
  }

 // Gère l'affichage de certains éléments lors du passage à l'étape suivante du sélecteur
  function handleSelectorNextStepElements($this) {
    var selector_step_progressions = $('.selector-step-progression'),
        nb_items_selected_texts = $('.nb-items-selected'),
        slick_list = $('.carousel--product-challenge').find('.slick-list');

    // Gère l'overflow du slider qui a été retiré par la colonne sticky
    if(!isCurrentStep('flavors')) {
      slick_list.addClass('no-overflow');
    }

    // Gère l'activation du cta flottant
    if(isCurrentStep('shakers') && !shakersSelectionComplete($this)) {
      disableNextButton($this);
    }

    // Gère l'affichage du résumé des saveurs
    if(!isCurrentStep('flavors')) {
      selector_step_progressions.hide();
      nb_items_selected_texts.closest('.section__snippet').hide();
    }
  }
  
  // Affiche l'étape précédente du sélecteur (#SoShape)
  function displaySelectorPreviousStep($this, e) {
    var carousels = $('.custom-section.carousel'),
        carousel = $('.custom-section.carousel--product-challenge'),
        current_slide = carousel.find('.slick-current'),
        current_slide_index = parseInt(current_slide.data('slick-index'));

    if(current_slide_index > 0) {
      e.preventDefault();
      scrollToTop();
      carousels.slick('slickPrev');
      handleSelectorPreviousStepElements($this);
    }
  }
  
  // Affiche l'étape suivante du sélecteur (#SoShape)
  function displaySelectorNextStep($this, e) {
    var carousels = $('.custom-section.carousel'),
        carousel = $('.custom-section.carousel--product-challenge'),
        step_completed = true,
        alert_text = '';
    
    e.preventDefault();
    scrollToTop();
    
    // Vérifie si tous les repas ont été sélectionnés
    if(isCurrentStep('flavors') && !flavorsSelectionComplete($this)) {
      step_completed = false;
      alert_text = window.languages.alertFlavors;
    }
    
   // Vérifie si un shaker a été sélectionné
    if(isCurrentStep('shakers') && !shakersSelectionComplete($this)) {
      step_completed = false;
      alert_text = window.languages.alertShaker;
    }
    
    if(step_completed) {
      carousels.slick('slickNext');
      handleSelectorNextStepElements($this);
    } else {
      $this.attr('disabled', 'disabled');
      $this.find('.button-text').text($this.data('button-text'));
      alert(alert_text);
    }
  }

  // Choisit l'action à effectuer lors du passage à l'étape suivante dans le sélecteur
  function chooseSelectorCtaAction($this, e) {    
    var carousel = $('.custom-section.carousel--product-challenge');
    
    if(!isLastStep(carousel)) {
      displaySelectorNextStep($this, e);
    } else {    
      e.preventDefault();
      addToCartFromSelector($this);
    }
  }

  // Displays the clicked step of the selector
  function displaySelectorStep($this, e) {
    var carousels = $('.custom-section.carousel'),
        carousel = $('.custom-section.carousel--product-challenge'),
        selector_step = $this.closest('.selector-step'),
        current_index = parseInt(carousel.find('.slick-current').data('slick-index')),
        new_index = parseInt(selector_step.data('step-index'));
    
    e.preventDefault();
    scrollToTop();
    carousels.slick('slickGoTo', new_index);

    if(new_index != current_index) {
      if(current_index > new_index) {
        handleSelectorPreviousStepElements($this);
      } else {
        handleSelectorNextStepElements($this);
      }
    }
  }

  // Filtre les produits à afficher
  function filterSelectorProducts($this, e) {
    var section_page = $this.closest('.section__page'),
        action = $this.data('action'),
        tag = action.split('_').pop(),
        product = section_page.find('.item-product[data-item-template-suffix="' + tag + '"]');

    if(product.length == 0) {
      product = section_page.find('.item-product[data-product-tags*="' + tag + '"], .elkad-product-card--selector[data-product-tags*="' + tag + '"]');
    }

    e.preventDefault();
    //scrollToTop();
    $this.closest('.buttons-wrapper').find('.active').removeClass('active');
    $this.closest('.button-wrapper').addClass('active');

    if(tag == 'all') {
      section_page.find('.section__grid-products-selector').each(function() {
        $(this).show();
        $(this).closest('.grid__cell-snippet').prev().find('.section__snippet.section__title').show();
      });
    } else {
      section_page.find('.section__grid-products-selector').each(function() {
        $(this).hide();
        $(this).closest('.grid__cell-snippet').prev().find('.section__snippet.section__title').hide();
      });
      product.closest('.section__grid-products-selector').show();
      product.closest('.grid__cell-snippet').prev().find('.section__snippet.section__title').show();
    }

    var carousel = $('.custom-section.carousel--product-challenge'),
    current_slide_height = carousel.find('.slick-current').height();

    // Change slick-list height to the current slide height
    carousel.find('.slick-list').css('height', current_slide_height);
  }
  
  // Au clic sur le bouton pour revenir à l'étape précédente du sélecteur
  function _clickSelectorPreviousStepListener($this, e) {
    displaySelectorPreviousStep($this, e);
  }
  
  // Au clic sur le bouton pour passer à l'étape suivante du sélecteur
  function _clickSelectorNextStepListener($this, e) {
    displaySelectorNextStep($this, e);
  }

  // Au clic sur le bouton pour passer à l'étape suivante du sélecteur (cta unique)
  function _clickSelectorNextStepAddToCartListener($this, e) {
    chooseSelectorCtaAction($this, e);
  }

  // On clicking on a selector step button
  function _clickSelectorGoToStepListener($this, e) {
    displaySelectorStep($this, e);
  }
  
  // Au clic sur le bouton pour filtrer le type de produits
  function _clickFilterProductsListener($this, e) {
    filterSelectorProducts($this, e);
  }
  
  // Au clic sur le bouton pour revenir à l'étape précédente du sélecteur
  $(document).on('click', '[data-action="selector-previous-step"]', function(e) {
    _clickSelectorPreviousStepListener($(this), e);
  });
  
  // Au clic sur le bouton pour passer à l'étape suivante du sélecteur
  $(document).on('click', '[data-action="selector-next-step"]', function(e) {
    _clickSelectorNextStepListener($(this), e);
  });

  // Au clic sur le bouton pour passer à l'étape suivante du sélecteur (cta unique)
  $(document).on('click', '[data-action="selector-next-step-add-to-cart"]', function(e) {
    _clickSelectorNextStepAddToCartListener($(this), e);
  });
  
  // On clicking on a selector step button
  $(document).on('click', '[data-action="selector-goto-step"]', function(e) {
    _clickSelectorGoToStepListener($(this), e);
  });

  // Au clic sur le bouton pour filtrer le type de produits
  $(document).on('click', '[data-action^="filter-products_"]', function(e) {
    _clickFilterProductsListener($(this), e);
  });

  // Bouton retour à la page précédente (bloc Button de custom-section avec option "Retour à la page précédente")
$(document).on('click', '[data-action="back"]', function(e) {
  e.preventDefault();
  window.history.back();
});
  
  /**
   * ----------------------------------------------------------------------------------------------------
   * SNIPPETS
   * ----------------------------------------------------------------------------------------------------
   */
  
  /**
   * SNIPPET - BLOCKS
   */
  
  // Affiche la catégorie sélectionnée
  function toggleCategory($this, e) {
    var section_categories = $this.closest('.section-categories'),
        categories_titles = section_categories.find('.categories-titles'),
        categories_contents = section_categories.find('.categories-contents'),
        category_number = $this.data('category-number');
    
    if(!$this.hasClass('selected')) {    
      categories_titles.find('.category-title.selected').removeClass('selected');
      $this.addClass('selected');

      categories_contents.find('.category-contents:not(.hidden)').addClass('hidden');
      categories_contents.find('.category-contents[data-category-number="' + category_number + '"]').removeClass('hidden');
    }

    // scroll to the category
    $('html, body').animate({
      scrollTop: categories_contents.find('.category-contents[data-category-number="' + category_number + '"]').offset().top - 100
    }, 500);
  }
  
  // Au clic sur une catégorie de la custom section
  function _clickToggleCategoryListener($this, e) {
    toggleCategory($this, e);
  }
  
  // Au clic sur une catégorie de la custom section
  $(document).on('click', '[data-action="toggle-category"]', function(e) {
    _clickToggleCategoryListener($(this), e);
  });
  
  // Affiche les blocs cachés
  function showHiddenBlocks($this, e) {
    var section_column = $this.closest('.section-column'),
        snippets_to_hide = section_column.find('.section__snippet[data-hide-on-load="false"]'),
        snippets_to_show = section_column.find('.section__snippet[data-hide-on-load="true"]');
    
    e.preventDefault();
    
    snippets_to_hide.each(function() {
      $(this).hide();
    });
    
    snippets_to_show.each(function() {
      $(this).show();
    });
  }
  
  // Cache les blocs cachés
  function hideHiddenBlocks($this, e) {
    var section_column = $this.closest('.section-column'),
        snippets_to_hide = section_column.find('.section__snippet[data-hide-on-load="true"]'),
        snippets_to_show = section_column.find('.section__snippet[data-hide-on-load="false"]');
    
    e.preventDefault();
    
    snippets_to_hide.each(function() {
      $(this).hide();
    });
    
    snippets_to_show.each(function() {
      $(this).show();
    });
  }

  // Affiche les blocs cachés (sans cacher les autres)
  function toggleHiddenBlocks($this, e) {
    var section_column = $this.closest('.section-column'),
        snippets_to_toggle = section_column.find('.section__snippet[data-hide-on-load="true"]'),
        button_text = $this.data('button-text'),
        button_text_toggle = $this.data('button-text-toggle'),
        current_button_text = $this.find('.button-text').text();
    
    e.preventDefault();
    
    snippets_to_toggle.each(function() {
      $(this).toggle();
    });

    // Change le texte du bouton
    if(current_button_text == button_text) {
      $this.find('.button-text').text(button_text_toggle);
    } else {
      $this.find('.button-text').text(button_text);
    }
  }
  
  // Au clic sur un bouton pour afficher les blocs cachés au load
  function _showHiddenBlocksListener($this, e) {
    showHiddenBlocks($this, e);
  }
  
  // Au clic sur un bouton pour cacher les blocs cachés au load
  function _hideHiddenBlocksListener($this, e) {
    hideHiddenBlocks($this, e);
  }

  // Au clic sur un bouton pour afficher les blocs cachés au load (sans cacher les autres)
  function _toggleHiddenBlocksListener($this, e) {
    toggleHiddenBlocks($this, e);
  }
  
  // Au clic sur un bouton pour afficher les blocs cachés au load
  $(document).on('click', '[data-action="show-hidden-blocks"]', function(e) {
    _showHiddenBlocksListener($(this), e);
  });
  
  // Au clic sur un bouton pour cacher les blocs cachés au load
  $(document).on('click', '[data-action="hide-hidden-blocks"]', function(e) {
    _hideHiddenBlocksListener($(this), e);
  });  
  
  // Au clic sur un bouton pour afficher les blocs cachés au load (sans cacher les autres)
  $(document).on('click', '[data-action="toggle-hidden-blocks"]', function(e) {
    _toggleHiddenBlocksListener($(this), e);
  });
  
  /**
   * SNIPPET - CAROUSEL PRODUCTS
   */
  
  // Change le produit affiché dans le carousel de produits
  function changeProductsCarouselCurrentProduct($this, e) {
    var section = $this.closest('.section__page'),
        carousel = section.find('.carousel--products').eq(0),
        cells = carousel.find('.carousel-cell:not(.slick-cloned)'),
        switcher_tag = $this.closest('.products-tag'),
        target = switcher_tag.data('target');
    
    e.preventDefault();
    
    cells.each(function() {
      var cell = $(this),
      	  item_product = cell.find('.item-product'),
          product_tags = item_product.data('product-tags');
      
      if(product_tags.indexOf(target) != -1) {
        var cell_index = parseInt(cell.data('slick-index'));
        
        carousel.slick('slickGoTo', cell_index);
        
        return false;
      }         
    });
  }
  
  // Change le style du tags switcher
  function changeTagsSwitcherStyle($this) {
    var selected_switcher_tag = $this.closest('.products-tag'),
        old_switcher_tag = selected_switcher_tag.siblings('.selected');
    
    selected_switcher_tag.addClass('selected');
    old_switcher_tag.removeClass('selected');
  }
  
  // Change les couleurs de la section contenant le carousel de produits
  function changeProductsCarouselSectionColors($this) {
    var section = $this.closest('.section__page'),
        carousel = section.find('.carousel--products').eq(0),
        change_section_colors = carousel.data('change-section-colors'),
        change_section_bg_colors = carousel.data('change-section-bg-colors'),
        change_section_tags_switcher_colors = carousel.data('change-section-tags-switcher-colors'),
        change_section_buttons_colors = carousel.data('change-section-buttons-colors');
    
    if(change_section_colors) {
      var tags_switcher = section.find('.section__snippet.section__products-tags-switcher'),
          switcher_tags_not_selected = tags_switcher.find('.products-tag:not(.selected)').find('.products-tag__button'),
          switcher_tag_selected = tags_switcher.find('.products-tag.selected').find('.products-tag__button'),
          current_slide = carousel.find('.slick-current'),
          current_product = current_slide.find('.item-product'),
          button_1 = section.find('.section__snippet.section__button').eq(0),
          button_2 = section.find('.section__snippet.section__button').eq(1),
          product_url = current_product.data('product-url'),
          product_color_1 = current_product.data('product-color-1'),
          product_color_2 = current_product.data('product-color-2'),
          gradient_style = section.data('gradient-style'),
          gradient_degree = section.data('gradient-degree'),
          gradient_percent_1 = section.data('gradient-percent-1'),
          gradient_percent_2 = section.data('gradient-percent-2');

      // Change la couleur de fond de la section
      if(change_section_bg_colors) {
        if(gradient_style == 'linear') {
          section.css('--section-color-bg', 'linear-gradient(' + gradient_degree + 'deg, ' + product_color_2 + ' ' + gradient_percent_1 + '%, ' + product_color_1 + ' ' + gradient_percent_2 + '%)');
        } else {
          section.css('--section-color-bg', 'radial-gradient(' + product_color_1 + ' ' + gradient_percent_1 + '%, ' + product_color_2 + ' ' + gradient_percent_2 + '%)');
        }
      }

      // Change les couleurs du tags switcher
      if(change_section_tags_switcher_colors && tags_switcher.length) {
        switcher_tags_not_selected.css('--btn-color-text', product_color_1);
        switcher_tags_not_selected.css('--btn-color-text-hover', product_color_1);
        switcher_tags_not_selected.css('--btn-color-bg', '');
        switcher_tags_not_selected.css('--btn-color-bg-hover', '');
        switcher_tag_selected.css('--btn-color-bg', product_color_1);
        switcher_tag_selected.css('--btn-color-bg-hover', product_color_1);
        switcher_tag_selected.css('--btn-color-text', '');
        switcher_tag_selected.css('--btn-color-text-hover', '');
      }

      // Change les couleurs des boutons
      if(change_section_buttons_colors) {
        if(button_2.length) {
          button_1.css('--btn-color-bg', product_color_1);
          button_1.css('--btn-color-bg-hover', product_color_1);
          button_1.css('--btn-borders-color', product_color_1);
          button_2.css('--btn-color-text', product_color_1);
          button_2.css('--btn-color-text-hover', product_color_1);
          button_2.find('.button').attr('href', product_url);
        } else if(button_1.length) {
          if(button_1.attr('href') == '#') {
            button_1.css('--btn-color-bg', product_color_1);
            button_1.css('--btn-color-bg-hover', product_color_1);
            button_1.css('--btn-borders-color', product_color_1);
          } else {
            button_1.css('--btn-color-text', product_color_1);
            button_1.css('--btn-color-text-hover', product_color_1);
            button_1.find('.button').attr('href', product_url);
          }
        }
      }
    }
  }
  
  // Vérifie si le tag sélectionné doit changer
  function checkTagsSwitcher($this) {
    var section = $this.closest('.section__page'),
        tags_switcher = section.find('.section__snippet.section__products-tags-switcher'),
        switcher_tags = tags_switcher.find('.products-tag'),
        carousel = section.find('.carousel--products'),
      	current_slide = carousel.find('.slick-current'),
        current_product = current_slide.find('.item-product'),
        current_product_tags = current_product.data('product-tags');
    
    switcher_tags.each(function() {
      var switcher_tag = $(this),
          target = switcher_tag.data('target');
      
      if(current_product_tags.indexOf(target) != -1) {
        changeTagsSwitcherStyle(switcher_tag);
        
        return false;
      }
    });
  }
  
  // Au clic sur un tag du tags switcher
  function _clickTagSwitcherListener($this, e) {    
    changeProductsCarouselCurrentProduct($this, e);
    changeTagsSwitcherStyle($this);
    changeProductsCarouselSectionColors($this);
  }
  
  // Au changement de slide d'un carousel produits
  function _changeProductsCarouselSlideListener($this) {
    checkTagsSwitcher($this);
    changeProductsCarouselSectionColors($this);  
  }
  
  // Au clic sur un tag du tags switcher
  $(document).on('click', '.products-tag:not(.selected) [data-action="change-products-list-tag"]', function(e) {
    _clickTagSwitcherListener($(this), e);
  });
  
  // Au changement de slide d'un carousel produits
  $(document).on('afterChange', '.carousel--products[data-after-change="true"]', function(event, slick, direction) {
	_changeProductsCarouselSlideListener($(this));
  });

  /**
   * SNIPPET - CART SIDEBAR
   */

  // Ouvre ou ferme le panier latéral
  function toggleCartSidebar() {
    var html = $('html'),
        page_overlay = $('.page__overlay'),
        cart_sidebar = $('.section__page.cart-sidebar'),
        sidebar_contents = cart_sidebar.find('.sidebar__contents'),
    	sidebar_height = cart_sidebar.height(),
        sidebar_header_height = cart_sidebar.find('.sidebar__header').height(),
        sidebar_footer_height = cart_sidebar.find('.sidebar__footer').height(),
        sidebar_contents_height = sidebar_height - sidebar_header_height - sidebar_footer_height;
    
    // On doit effectuer des calculs supplémentaires pour nous assurer que le contenu complet de la barre latérale est visible
    sidebar_contents.css('max-height', sidebar_contents_height + 'px');
    
    cart_sidebar.toggleClass('sidebar--open');
    document.querySelector("body").classList.toggle("cart--open");
    page_overlay.toggleClass('page__overlay--open');
    html.toggleClass('no-scroll');

    if(cart_sidebar.hasClass('sidebar--open')) {
      page_overlay.bind('click', function() {
        closeCartSidebar();
      });
    } else {
      page_overlay.off('click');
    }

    return false;
  }

  // Ferme le panier latéral
  function closeCartSidebar() {
    var html = $('html'),
        page_overlay = $('.page__overlay'),
        cart_sidebar = $('.section__page.cart-sidebar');
    
    cart_sidebar.removeClass('sidebar--open');
    document.querySelector("body").classList.remove("cart--open");
    page_overlay.removeClass('page__overlay--open').off('click');
    html.removeClass('no-scroll');
  };

  // Met à jour le nombre d'items au panier ainsi que les boutons contenant le total du panier
  function updateCartItemsCountAndButtonsPrice() {
    var cart_items_count = $('.cart-icon-wrapper__count'),
        cart_icon_full = $('.cart-icon-wrapper--has-items'),
        cart_icon_empty = $('.cart-icon-wrapper--empty'),
        buttons_price = $('.button-price');
    
    $.getJSON(window.theme.localeRootUrl + '/cart.js').then(function(results) {
      var items_count = results['item_count'],
          new_total_price = results['total_price'],
          new_total_price_formatted = convertToPriceFormat(new_total_price);

      // Met à jour le prix total dans chaque bouton
      buttons_price.each(function(){
        var button_price = $(this);
        
        button_price.data('total-price', new_total_price);
        button_price.attr('data-total-price', new_total_price);
        button_price.find('.button-price-value').text(new_total_price_formatted);
        
        if(items_count <= 0) {
          buttons_price.addClass('hidden');
        }
      });      

      // Met à jour l'icône du panier dans le header
      if (items_count > 0) {
        cart_items_count.text(items_count);
        cart_icon_full.show();
        cart_icon_empty.hide();
      } else {
        cart_icon_full.hide();
        cart_icon_empty.show();
      }
    });
  }

  function updatePriceForPackSnackCartItems() {
    const cartItems = document.querySelectorAll('.item-cart-wrapper--pack-snacks:not(.item-cart-wrapper--pack-snacks--is-pack)');

    if (cartItems.length <= 0) return;
    
    const convertNumberToPrice = (number) => {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(number / 100);
    }

    cartItems.forEach((cartItem) => {
      const itemJson = JSON.parse(cartItem.getAttribute('data-item-json'));
      const itemPricesContainer = cartItem.querySelector('.prices.cart-item-price');

      if (!itemPricesContainer) return;

      const itemPrice = itemJson.final_line_price;
      const itemCompareAtPrice = itemJson.original_line_price;

      const cardPrice = itemPricesContainer.querySelector('.product-price--value.product-price--new');
      const cardCompareAtPrice = itemPricesContainer.querySelector('.product-price--value.product-price--old');

      if (cardCompareAtPrice && cardPrice) {
        cardPrice.innerHTML = convertNumberToPrice(itemPrice);
        cardCompareAtPrice.innerHTML = convertNumberToPrice(itemCompareAtPrice);

        if (itemCompareAtPrice <= itemPrice) {
          cardPrice.classList.remove('product-price--new');
          cardCompareAtPrice.remove();
        }
      } else {
        itemPricesContainer.innerHTML = '';
        const htmlPrice = `<span class="product-price--value ${itemCompareAtPrice > 0 && itemCompareAtPrice > itemPrice ? "product-price--new" : ""}">${convertNumberToPrice(itemPrice)}</span>`;

        if (itemCompareAtPrice > 0 && itemCompareAtPrice > itemPrice) {
          const htmlCompareAtPrice = `<span class="product-price--value product-price--old">${convertNumberToPrice(itemCompareAtPrice)}</span>`;

          itemPricesContainer.insertAdjacentHTML('beforeend', htmlCompareAtPrice);
        }
        
        itemPricesContainer.insertAdjacentHTML('beforeend', htmlPrice);
      }
    });
  }

  updatePriceForPackSnackCartItems();

  // Recharge le panier latéral
  function renderCartSidebar() {
    if (Modernizr.touchevents) {
      bouncefix.remove('sidebar__header');
      bouncefix.remove('sidebar__contents');
      bouncefix.remove('sidebar__footer');
    }

    $('#cart-sidebar__contents').load('#cart-sidebar__contents #cart-sidebar__contents--inner', function(response) {
      // Find #cart-sidebar__header--inner in the response and replace the current one
      var new_header = $('#cart-sidebar__header--inner', response),
          current_header = $('#cart-sidebar__header--inner');

      current_header.replaceWith(new_header);

      checkCartContent('');
      $('.cart--reloading').removeClass('cart--reloading');
      updateCartItemsCountAndButtonsPrice();
      updateQuickAddToCart();
      updatePriceForPackSnackCartItems();
      startCarousel($('#cart-sidebar__contents .carousel--products-select:not(.slick-initialized)'), false);
      elkadInitPackInCart();
      elkadGiftForPackInCart();
      initQuickAddToCart();

      fetch("/cart.js").then((response) => response.json()).then((data) => {
        if (data.item_count > 0) {
          $(".header__item.header__item-cart").show();
          if ($(".header__item.header__item-cta.header__item--mobile a[data-action='open-navigation-sidebar']")) {
            $(".header__item-cta--1").hide();
          }
        } else {
          $(".header__item.header__item-cart").hide();
          if ($(".header__item.header__item-cta.header__item--mobile a[data-action='open-navigation-sidebar']")) {
            document.querySelector(".header__item-cta--1").style.display = "inline-block";
          }
        }
      });

      document.dispatchEvent(new CustomEvent('cart.reloaded'));
    });
    
    if (Modernizr.touchevents) {
      bouncefix.add('sidebar__header');
      bouncefix.add('sidebar__contents');
      bouncefix.add('sidebar__footer');
    }
  }

  // Ouvre et met à jour le panier latéral
  function productAddedDrawer($this, checkCartSidebar = true) {
    var cart_sidebar = $('.section__page.cart-sidebar');

    if (cart_sidebar.length <= 0) {
      window.location.reload();
      return;
    }

    if (checkCartSidebar && !document.querySelector("body").classList.contains("cart--open")) {
      toggleCartSidebar();
    }

    cart_sidebar.addClass('cart--reloading');
    renderCartSidebar();
  };

  // Met à jour le nombre d'item au panier
  function productAddedMessage($this) {
    var cart_sidebar = $('.section__page.cart-sidebar');

    cart_sidebar.addClass('cart--reloading');
    renderCartSidebar();
  };

  // Au clic sur le bouton d'ouverture ou de fermeture du panier latéral
  function _toggleCartSidebarListener($this, e) {
    e.preventDefault();
    toggleCartSidebar();
  }
  
  // Lorsque un élément est ajouté au panier et ouvre le panier latéral
  function _productAddedDrawerListener($this, e) {
    productAddedDrawer();
  }

  // Lorsque un élément est ajouté au panier et affiche un message
  function _productAddedMessageListener($this, e) {
    productAddedMessage();
  }

  // Au clic sur le bouton d'ouverture ou de fermeture du panier latéral
  $(document).on('click', '[data-action="open-cart-sidebar"], [data-action="close-cart-sidebar"]', function(e) {
	_toggleCartSidebarListener($(this), e);
  });
  
  // Lorsque un élément est ajouté au panier et ouvre le panier latéral
  $(document).on('product.added.drawer', function(e) {
	_productAddedDrawerListener($(this), e);
  });
  
  // Lorsque un élément est ajouté au panier et affiche un message
  $(document).on('product.added.message', function(e) {
	_productAddedMessageListener($(this), e);
  });
  
  /**
   * SNIPPET - CART SUMMARY
   */

  // Sauvegarde la valeur du champ "Cart note"
  function updateCartNote($this) {
    var cart_notes = $('.cart__note'),
        new_note = $this.val();
    
    cart_notes.val(new_note);

    $.post(window.theme.localeRootUrl + '/cart/update.js', {note: new_note}, null, 'json');
  }
  
  // Active le bouton "Checkout"
  function enableCheckoutButton($this) {
    var cart_summary = $this.closest('.cart-summary'),
        button_checkout = cart_summary.find('.cart-summary-button').find('.button'),
        cgv_text = cart_summary.find('.cart-summary-cgv').find('.input-radio-label-content');
    
    button_checkout.removeAttr('disabled');
    cgv_text.removeClass('blinking-error');
  }
  
  // Désactive le bouton "Checkout"
  function disableCheckoutButton($this) {
    var cart_summary = $this.closest('.cart-summary'),
        button_checkout = cart_summary.find('.cart-summary-button').find('.button'),
        cgv_text = cart_summary.find('.cart-summary-cgv').find('.input-radio-label-content');
    
    button_checkout.attr('disabled', 'disabled');
    cgv_text.addClass('blinking-error');
    
    setTimeout(function(){
      cgv_text.removeClass('blinking-error');
    }, 7500);
  }
  
  // Active ou désactive le bouton "Checkout"
  function toggleCheckoutButton($this) {
    var cgv_input = $this.find('.input-radio'),
        cgv_input_checked = cgv_input.prop('checked');
    
    if(cgv_input_checked == true) {
      enableCheckoutButton($this);
    } else {
      disableCheckoutButton($this);
    }
  }
  
  // Vérifie si la case des cgv est cochée
  function checkCgv($this, e) {
    var cart_summary = $this.closest('.cart-summary'),
        cgv_input = cart_summary.find('.cart-summary-cgv').find('.input-radio'),
        cgv_input_checked = cgv_input.prop('checked');
    
    if(cgv_input.length && cgv_input_checked != true) {
      e.preventDefault();
      disableCheckoutButton($this);
    }
  }
  
  // Vérifie si une des saveurs d'un des challenges est en rupture (#SoShape)
  function checkOutOfStockFlavors($this, e) {
    var section = $this.closest('.section__page'),
        list_cart_items = section.find('.list-cart-items').eq(0),
    	out_of_stock_items = list_cart_items.find('.item-cart[data-out-of-stock-flavor="true"]'),
        modal = $('.modal--out-of-stock').eq(0);
      
    if(out_of_stock_items.length) {
      e.preventDefault();
      disableCheckoutButton($this);
      
      if(modal) {
        var modal_instance = modal.remodal({});
        
        modal_instance.open();
      }
      
      setTimeout(function(){
        out_of_stock_items.each(function(){
          var item = $(this),
              remove_button = item.find('.cart-item-remove');
          
          remove_button[0].click();
        });          
      }, 5000);
    }
  }

  // Au changement de valeur dans le champ "Cart note"
  function _changeCartNoteListener($this) {
    updateCartNote($this);
  }
  
  // Au clic sur la case d'acceptation des cgv
  function _clickAcceptsCgvListener($this, e) {
    toggleCheckoutButton($this);
  }
  
  // Au clic sur le bouton pour aller au checkout
  function _clickCheckoutListener($this, e) {
    checkCgv($this, e);
    checkOutOfStockFlavors($this, e);
  }
  
  // Au changement de valeur dans le champ "Cart note"
  $(document).on('change', '.cart__note', function(e) {
    _changeCartNoteListener($(this));
  });
  
  // Au clic sur la case d'acceptation des cgv
  $(document).on('click', '[data-action="accepts-cgv"]', function(e) {
    _clickAcceptsCgvListener($(this), e);
  });
  
  // Au clic sur le bouton pour aller au checkout
  $(document).on('click', '[data-action="checkout"]', function(e) {
    _clickCheckoutListener($(this), e);
  });
  
  /**
   * SNIPPET - COOKIES
   */
  
  // Accepte les cookies
  function acceptCookies($this) {
    var href = $this.attr('href');
    
  	window.localStorage.setItem('accept_cookies', 'true');
    
    if(href != '#accept-cookies') {
      window.location.href = href;
    }
  }
  
  // Au clic sur un lien ou sur le bouton "J'ai compris" du bandeau de cookies
  function _clickAcceptCookiesListener($this, e) { 
    e.preventDefault();
    hideBand($this.closest('.shopify-section__cookies-bar'));
    acceptCookies($this);
  }
  
  // Au clic sur un lien du bandeau de cookies ou sur le bouton "J'ai compris" du bandeau de cookies
  $(document).on('click', '[data-action="accept-cookies"]', function(e) {
    _clickAcceptCookiesListener($(this), e);
  });
  
  /**
   * SNIPPET - CUSTOMER INFORMATIONS
   */
  
  // Supprime une adresse client
  function deleteAddress($this, e) {
    var customer_address_id = $this.parent().data('address');
    
    Shopify.CustomerAddress.destroy(customer_address_id); 
    
    return false;
  }
  
  // Au clic sur le bouton "Supprimer" d'une adresse client
  function _clickDeleteAddressListener($this, e) {
    deleteAddress($this, e);
  }
  
  // Au clic sur le bouton "Supprimer" d'une adresse client
  $(document).on('click', '[data-action="delete-address"]', function(e) {
    _clickDeleteAddressListener($(this), e);
  });
  
  /**
   * SNIPPET - CUSTOMER ORDERS
   */
  
  // Affiche ou cache le détails d'une commande
  function toggleOrder($this, e) {
    var orders = $this.closest('.customer-orders'),
        orders_table = orders.find('.customer-orders-table'),
        orders_details = orders.find('.customer-orders-details'),
        order_name = $this.data('order-name'),
        orders_not_hidden = orders_details.find('.customer-order:not(.hidden)'),
        order = orders_details.find('.customer-order[data-order-name="' + order_name + '"]');
    
    e.preventDefault();
    
    orders_table.toggleClass('hidden');
    orders_details.toggleClass('hidden');
    orders_not_hidden.addClass('hidden');
    order.toggleClass('hidden');
  }
  
  // Au clic sur le bouton "Voir" d'une commande ou le bouton "Retour"
  function _clickToggleOrderListener($this, e) {
    toggleOrder($this, e);
  }
  
  // Au clic sur le bouton "Voir" d'une commande ou le bouton "Retour"
  $(document).on('click', '[data-action="toggle-order"]', function(e) {
    _clickToggleOrderListener($(this), e);
  });
  
  /**
   * SNIPPET - FAQ SEARCH
   */
  
  // Recherche une réponse dans la FAQ
  function searchFaqAnswers($this, e) {
    var search_form = $this.closest('form'),
        search_type = search_form.data('search-type'),
        search_term = $this.val().toLowerCase(),
        shopify_section = $('#shopify-section-template--23380629913948__1655133772c8134328.shopify-section'),
    	sections_faq = shopify_section.find('.section__faq');
    
    if(sections_faq.length == 0) {
      shopify_section = shopify_section.next();
      sections_faq = shopify_section.find('.section__faq');
    }
    
    if(sections_faq.length > 0) {
      if(search_type == 'global') {
        var global_faq_search_results_inner_html = '';
      }
      
      sections_faq.each(function() {
        var section_faq = $(this),
            faq_wrapper = section_faq.find('.faq-wrapper'),
            faq_items = faq_wrapper.find('.faq-item');

        if(search_type == 'category') {
          var faq_search_results_wrapper = section_faq.find('.faq-search-results-wrapper'),
              faq_search_results = faq_search_results_wrapper.find('.faq-search-results'),
              faq_search_results_inner_html = '';
        }

        if(search_term.length >= 3) {
          faq_items.each(function() {
            var faq_item = $(this),
                faq_question_content = faq_item.find('.faq__question').text().toLowerCase(),
                faq_answer_content = faq_item.find('.faq__answer').text().toLowerCase();

            if(faq_question_content.indexOf(search_term) != -1 || faq_answer_content.indexOf(search_term) != -1){
              var faq_item_html = faq_item.prop('outerHTML');

              if(search_type == 'global') {
                global_faq_search_results_inner_html += faq_item_html;
              } else {
                faq_search_results_inner_html += faq_item_html;
              }
            }
          });

          if(search_type == 'category') {
            if(faq_search_results_inner_html == '') {
              faq_search_results_inner_html = '<div class="search-empty">' + window.languages.autocompleteNoResults + '</div>';
            } 
            
            faq_search_results.empty();
            faq_search_results.html(faq_search_results_inner_html);
            faq_search_results_wrapper.removeClass('hidden');
            faq_wrapper.hide();
          }
        } else {
          if(search_type == 'category') {
            faq_search_results.empty();
            faq_search_results_wrapper.addClass('hidden');
            faq_wrapper.show();
          }
        }
      });

      if(search_type == 'global') {
        if(global_faq_search_results_inner_html == '') {
          global_faq_search_results_inner_html = '<div class="search-empty">' + window.languages.autocompleteNoResults + '</div>';
        }
  
        sections_faq.each(function() {
          var section_faq = $(this),
              faq_wrapper = section_faq.find('.faq-wrapper'),
              faq_search_results_wrapper = section_faq.find('.faq-search-results-wrapper'),
              faq_search_results = faq_search_results_wrapper.find('.faq-search-results');
  
          if(search_term.length >= 3) {
            faq_search_results.empty();
            faq_search_results.html(global_faq_search_results_inner_html);
            faq_search_results_wrapper.removeClass('hidden');
            faq_wrapper.hide();
          } else {
            faq_search_results.empty();
            faq_search_results_wrapper.addClass('hidden');
            faq_wrapper.show();
          }
        });
      }

      // Check if the pressed key is 'Enter'
      if (e.key === 'Enter') {
        // Scroll to the .categories-contents
        $('html, body').animate({
          scrollTop: $(".categories-contents").offset().top - 100
        }, 500);
      }
    }
  }

  // Empêche la soumission du formulaire
  function preventFormSubmission($this, e) {
    if(e.keyCode == 13) {    
      e.preventDefault();
    }
  }
  
  // A la saisie d'un terme de recherche dans la FAQ
  function _keyupFaqSearchListener($this, e) {
    searchFaqAnswers($this, e);
  }

  // A la saisie d'un terme de recherche dans la FAQ
  function _keydownFaqSearchListener($this, e) {
    preventFormSubmission($this, e);
  }
  
  // A la saisie d'un terme de recherche dans la FAQ
  $(document).on('keyup', '.faq-search__form input', function(e) {
    _keyupFaqSearchListener($(this), e);
  });

  // A la saisie d'un terme de recherche dans la FAQ
  $(document).on('keydown', '.faq-search__form input', function(e) {
    _keydownFaqSearchListener($(this), e);
  });

  /**
   * SNIPPET - FOOTER
   */

  // Affiche ou cache un menu dépliant du footer
  function openNextDropdown($this) {
  	var menu_item = $this.closest('.linklist-item');

    menu_item.toggleClass('linklist-item--active').attr('aria-expanded', function(index, attr) {return attr === 'true' ? 'false' : 'true'});
    menu_item.siblings().removeClass('linklist-item--active').attr('aria-expanded', 'false')
    .find('.linklist-item--active').removeClass('linklist-item--active').attr('aria-expanded', 'false');

    return false;
  }

  // Au clic sur un menu dépliant dans le footer
  function _clickFooterMenuListener($this, e) {
    e.preventDefault();
    openNextDropdown($this, e);
  }

  // Au clic sur un menu dépliant dans le footer
  $(document).on('click', '.linklist-item--expandable > .linklist__link', function(e) {
    _clickFooterMenuListener($(this), e);
  });
  
  /**
   * SNIPPET - HEADER
   */
  
  // Redirige vers la bonne page produit
  function redirectProduct($this, e) {
  	var selected_option = $this.find('option:selected'),
        url = selected_option.data('url');
    
    window.location.href = url;
  }
  
  // Redirige vers la bonne langue
  function redirectSite($this, e) {
  	var flag_icon = $this.closest('.flag-icon');
    
    if(flag_icon.data('action') == 'toggle-countries') {      
      e.preventDefault();
      flag_icon.closest('.flag-icon-wrapper').toggleClass('active');
    }
  }
  
  // Au changement de valeur dans la liste des autres produits
  function _changeOtherProductsListListener($this, e) {
    redirectProduct($this, e);
  }
  
  // Au clic sur un icône de drapeau
  function _clickFlagIconListener($this, e) {
    redirectSite($this, e);
  }
  
  // Au changement de valeur dans la liste des autres produits
  $(document).on('change', '[data-action="redirect-other-product"]', function(e) {
    _changeOtherProductsListListener($(this), e);
  });
  
  // Au clic sur un icône de drapeau
  $(document).on('click', '.flag-icon .header__link', function(e) {
    _clickFlagIconListener($(this), e);
  });
  
  /**
   * SNIPPET - ITEM CART
   */

  // Change la quantité d'un item au panier
  function changeCartItemQuantity(item_cart, item_cart_key, quantity) {
    const is_main_pack = item_cart.data('is-main-pack');
    const pack_id = item_cart.data('selector-pack-id');

    $.post({
      url: window.theme.localeRootUrl + '/cart/change.js',
      dataType: 'json',
      data: {
        quantity: quantity,
        id: item_cart_key
      }
    }).then(async function (res) {
      if(isPage('/cart')) {
        location.reload();
      } else {
        if (is_main_pack && quantity <= 0) {
          const related_pack_items = document.querySelectorAll(`.item-cart[data-selector-pack-id="${pack_id}"]:not([data-cart-item-key="${item_cart_key}"])`);

          const updates = {updates: {}};

          for (const item of related_pack_items) {
            const item_cart_key = item.getAttribute('data-cart-item-key');

            updates.updates[item_cart_key] = 0;
          }

          if (updates.updates != {}) {
            await fetch(window.theme.localeRootUrl + '/cart/update.js', {
              method: 'POST',
              body: JSON.stringify(updates)
            });
          }
        } 

        if(quantity > 0) {
          renderCartSidebar();
        } else {
          item_cart.slideUp(150, function() {
            renderCartSidebar();
          });
        }
      }
    }).catch(function(error) {
      console.error(error);
    });
  }
  
  // Supprime du panier le challenge à modifier (#SoShape)
  function deleteChallenge($this) {
  	var modal = $this.closest('.modal'),
    	item_cart_number = modal.data('cart-item-number');

    $.post({
      url: window.theme.localeRootUrl + '/cart/change.js',
      dataType: 'json',
      data: {
        quantity: 0,
        line: item_cart_number
      }
    }).then(function() {
      window.location.href = $this.attr('href');
    });
  }

  // Change la valeur d'un item au panier
  function changeCartItemQuantityInput($this) {
      var item_cart = $this.closest('.item-cart'),
          item_cart_key = item_cart.attr('data-cart-item-key'),
          quantity = parseInt($this.val());

    // On ajoute un car Shopify utilise la numérotation 1-index.
    window.location.href = window.theme.localeRootUrl + '/cart/change?quantity=' + quantity + '&id=' + item_cart_key;
  }

  // Change le selling plan d'un item au panier
  function changeCartItemSellingPlan($this, update_frequency) {
    var section_page = $this.closest('.section__page'),
        item_cart = $this.closest('.item-cart'),
        item_cart_key = item_cart.attr('data-cart-item-key'),
        quantity = parseInt(item_cart.find('.product__quantity-value').text()),
        selling_plan_group_id = $this.closest('[data-smartrr-selling-plan-group-id]'),
        selling_plan_group_contents = selling_plan_group_id.find('[data-smartrr-selling-plan-group-contents]'),
        selling_plans_select = selling_plan_group_contents.find('[data-smartrr-selling-plans-select]'),
        selling_plan = null;

    if(!isPage('/cart')) {
      section_page.addClass('cart--reloading');
    }

    if(isNaN(quantity)) {
      quantity = 1;
    }

    // On récupère l'id du selling plan sélectionné
    if(!selling_plan_group_id.hasClass('smartrr-group-active') || update_frequency) {
      selling_plan = parseInt(selling_plans_select.find('option:selected').val());
    }

    // On change les informations de selling plan sauvegardées
    $.post({
      url: window.theme.localeRootUrl + '/cart/change.js',
      dataType: 'json',
      data: {
        quantity: quantity,
        selling_plan: selling_plan,
        id: item_cart_key
      }
    }).then(function(res) {
      if(isPage('/cart')) {
        location.reload();
      } else {
        renderCartSidebar();
      }
    }).catch(function(error) {
      console.log(error.responseJSON.description);
      renderCartSidebar();
    }); 
  }

  // Change le selling plan de plusieurs items au panier
  const updateSellingPlan = (item_cart_key, selling_plan, quantity) => {
    // Prepare the data
    const data = {
      quantity: quantity,
      selling_plan: selling_plan,
      id: item_cart_key
    };
  
    // Return the Promise created by fetch
    return fetch(window.theme.localeRootUrl + '/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .catch(error => {
      console.log(error.message);
    });
  }

  const changeCartItemsSellingPlan = async (items, update_frequency) => {
    for (const item of items) {
      if (!item.querySelector('.product__quantity-value')) return;
      
      var section_page = item.closest('.section__page'),
          item_cart = item,
          item_cart_key = item_cart.getAttribute('data-cart-item-key'),
          quantity = parseInt(item_cart.querySelector('.product__quantity-value').textContent),
          selling_plan_group_id = item.querySelector('[data-smartrr-selling-plan-group-id]'),
          selling_plan_group_contents = selling_plan_group_id.querySelector('[data-smartrr-selling-plan-group-contents]'),
          selling_plans_select = selling_plan_group_contents.querySelector('[data-smartrr-selling-plans-select]'),
          selling_plan = null;
  
      if(!isPage('/cart')) {
        section_page.classList.add('cart--reloading');
      }
  
      if(isNaN(quantity)) {
        quantity = 1;
      }
  
      // On récupère l'id du selling plan sélectionné
      if(!selling_plan_group_id.classList.contains('smartrr-group-active') || update_frequency) {
        selling_plan = parseInt(selling_plans_select.options[selling_plans_select.selectedIndex].value);
      }
  
      // Call updateSellingPlan and wait for it to resolve before continuing
      await updateSellingPlan(item_cart_key, selling_plan, quantity);
    }
  
    if(isPage('/cart')) {
      location.reload();
    } else {
      renderCartSidebar();
    }
  }
  
  // Au clic sur le lien "Modifier mes choix" dans les détails d'un challenge
  function _clickModifyChallengeListener($this, e) {
    e.preventDefault();
    deleteChallenge($this);
  }

  // Au changement de valeur d'un input quantity
  function _changeCartItemQuantityInputListener($this, e) {
    changeCartItemQuantityInput($this);
  }

  // Au clic sur une case à cocher liée à l'abonnement
  function _toggleCartItemSubscriptionListener($this, e) {
    changeCartItemSellingPlan($this, false);
  }

  // Au changement de fréquence de l'abonnement
  function _changeCartItemSubscriptionListener($this, e) {
    changeCartItemSellingPlan($this, true);
  }
  
  // Au clic sur le lien "Modifier mes choix" dans les détails d'un challenge
  $(document).on('click', '[data-action="modify-challenge"]', function(e) {
    _clickModifyChallengeListener($(this), e);
  });
  
  // Au changement de valeur d'un input quantity
  $(document).on('change', '.item-cart .product__quantity-value', function(e) {
    _changeCartItemQuantityInputListener($(this), e);
  });
  
  // Au clic sur une case à cocher liée à l'abonnement
  $(document).on('click', '.item-cart [data-smartrr-selling-plan-group-input]', function(e) {
    _toggleCartItemSubscriptionListener($(this), e);
  });
  
  // Au changement de fréquence de l'abonnement
  $(document).on('change', '.item-cart [data-smartrr-selling-plans-select]', function(e) {
    _changeCartItemSubscriptionListener($(this), e);
  });

  /**
   * SNIPPET - ITEM CART - SIDEBAR
   */

  // Réduit la quantité d'un item au panier
  function subProduct($this) {
    var section_page = $this.closest('.section__page'),
        item_cart = $this.closest('.item-cart-sidebar'),
        item_cart_key = item_cart.attr('data-cart-item-key'),
        quantity = parseInt(item_cart.find('.product__quantity-value').text()) - 1;

    section_page.addClass('cart--reloading');
    changeCartItemQuantity(item_cart, item_cart_key, quantity);

    return false;
  };

  // Augmente la quantité d'un item au panier
  function addProduct($this) {
    var section_page = $this.closest('.section__page'),
        item_cart = $this.closest('.item-cart-sidebar'),
        item_cart_key = item_cart.attr('data-cart-item-key'),
        quantity = parseInt(item_cart.find('.product__quantity-value').text()) + 1;

    section_page.addClass('cart--reloading');
    changeCartItemQuantity(item_cart, item_cart_key, quantity);

    return false;
  };

  // Supprime un item au panier
  function removeProduct($this) {
    var section_page = $this.closest('.section__page'),
        item_cart = $this.closest('.item-cart-sidebar'),
        item_cart_key = item_cart.attr('data-cart-item-key'),
        quantity = 0;

    section_page.addClass('cart--reloading');
    changeCartItemQuantity(item_cart, item_cart_key, quantity);

    return false;
  };

  // Au clic sur le bouton - de la quantité dans un item cart sidebar
  function _clickCartItemSidebarSubQuantityListener($this, e) {
    e.preventDefault();
    subProduct($this);
  }
  
  // Au clic sur le bouton + de la quantité dans un item cart sidebar
  function _clickCartItemSidebarAddQuantityListener($this, e) {
    e.preventDefault();
    addProduct($this);
  } 
  
  // Au clic sur le bouton x dans un item cart sidebar
  function _clickCartItemSidebarRemoveListener($this, e) {
    e.preventDefault();
    removeProduct($this);
  } 

  // Au clic sur le bouton - de la quantité dans un item cart sidebar
  $(document).on('click', '.item-cart-sidebar [data-action="sub-product"]', function(e) {
	_clickCartItemSidebarSubQuantityListener($(this), e);
  });
  
  // Au clic sur le bouton + de la quantité dans un item cart sidebar
  $(document).on('click', '.item-cart-sidebar [data-action="add-product"]', function(e) {
	_clickCartItemSidebarAddQuantityListener($(this), e);
  });
  
  // Au clic sur le bouton x dans un item cart sidebar
  $(document).on('click', '.item-cart-sidebar [data-action="remove-product"]', function(e) {
	_clickCartItemSidebarRemoveListener($(this), e);
  });
  
  /**
   * SNIPPET - ITEM PRODUCT
   */
  
  // Au clic sur le bouton d'ajout au panier dans un item produit
  function _clickProductItemAddToCartListener($this, e) {
    e.preventDefault();
    addToCartFromProductItem($this);
  }
  
  // Au clic sur le bouton d'ajout au panier dans un item produit de type challenge
  function _clickProductItemChallengeAddToCartListener($this, e) {
    e.preventDefault();
    addToCartFromProductItemChallenge($this);
  }
  
  // Au clic sur un bouton d'ajout au panier sous une liste de produits
  function _clickProductsListAddToCartListener($this, e) {
    e.preventDefault();
    addToCartFromProductsList($this);
  }

  // Au clic sur un bouton d'ajout au panier à la fin du sélecteur de produits
  function _clickSelectorProductsAddToCartListener($this, e) {
    e.preventDefault();
    addToCartFromSelectorProducts($this);
  }
  
  // Au clic sur un bouton d'ajout au panier à la fin du sélecteur de challenge
  function _clickSelectorAddToCartListener($this, e) {
    e.preventDefault();
    addToCartFromSelector($this);
  }
  
  // Au clic sur le bouton d'ajout au panier dans un item produit
  $(document).on('click', '.item-product:not([data-item-template-suffix="challenge"]) [data-action="add-to-cart"]', function(e) {
	_clickProductItemAddToCartListener($(this), e);
  });
  
  // Au clic sur le bouton d'ajout au panier dans un item produit de type challenge
  $(document).on('click', '.item-product[data-item-template-suffix="challenge"] [data-action="add-to-cart"]', function(e) {
	_clickProductItemChallengeAddToCartListener($(this), e);
  });
  
  // Au clic sur un bouton d'ajout au panier sous une liste de produits
  $(document).on('click', '[data-action="add-to-cart-products-list"]', function(e) {
	_clickProductsListAddToCartListener($(this), e);
  });

  // Au clic sur un bouton d'ajout au panier à la fin du sélecteur de produits
  $(document).on('click', '[data-action="add-to-cart-selector-products"]', function(e) {
	_clickSelectorProductsAddToCartListener($(this), e);
  });
  
  // Au clic sur un bouton d'ajout au panier à la fin du sélecteur de challenge
  $(document).on('click', '[data-action="add-to-cart-selector"]', function(e) {
	_clickSelectorAddToCartListener($(this), e);
  });
  
  /**
   * SNIPPET - ITEM PRODUCT CHALLENGE
   */
  
  // Sélectionne un challenge (#SoShape)
  function selectChallenge($this) {
  	var item_product = $this.closest('.item-product');

    item_product.closest('.section__snippet').find('.item-product.selected').removeClass('selected');
    item_product.addClass('selected');
  }
  
  // Redirige vers le challenge sélectionné (#SoShape)
  function redirectChallenge($this) {
    var item_product = $this.closest('.item-product'),
        product_url = item_product.data('product-url');
    
    window.location.href = product_url;
  }
  
  // Active le cta d'une collection de challenge (#SoShape)
  function enableChallengesButton($this) {
  	var button_next_step = $('[data-action="redirect-challenge"]');
    
    button_next_step.removeAttr('disabled');
    //scrollToElement(button_next_step);
  }

  // Met à jour le cta d'une collection de challenge (#SoShape)
  function updateChallengesButton($this) {
  	var button_next_step = $('[data-action="redirect-challenge"]'),
        button_price = button_next_step.find('.button-price'),
        item_product = $this.closest('.item-product'),
        product_price = parseInt(item_product.data('variant-price')),
        product_price_formatted = convertToPriceFormat(product_price),
        product_url = item_product.data('product-url');
        
    if(button_next_step.length) {
      button_next_step.attr('href', product_url);
      
      if(button_price.length) {
        button_price.data('total-price', product_price);
        button_price.attr('data-total-price', product_price);
        button_price.find('.button-price-value').text(product_price_formatted);
        button_price.removeClass('hidden');
      }
    }
  }

  function getPriceFromUrlToButton() {
    const urlParams = new URLSearchParams(window.location.search);
    const challengePrice = urlParams.get('challenge_price');

    if (!challengePrice) return;
    
    var button_next_step = $('[data-action="add-to-cart-selector"]'),
        button_price = button_next_step.find('.button-price'),
        challengePriceFormatted = convertToPriceFormat(challengePrice);
        
    if(button_price.length) {
      button_price.attr('data-total-price', challengePrice);
      button_price.attr('data-total-price-compare', challengePrice);
      button_price.find('.button-price-value').text(challengePriceFormatted);
      button_price.removeClass('hidden');
    }
  }
  
  // Au clic sur un item product challenge ailleurs que dans le sélecteur
  function _clickItemChallengeNotSelectorListener($this) {
    selectChallenge($this);
    redirectChallenge($this);
  }
  
  // Au clic sur un item product challenge dans le sélecteur
  function _clickItemChallengeSelectorListener($this) {
    selectChallenge($this);
    enableChallengesButton($this);
    updateChallengesButton($this);
  }
  
  // Au clic sur un item product challenge ailleurs que dans le sélecteur
  $(document).on('click', '[data-item-action="select-challenge-collection"]', function(e) {
    _clickItemChallengeNotSelectorListener($(this), e);
  });
  
  // Au clic sur un item product challenge dans le sélecteur
  $(document).on('click', '[data-item-action="select-challenge-selector"]', function(e) {
    _clickItemChallengeSelectorListener($(this), e);
  });

  document.addEventListener('DOMContentLoaded', function() {
    getPriceFromUrlToButton();
  });
  
  /**
   * SNIPPET - ITEM PRODUCT SELECTOR
   */
  
  // Cache le sélecteur de quantité
  function hideProductQuantity($this) {
    var item_product = $this.closest('.item-product'),
        product_quantity = item_product.find('.product__quantity'),
    	quantity_item = product_quantity.find('.product__quantity-value'),
        quantity_value = parseInt(quantity_item.text()),
        product_button = item_product.find('.product__button');
    
    if(quantity_value <= 0 && product_button.length) {
      product_quantity.addClass('hidden');
      product_button.removeClass('hidden');
    }
  }
  
  // Affiche le sélecteur de quantité
  function showProductQuantity($this) {   
    var item_product = $this.closest('.item-product'),
        product_button = item_product.find('.product__button'),
        product_quantity = item_product.find('.product__quantity'),
        add_button = product_quantity.find('.button--quantity-add');
    
    product_button.addClass('hidden');
    product_quantity.removeClass('hidden');
    add_button.trigger('click');
  }

  // Supprime un item de summary
  function deleteSummaryItem($this) {
    var section_page = $this.closest('.section__page'),
        selector_summaries = $('.selector-summary'),          
        nb_items_selected_texts = $('.nb-items-selected'),
        nb_items_selected_value = 0,      
        item_product = $this.closest('.item-product'),
        item_handle = item_product.data('item-handle'),
        step = parseInt(item_product.find('.product__quantity-wrapper').attr('data-step'));

    if(isNaN(step)) {
      step = 1;
    }

    selector_summaries.each(function() {
      var selector_summary = $(this),
          nb_items_selected = parseInt(selector_summary.attr('data-nb-items-selected')),
          new_nb_items_selected = nb_items_selected - step,
          selected_slot = selector_summary.find('.summary-item[data-product-handle="' + item_handle + '"]').last();
        
      // Supprime un item de summary
      if(!selected_slot.hasClass('last')) {
        selector_summary.find('.summary-item.last').first().removeClass('last');
      }
      
      selected_slot.remove();
      
      if(new_nb_items_selected == 0) {
        selector_summary.closest('.section__snippet').attr('data-hide-on-load', true);
      }

      // Met à jour l'ordre des items de summary
      selector_summary.find('.summary-item').each(function(index) {
        var summary_item = $(this);

        summary_item.attr('data-summary-number', index + 1);
        summary_item.css('--z-index', index);
      });
      
      // Met à jour le nombre d'item sélectionnés
      selector_summary.data('nb-items-selected', new_nb_items_selected); 
      selector_summary.attr('data-nb-items-selected', new_nb_items_selected);    
      nb_items_selected_value = new_nb_items_selected;
    });

    // Met à jour le nombre d'item sélectionnés
    if(selector_summaries.length) {
      nb_items_selected_texts.each(function() {
        var nb_items_selected_text = $(this);
  
        nb_items_selected_text.text(nb_items_selected_value);
  
        if(nb_items_selected_value == 0) {
          nb_items_selected_text.closest('.section__snippet').attr('data-hide-on-load', true);
        }
      });
    }
  }

  // Ajoute un item de summary
  function addSummaryItem($this) {
    var section_page = $this.closest('.section__page'),
        selector_summaries = $('.selector-summary'),       
        nb_items_selected_texts = $('.nb-items-selected'),
        nb_items_selected_value = 0,
        item_product = $this.closest('.item-product'),
        step = parseInt(item_product.find('.product__quantity-wrapper').attr('data-step'));

    if(isNaN(step)) {
      step = 1;
    }

    selector_summaries.each(function() {
      var selector_summary = $(this),  
          nb_items_max = parseInt(selector_summary.attr('data-nb-items-max')),
          nb_items_selected = parseInt(selector_summary.attr('data-nb-items-selected')),
          new_nb_items_selected = nb_items_selected + step,
          nb_slots = selector_summary.find('.summary-item').length,
          new_slot = '<span class="summary-item" data-summary-number="' + (nb_slots + 1) + '" style="--z-index: ' + nb_slots + '"></span>';

      // Ajoute un item de summary
      selector_summary.find('.selector-summary--inner').append(new_slot);
      selector_summary.closest('.section__snippet').attr('data-hide-on-load', false);
      
      // Ajoute la couleur et les attributs d'un item de summary 
      var selected_slot = selector_summary.find('.summary-item').last();

      if(nb_items_max > 0 && nb_slots >= nb_items_max) {
        selected_slot.addClass('last');
      }
      
      selected_slot.addClass('selected');
      selected_slot.css('background-color', item_product.data('product-color-1'));
      selected_slot.css('background-image', 'url(' + item_product.find('.item__image').find('img').attr('src') + ')');
      selected_slot.attr('data-product-handle', item_product.data('item-handle'));
      selected_slot.attr('data-variant-id', item_product.data('variant-id'));
  	  selected_slot.attr('data-variant-sku', item_product.data('variant-sku'));
      selected_slot.attr('data-product-title', item_product.data('product-title'));
      
      // Met à jour le nombre d'item sélectionnés
      selector_summary.data('nb-items-selected', new_nb_items_selected); 
      selector_summary.attr('data-nb-items-selected', new_nb_items_selected);
      nb_items_selected_value = new_nb_items_selected;
    });

    // Met à jour le nombre d'item sélectionnés
    if(selector_summaries.length) {
      nb_items_selected_texts.each(function() {
        var nb_items_selected_text = $(this);
  
        nb_items_selected_text.text(nb_items_selected_value);
        nb_items_selected_text.closest('.section__snippet').attr('data-hide-on-load', false);
      });
    }
  }
  
  // Supprime un item de progression
  function deleteStepProgressionItem($this) {
    var section_page = $this.closest('.section__page'),
        selector_step_progressions = $('.selector-step-progression'),          
        nb_items_selected_texts = $('.nb-items-selected'),
        nb_items_selected_value = 0,      
        item_product = $this.closest('.item-product'),
        item_handle = item_product.data('item-handle'),
        item_tags = item_product.data('product-tags');

    selector_step_progressions.each(function() {
      var selector_step_progression = $(this),
          nb_items_selected = parseInt(selector_step_progression.attr('data-nb-items-selected')),
          step = parseInt(selector_step_progression.attr('data-step')),
          new_nb_items_selected = nb_items_selected - step,
          selected_slot = selector_step_progression.find('.step-progression-item[data-product-handle="' + item_handle + '"]').last(),
          tag = selector_step_progression.attr('data-tag');

      if(item_tags.indexOf(tag) != -1) {
        // Retire la slot et en ajoute un vide à la fin
        var step_number = selector_step_progression.find('.step-progression-item').length + 1,
            selector_step_progression_inner = selector_step_progression.find('.selector-step-progression--inner'),
            step_progression_item_html = '<span class="step-progression-item" data-step-number="' + step_number + '" style="--z-index: ' + step_number + ';"></span>';
        
        selected_slot.remove();
        selector_step_progression_inner.append(step_progression_item_html);

        // Met à jour leur propriété "z-index"
        updateStepProgressionItemsOrder(selector_step_progression);

        // Met à jour le nombre d'item sélectionnés par catégorie
        var nb_cat_items_selected_text = selector_step_progression.find('.nb-cat-items-selected'),
            old_nb_cat_items_selected = parseInt(nb_cat_items_selected_text.text()),
            new_nb_cat_items_selected = old_nb_cat_items_selected - step;

        nb_cat_items_selected_text.text(new_nb_cat_items_selected);
      }
      
      // Met à jour le nombre d'item sélectionnés
      selector_step_progression.data('nb-items-selected', new_nb_items_selected); 
      selector_step_progression.attr('data-nb-items-selected', new_nb_items_selected);    
      nb_items_selected_value = new_nb_items_selected;
    });

    // Met à jour le nombre d'item sélectionnés
    if(selector_step_progressions.length) {
      nb_items_selected_texts.each(function() {
        var nb_items_selected_text = $(this);
  
        nb_items_selected_text.text(nb_items_selected_value);
      });
    }
  }
  
  // Ajoute un item de progression
  function addStepProgressionItem($this) {
    var section_page = $this.closest('.section__page'),
        selector_step_progressions = $('.selector-step-progression'),       
        nb_items_selected_texts = $('.nb-items-selected'),
        nb_items_selected_value = 0,
        item_product = $this.closest('.item-product'),
        item_tags = item_product.data('product-tags');

    selector_step_progressions.each(function() {
      var selector_step_progression = $(this),
          nb_items_selected = parseInt(selector_step_progression.attr('data-nb-items-selected')),
          step = parseInt(selector_step_progression.attr('data-step')),
          new_nb_items_selected = nb_items_selected + step,
          selected_slot = selector_step_progression.find('.step-progression-item:not(.selected)').first(),
          tag = selector_step_progression.attr('data-tag');

      if(item_tags.indexOf(tag) != -1) {
        // Ajoute la couleur et les attributs d'un item de progression
        selected_slot.addClass('selected');
        selected_slot.css('background', 'var(--accent-color)');
        selected_slot.attr('data-product-handle', item_product.data('item-handle'));
        selected_slot.attr('data-variant-id', item_product.data('variant-id'));
        selected_slot.attr('data-variant-sku', item_product.data('variant-sku'));
        selected_slot.attr('data-product-title', item_product.data('product-title'));

        // Met à jour le nombre d'item sélectionnés par catégorie
        var nb_cat_items_selected_text = selector_step_progression.find('.nb-cat-items-selected'),
            old_nb_cat_items_selected = parseInt(nb_cat_items_selected_text.text()),
            new_nb_cat_items_selected = old_nb_cat_items_selected + step;

        nb_cat_items_selected_text.text(new_nb_cat_items_selected);
      }
        
      // Met à jour le nombre d'item sélectionnés
      selector_step_progression.data('nb-items-selected', new_nb_items_selected); 
      selector_step_progression.attr('data-nb-items-selected', new_nb_items_selected);
      nb_items_selected_value = new_nb_items_selected;
    });

    // Met à jour le nombre d'item sélectionnés
    if(selector_step_progressions.length) {
      nb_items_selected_texts.each(function() {
        var nb_items_selected_text = $(this);
  
        nb_items_selected_text.text(nb_items_selected_value);
      });
    }
  }

  // Met à jour le prix de la sélection dans l'encart d'abonnement
  function updateSubscriptionPrices($this) {
    var main = $this.closest('.main'),
        product_subscriptions = main.find('.product__subscription');

    product_subscriptions.each(function() {
      var product_subscription = $(this),
          product_form = product_subscription.closest('.product__form'),
          smartrr_unique_id = product_form.attr('data-smartrr-form-id');

      if(window.smartrrProductList && window.smartrrProductList[smartrr_unique_id]) {
        var product_info = window.smartrrProductList[smartrr_unique_id];
    
        product_info.ui.logic.apiChangePlan(product_info.ui.logic.apiGetCurrentCopy().planId);
      }
    });
  }
  
  // Désactive les boutons "+" et les boutons "Ajouter" dans un item product selector
  function disableAddButtons(section_page) {
    const elkadAddButtons = section_page.find('.elkad-quick-add-to-cart__add, .elkad-quick-add-to-cart__add-button');

    elkadAddButtons.each(function() {
      const button = $(this);

      button.attr('disabled', 'disabled');
    });

    var add_buttons = section_page.find('.button--quantity-add'),
        product_buttons = section_page.find('.button[data-action="show-product-quantity"]');
    
    add_buttons.each(function() {
      var button = $(this);
      
      button.attr('disabled', 'disabled');
    });
    
    product_buttons.each(function() {
      var button = $(this);
      
      button.attr('disabled', 'disabled');
    });
  }
  
  // Active les boutons "+" et les boutons "Ajouter" dans un item product selector
  function enableAddButtons(section_page) {
    const elkadAddButtons = section_page.find('.elkad-quick-add-to-cart__add, .elkad-quick-add-to-cart__add-button');

    elkadAddButtons.each(function() {
      const button = $(this);

      button.removeAttr('disabled', 'disabled');
    });
    
    var add_buttons = section_page.find('.button--quantity-add[disabled="disabled"]'),
        product_buttons = section_page.find('.button[data-action="show-product-quantity"][disabled]');
    
    add_buttons.each(function() {
      var button = $(this);
      
      if(!button.hasClass('sold-out')) {
        button.removeAttr('disabled');
      }
    });
    
    product_buttons.each(function(index) {
      var button = $(this),
          add_button = add_buttons.eq(index);
      
      if(!add_button.hasClass('sold-out')) {
        button.removeAttr('disabled');
      }
    });
  }

  // Affiche la section fixed contenant le cta sur mobile
  function showAddToCartSection($this) {
    var section_fixed = $('.section--footer-fixed');

    if(window.innerWidth < 1025) {
      section_fixed.slideDown();
    }
  }
  
  // Désactive le bouton pour ajouter une liste de produits au panier
  function disableAddToCartButton($this) {
    var section_page = $this.closest('.section__page'),
        add_to_cart_buttons = section_page.find('[data-action="add-to-cart-products-list"]'),
        items_product = section_page.find('.item-product-selector'),
        disable_button = true;

    if(add_to_cart_buttons.length == 0) {
      add_to_cart_buttons = $('[data-action="add-to-cart-selector-products"]');
    }
    
    if(add_to_cart_buttons.length) {
      items_product.each(function() {
        var item_product = $(this),
            product_quantity = item_product.find('.product__quantity'),
            quantity_item = product_quantity.find('.product__quantity-value'),
            quantity_value = parseInt(quantity_item.text());
        
        if(quantity_value > 0) {
          disable_button = false;
        }
      });

      if($this.closest('.item-product[data-item-template-suffix="omad"]').length) {
        disable_button = true;
      }
      
      if(disable_button) {
        add_to_cart_buttons.each(function() {
          var add_to_cart_button = $(this);

          if(add_to_cart_button.attr('data-disabled') == 'true') {
            add_to_cart_button.attr('disabled', 'disabled');
          }
        });
      }
    }
  }
  
  // Active le bouton pour ajouter une liste de produits au panier
  function enableAddToCartButton($this) {
    var section_page = $this.closest('.section__page'),
        add_to_cart_buttons = section_page.find('[data-action="add-to-cart-products-list"]');

    if(add_to_cart_buttons.length == 0) {
      add_to_cart_buttons = $('[data-action="add-to-cart-selector-products"]');
    }
  
    if(add_to_cart_buttons.length) {
      add_to_cart_buttons.removeAttr('disabled');
    }
  }

  // Met à jour le prix dans le bouton général pour ajouter au panier
  function updateAddToCartButton($this) {
    var section_page = $this.closest('.section__page'),
        add_to_cart_buttons = section_page.find('[data-action="add-to-cart-products-list"]');

    if(add_to_cart_buttons.length == 0) {
      add_to_cart_buttons = $('[data-action="add-to-cart-selector-products"]');
    }

    add_to_cart_buttons.each(function() {
      var add_to_cart_button = $(this),
          button_price = add_to_cart_button.find('.button-price'),
          total_price = parseInt(button_price.attr('data-total-price')),
          item_product = $this.closest('.item-product'),
          item_product_price = parseInt(item_product.data('variant-price')),
          step = parseInt($this.closest('.product__quantity-wrapper').data('step')),
          new_total_price = total_price;
    
      if(add_to_cart_button.length && button_price.length) {
        if($this.hasClass('button--quantity-add')) {
          new_total_price = total_price + (item_product_price * step);
        } else if($this.hasClass('button--quantity-sub')) {
          new_total_price = total_price - (item_product_price * step);
        }
  
        var new_total_price_formatted = convertToPriceFormat(new_total_price);
        
        button_price.data('total-price', new_total_price);
        button_price.attr('data-total-price', new_total_price);
        button_price.find('.button-price-value').text(new_total_price_formatted);
  
        if(new_total_price > 0) {
          button_price.removeClass('hidden');
        } else {
          button_price.addClass('hidden');
        }
      }
    });
  }
  
  // Désactive le bouton pour passer à l'étape suivante du sélecteur
  function disableNextButton(section_page) {
    var button_next_step = section_page.find('[data-action="selector-next-step"]');

    if(button_next_step.length == 0) {
      button_next_step = $('[data-action="selector-next-step-add-to-cart"]');
    }

    if(button_next_step.length) {
      button_next_step.attr('disabled', 'disabled');
    } else {
      var buttons_next_step = $('[data-action="selector-next-step"]');

      buttons_next_step.each(function() {
        var button_next_step = $(this),
            section_page = button_next_step.closest('.section__page');

        if(section_page.hasClass('slick-current')) {
          button_next_step.attr('disabled', 'disabled');
        }
      });
    }
  }
  
  // Active le bouton pour passer à l'étape suivante du sélecteur
  function enableNextButton(section_page) {
    var button_next_step = section_page.find('[data-action="selector-next-step"]');

    if(button_next_step.length == 0) {
      button_next_step = $('[data-action="selector-next-step-add-to-cart"]');
    }

    if(button_next_step.length) {
      button_next_step.removeAttr('disabled');
      //scrollToElement(button_next_step);
    } else {
      var buttons_next_step = $('[data-action="selector-next-step"]');

      buttons_next_step.each(function() {
        var button_next_step = $(this),
            section_page = button_next_step.closest('.section__page');

        if(section_page.hasClass('slick-current')) {
          button_next_step.removeAttr('disabled');
        }
      });
    }
  }

  // Met à jour le prix dans le bouton pour passer à l'étape suivante du sélecteur
  function updateNextButton($this) {
    var buttons_next_step = $('[data-action="selector-next-step"], [data-action="add-to-cart-selector"], [data-action="selector-next-step-add-to-cart"]');

    if(buttons_next_step.length) {
      if(isCurrentStep('flavors')) {
        var item_variant = $this.closest('.item-variant'),
            item_variant_first = $('.list-variants').first().find('.item-variant').first(),
            item_variant_last = $('.list-variants').first().find('.item-variant').last();

        if(item_variant.length == 0) {
          item_variant = item_variant_last;
        }

        var item_variant_first_price = parseInt(item_variant_first.data('variant-price')),
            item_variant_last_price = parseInt(item_variant_last.data('variant-price')),
            price_difference = item_variant_last_price - item_variant_first_price,
            item_variant_first_price_compare = parseInt(item_variant_first.data('variant-compare-at-price')),
            item_variant_last_price_compare = parseInt(item_variant_last.data('variant-compare-at-price')),
            price_difference_compare = item_variant_last_price_compare - item_variant_first_price_compare;
      } else if(isCurrentStep('shakers')) {
        var item_product = $this.closest('.item-product'),
            item_product_price = parseInt(item_product.data('variant-price')),
            item_product_price_compare = parseInt(item_product.data('variant-compare-at-price')),
            step = 1;
  
        if(item_product_price <= 990) {
          item_product_price = 0;
          item_product_price_compare = 0;
        }
      } else if(isCurrentStep('addons')) {
        var item_product = $this.closest('.item-product'),
            item_product_price = parseInt(item_product.data('variant-price')),
            item_product_price_compare = parseInt(item_product.data('variant-compare-at-price')),
            step = 1;
      } else {
        
      }
  
      buttons_next_step.each(function() {
        var button_next_step = $(this),
            button_price = button_next_step.find('.button-price'),
            total_price = parseInt(button_price.attr('data-total-price')),
            total_price_compare = parseInt(button_price.attr('data-total-price-compare')),
            new_total_price = total_price,
            new_total_price_compare = total_price_compare;
  
        if(button_price.length) {
          if(isCurrentStep('flavors')) {
            if(item_variant.data('variant-id') == item_variant_first.data('variant-id')) {
              new_total_price = total_price - price_difference;
              new_total_price_compare = total_price_compare - price_difference_compare;
            } else if(item_variant.data('variant-id') == item_variant_last.data('variant-id')) {
              new_total_price = total_price + price_difference;
              new_total_price_compare = total_price_compare + price_difference_compare;
            }
          } else if(isCurrentStep('shakers')) {
            if(item_product.hasClass('selected') || item_product.hasClass('elkad-item-product-selector--selected')) {
              new_total_price = total_price + (item_product_price * step);
              new_total_price_compare = total_price_compare + (item_product_price_compare * step);
            } else {
              new_total_price = total_price - (item_product_price * step);
              new_total_price_compare = total_price_compare - (item_product_price_compare * step);
            }
          } else if(isCurrentStep('addons')) {    
            if($this.hasClass('button--quantity-add') || $this.attr('data-action') == 'add-addon') {
              new_total_price = total_price + (item_product_price * step);
              new_total_price_compare = total_price_compare + (item_product_price_compare * step);
            } else if($this.hasClass('button--quantity-sub') || $this.attr('data-action') == 'sub-addon') {
              new_total_price = total_price - (item_product_price * step);
              new_total_price_compare = total_price_compare - (item_product_price_compare * step);
            }
          } else {
            
          }
          
          var new_total_price_formatted = convertToPriceFormat(new_total_price),
              new_total_price_compare_formatted = convertToPriceFormat(new_total_price_compare);
          
          button_price.data('total-price', new_total_price);
          button_price.attr('data-total-price', new_total_price);
          button_price.find('.button-price-value').text(new_total_price_formatted);
          button_price.data('total-price-compare', new_total_price_compare);
          button_price.attr('data-total-price-compare', new_total_price_compare);

          if(new_total_price_compare > new_total_price) {
            button_price.find('.button-original-price-value').text(new_total_price_compare_formatted);
          } else {
            button_price.find('.button-original-price-value').text('');
          }
        }
      });
    }
  }
  
  // Affiche une popup pour suggérer l'option perso (#SoShape)
  function showUpgradePopup(section_page) {
    var list_variants_challenge = section_page.find('.list-variants-challenge'),
      	items_variant = list_variants_challenge.find('.item-variant-challenge'),
        item_variant_selected = list_variants_challenge.find('.item-variant-challenge.selected'),
        item_variant_selected_sku = item_variant_selected.data('variant-sku');
    
    if(items_variant.length > 1 && item_variant_selected_sku.indexOf('CUSTOM') == -1) {
      openModalWithId('modal-upgrade-challenge');
    }
  }
  
  // Vérifie si on doit afficher ou réactiver des boutons
  function checkSelectorButtons($this) {
    var section_page  = $this.closest('.section__page'),
        selector_step_progression = $('.selector-step-progression').eq(0),
        nb_items_max = parseInt(selector_step_progression.attr('data-nb-meals')),
        nb_items_selected = parseInt(selector_step_progression.attr('data-nb-items-selected'));

    if(selector_step_progression.length == 0) {
      var selector_summary = $('.selector-summary').eq(0),
          step = parseInt($this.closest('.product__quantity-wrapper').attr('data-step')),
          nb_items_max = parseInt(selector_summary.attr('data-nb-items-max')),
          nb_items_max = nb_items_max * step,
          nb_items_selected = parseInt(selector_summary.attr('data-nb-items-selected'));
    }

    const elkadQuickAddToCart = $this.closest('.elkad-quick-add-to-cart');

    if(elkadQuickAddToCart.length && elkadQuickAddToCart.hasClass('elkad-quick-add-to-cart--limit-to-one-select')) {
      nb_items_max = 1;
      nb_items_selected = section_page.find('.elkad-item-product-selector--selected').length;
    }
    
  	// Si le nombre d'items sélectionnés est inférieur au nombre maximums d'items sélectionnable
    if(nb_items_selected < nb_items_max) {
      enableAddButtons(section_page);
      disableAddToCartButton($this);
      disableNextButton(section_page);
    }
  }
  
  // Vérifie si on a atteind le maximum d'items sélectionnables
  function checkMaximumSelection($this) {
    var section_page  = $this.closest('.section__page'),
        selector_step_progression = $('.selector-step-progression').eq(0),
        nb_items_max = parseInt(selector_step_progression.attr('data-nb-meals')),
        nb_items_selected = parseInt(selector_step_progression.attr('data-nb-items-selected'));

    if(selector_step_progression.length == 0) {
      var selector_summary = $('.selector-summary').eq(0),
          step = parseInt($this.closest('.product__quantity-wrapper').attr('data-step')),
          nb_items_max = parseInt(selector_summary.attr('data-nb-items-max')),
          nb_items_max = nb_items_max * step,
          nb_items_selected = parseInt(selector_summary.attr('data-nb-items-selected'));
    }

    const elkadQuickAddToCart = $this.closest('.elkad-quick-add-to-cart');

    if(elkadQuickAddToCart.length && elkadQuickAddToCart.hasClass('elkad-quick-add-to-cart--limit-to-one-select')) {
      nb_items_max = 1;
      nb_items_selected = section_page.find('.elkad-item-product-selector--selected').length;
    }
    
  	// Si le nombre d'items sélectionnés est égal (ou supérieur) au nombre maximums d'items sélectionnable
    if(nb_items_selected >= nb_items_max) {
      disableAddButtons(section_page);
      enableAddToCartButton($this);
      enableNextButton(section_page);
      showUpgradePopup(section_page);
    }
  }
  
  // Désélectionne un shaker et active les autres (#SoShape)
  function unSelectShaker($this, item_product) {
    var section_snippet = item_product.closest('.section__snippet'),
        button_text = $this.data('button-text');
    
	section_snippet.find('.item-product').removeClass('disabled');
    item_product.removeClass('selected');
    $this.find('span').text(button_text);
  }
  
  // Sélectionne un shaker et désactive les autres (#SoShape)
  function selectShaker($this, item_product) {
    var section_snippet = item_product.closest('.section__snippet'),
        button_text = window.languages.addedProductButton;

    section_snippet.find('.item-product.selected').find('[data-action="select-product"]').trigger('click');
    section_snippet.find('.item-product').addClass('disabled');    
    section_snippet.find('.item-product').removeClass('selected');
    item_product.removeClass('disabled').addClass('selected');
    $this.find('span').text(button_text);
  }
  
  // Choisit le shaker du sélecteur (#SoShape)
  function chooseSelectorShaker($this) {
    var section_page = $this.closest('.section__page'),
        item_product = $this.closest('.item-product');
    
    if(item_product.hasClass('selected')) {
      unSelectShaker($this, item_product);
      deleteSummaryItem($this);
      disableNextButton(section_page);
    } else {  
      selectShaker($this, item_product);
      addSummaryItem($this);
      enableNextButton(section_page);
	  }
  }

  // Choisit le shaker du sélecteur (#SoShape)
  function elkadChooseSelectorShaker($this) {
    var section_page = $this.closest('.section__page'),
        item_product = $this.closest('.item-product');

    const quantity = item_product.find('.elkad-quick-add-to-cart__input').val();
    const allNonSelectedItems = section_page.find('.item-product').not(item_product);
    const allItems = section_page.find('.item-product');

    if (quantity == 1) {
      allNonSelectedItems.each(function() {
        const item = $(this);

        item.find('.elkad-quick-add-to-cart__input').val(0);
        item.find('.elkad-quick-add-to-cart__add, .elkad-quick-add-to-cart__add-button').attr('disabled', 'disabled');
      });

      item_product.find('.elkad-quick-add-to-cart__add, .elkad-quick-add-to-cart__add-button').attr('disabled', 'disabled');

      addSummaryItem($this);
      enableNextButton(section_page);
    } else if (quantity == 0) {
      allItems.each(function() {
        const item = $(this);

        item.find('.elkad-quick-add-to-cart__input').val(0);
        item.find('.elkad-quick-add-to-cart__add, .elkad-quick-add-to-cart__add-button').removeAttr('disabled');
      });

      deleteSummaryItem($this);
      disableNextButton(section_page);
    } else {
      alert("Vous ne pouvez sélectionner qu'un seul shaker.");

      allItems.each(function() {
        const item = $(this);

        item.find('.elkad-quick-add-to-cart__input').val(0);
        item.find('.elkad-quick-add-to-cart__add, .elkad-quick-add-to-cart__add-button').removeAttr('disabled');
      });
      deleteSummaryItem($this);
      disableNextButton(section_page);
    }
  }
  
  // Au clic sur le bouton - de la quantité dans un item product selector 
  function _clickProductItemSubQuantityListener($this, e) {
    if (e) {
      e.preventDefault();
    }

    subQuantity($this);
    hideProductQuantity($this);
    deleteSummaryItem($this);    
    updateSubscriptionPrices($this);
    disableAddToCartButton($this);
    updateAddToCartButton($this);
    updateNextButton($this);
  }
  
  // Au clic sur le bouton + de la quantité dans un item product selector
  function _clickProductItemAddQuantityListener($this, e) {
    if (e) {
      e.preventDefault();
    }

    addQuantity($this);
    addSummaryItem($this);
    updateSubscriptionPrices($this);    
    showAddToCartSection($this);
    enableAddToCartButton($this);
    updateAddToCartButton($this);
    updateNextButton($this);
  } 
  
  // Au clic sur le bouton - de la quantité dans un item product selector de type flavor
  function _clickProductItemFlavorSubQuantityListener($this, e) {
    if (e) {
      e.preventDefault();

      subQuantity($this);
    }
    
    hideProductQuantity($this);
    deleteSummaryItem($this);
    deleteStepProgressionItem($this);
    checkSelectorButtons($this);
  }
  
  // Au clic sur le bouton + de la quantité dans un item product selector de type flavor
  function _clickProductItemFlavorAddQuantityListener($this, e) {
    e.preventDefault();
    addQuantity($this);
    addSummaryItem($this);
    addStepProgressionItem($this); 
    showAddToCartSection($this);
    checkMaximumSelection($this);
  } 
  
  // Au clic sur le bouton "Ajouter" dans un item product selector
  function _clickShowProductQuantityListener($this, e) {
    e.preventDefault();
    showProductQuantity($this);
  } 
  
  // Au clic sur le bouton "Ajouter" dans un item product selector de type shaker
  function _clickShakerSelectListener($this, e) {
    if (e) {
      e.preventDefault();
    }

    if ($this.closest('.elkad-quick-add-to-cart').length > 0) {
      elkadChooseSelectorShaker($this);
    } else {
      chooseSelectorShaker($this);
    }
    updateSubscriptionPrices($this);
    updateNextButton($this);
  }
  
  // Au clic sur le bouton - de la quantité dans un item product selector
  $(document).on('click', '.item-product-selector:not([data-item-template-suffix="flavor"]):not([data-item-template-suffix="omad"]) [data-action="sub-product"]', function(e) {
	_clickProductItemSubQuantityListener($(this), e);
  });
  
  // Au clic sur le bouton + de la quantité dans un item product selector
  $(document).on('click', '.item-product-selector:not([data-item-template-suffix="flavor"]):not([data-item-template-suffix="omad"]) [data-action="add-product"]', function(e) {
    _clickProductItemAddQuantityListener($(this), e);
  });
  
  // Au clic sur le bouton - de la quantité dans un item product selector de type flavor
  $(document).on('click', '.item-product-selector[data-item-template-suffix="flavor"] [data-action="sub-product"]:not(.elkad-quick-add-to-cart__remove)', function(e) {
	_clickProductItemFlavorSubQuantityListener($(this), e);
  });
  
  // Au clic sur le bouton + de la quantité dans un item product selector de type flavor
  $(document).on('click', '.item-product-selector[data-item-template-suffix="flavor"] [data-action="add-product"]', function(e) {
	_clickProductItemFlavorAddQuantityListener($(this), e);
  });

  // Au clic sur le bouton - de la quantité dans un item product selector de type omad
  $(document).on('click', '.item-product-selector[data-item-template-suffix="omad"] [data-action="sub-product"]', function(e) {
	_clickProductItemFlavorSubQuantityListener($(this), e);
  });
  
  // Au clic sur le bouton + de la quantité dans un item product selector de type omad
  $(document).on('click', '.item-product-selector[data-item-template-suffix="omad"] [data-action="add-product"]', function(e) {
	_clickProductItemFlavorAddQuantityListener($(this), e);
  });
  
  // Au clic sur le bouton "Ajouter" dans un item product selector
  $(document).on('click', '.item-product-selector [data-action="show-product-quantity"]', function(e) {
	_clickShowProductQuantityListener($(this), e);
  });
  
  // Au clic sur le bouton "Ajouter" dans un item product selector de type shaker
  $(document).on('click', '.item-product-selector[data-item-template-suffix="shaker"] [data-action="select-product"]', function(e) {
	_clickShakerSelectListener($(this), e);
  });

  // Au clic sur le bouton "Ajouter" dans un item product selector de type bowl
  $(document).on('click', '.item-product-selector[data-item-template-suffix="bowl"] [data-action="select-product"]', function(e) {
	_clickShakerSelectListener($(this), e);
  });
  
  /**
   * SNIPPET - ITEM VARIANT CHALLENGE
   */
  
  // Sélectionne une option (#SoShape)
  function selectOption($this) {
  	var item_variant = $this.closest('.item-variant');
    
    if(item_variant.length == 0) {
      item_variant = $('.list-variants').first().find('.item-variant').last();
    }

    var item_variant_input = item_variant.find('.variant__input').find('.input-radio');

    item_variant.closest('.section__snippet').find('.item-variant.selected').removeClass('selected');
    item_variant.addClass('selected');
    item_variant_input.trigger('click');
  }
  
  // Convertit la quantité d'une option en l'équivalent d'une autre option (#SoShape)
  function convertQuantityFromOption(quantity_value, old_step, new_step, limit) {
  	var new_quantity_value = (parseFloat(quantity_value) / parseFloat(old_step)) * new_step;

    if(limit != 'none' && new_quantity_value > limit) {
      new_quantity_value = limit;
    }

    return new_quantity_value;
  }
  
  // Met à jour la quantité de chaque saveur sélectionnée et leur step (#SoShape)
  function updateFlavorItemsQuantity(section_page, new_item_variant, old_item_variant) {
    var items_product = section_page.find('.item-product'),
        new_step = new_item_variant.data('step'),
        old_step = old_item_variant.data('step');
    
    items_product.each(function() {
      var item_product = $(this),
          quantity = item_product.find('.product__quantity');

      const elkadQuickAddToCart = item_product.find('.elkad-quick-add-to-cart');

      if(elkadQuickAddToCart.length > 0) {
        quantity_wrapper = elkadQuickAddToCart;
        quantity_min = 0;
        quantity_item = elkadQuickAddToCart.find('.elkad-quick-add-to-cart__input');
        quantity_value = parseInt(quantity_item.val());

        const quantity_button = elkadQuickAddToCart.find('.elkad-quick-add-to-cart__add-button');
        const quantity_add = elkadQuickAddToCart.find('.elkad-quick-add-to-cart__add');
        const quantity_decrease = elkadQuickAddToCart.find('.elkad-quick-add-to-cart__decrease');

        quantity_add.attr('data-step', new_step);
        quantity_decrease.attr('data-step', new_step);
        quantity_button.attr('data-step', new_step);
      } else {
        var quantity_wrapper = quantity.find('.product__quantity-wrapper'),
        quantity_min = parseInt(quantity_wrapper.data('min')),
        quantity_item = quantity_wrapper.find('.product__quantity-value'),
        quantity_value = parseInt(quantity_item.text());
      
        // Met à jour le step de la quantité
        quantity_wrapper.data('step', new_step);
        quantity_wrapper.attr('data-step', new_step);
      }
      
      // Met à jour la valeur de la quantité
      if(quantity_value > quantity_min) {
      	var new_quantity_value = convertQuantityFromOption(quantity_value, old_step, new_step, 'none');

        if (elkadQuickAddToCart.length > 0) {
          quantity_item.val(new_quantity_value);
        } else {
          quantity_item.text(new_quantity_value);
        }
      }
    });
  }
  
  // Met à jour l'ordre des éléments de progression (#SoShape)
  function updateStepProgressionItemsOrder(selector_step_progression) {
    var step_progression_items = selector_step_progression.find('.step-progression-item'),
        step_progression_items_size = step_progression_items.length;
    
    step_progression_items.each(function(index) {
      var step_progression_item = $(this),
          step_number = index,
          z_index = step_progression_items_size - 1 - index;
      
      step_progression_item.data('step-number', step_number);
      step_progression_item.attr('data-step-number', step_number);
      step_progression_item.css('--z-index', z_index);
    });
  }
  
  // Ajoute les items de progression (#SoShape)
  function addStepProgressionItems(section_page, new_item_variant, old_item_variant) {
    var selector_step_progressions = $('.selector-step-progression'),
      new_nb_items_max = new_item_variant.data('nb-items-max'),
    	old_nb_items_max = old_item_variant.data('nb-items-max'),   	
    	nb_items_difference = Math.abs(new_nb_items_max - old_nb_items_max);
    
    // Ajoute un item à la barre de progression
    selector_step_progressions.each(function() {
      var selector_step_progression = $(this),
    	  selector_step_progression_inner = selector_step_progression.find('.selector-step-progression--inner');
      
      for (var i = 0; i < nb_items_difference; i++) {
        var step_number = selector_step_progression.find('.step-progression-item').length + 1,
            step_progression_item_html = '<span class="step-progression-item" data-step-number="' + step_number + '" style="--z-index: ' + step_number + ';"></span>';
        
        selector_step_progression_inner.append(step_progression_item_html);
      }
      
      // Met à jour leur propriété "z-index"
      updateStepProgressionItemsOrder(selector_step_progression);
    });
  }
  
  // Supprime les items de progression (#SoShape)
  function deleteStepProgressionItems(section_page, new_item_variant, old_item_variant) {
    var selector_step_progression_wrappers = $('.selector-step-progression-wrapper'),
      selector_step_progressions = $('.selector-step-progression'),
      new_nb_items_max = new_item_variant.data('nb-items-max'),
    	old_nb_items_max = old_item_variant.data('nb-items-max'),   	
    	nb_items_difference = Math.abs(new_nb_items_max - old_nb_items_max),
      new_step = new_item_variant.data('step');

    // Supprime les dots sélectionnés qui dépassent la limite 
    selector_step_progression_wrappers.each(function() {
      var selector_step_progression_wrapper = $(this),
          selected_step_progression_items = selector_step_progression_wrapper.find('.step-progression-item.selected'),
          nb_items_selected = selected_step_progression_items.length,	
          nb_items_difference = nb_items_selected - new_nb_items_max;

      if(nb_items_difference > 0) {
        for (var i = 0; i < nb_items_difference; i++) {
          var last_step_progression_item = selected_step_progression_items.last(),
              last_step_progression_item_variant_id = last_step_progression_item.data('variant-id'),
              item_product = section_page.find('.item-product[data-variant-id="' + last_step_progression_item_variant_id + '"]'),
              quantity_item = item_product.find('.elkad-quick-add-to-cart__input');
    
          if (item_product.find('.elkad-quick-add-to-cart').length > 0) {
            var quantity_value = parseInt(quantity_item.val()) - new_step;
            // Met à jour la quantité de la saveur à supprimer
            quantity_item.val(quantity_value);
            
            // Si la nouvelle quantité est égale (ou inférieure) à 0
            if(quantity_value <= 0) {
              item_product.removeClass("elkad-item-product-selector--selected");
              item_product.find('.elkad-quick-add-to-cart__quantity-container').addClass('hide');
              item_product.find('.elkad-quick-add-to-cart__add-button').removeClass('hide');
            }
          }

          // Retire la couleur et les attributs d'un item de progression
          last_step_progression_item.removeClass('selected');
          last_step_progression_item.css('background', last_step_progression_item.closest('.selector-step-progression').data('color-bg'));
          last_step_progression_item.removeAttr('data-product-handle');
          last_step_progression_item.removeAttr('data-variant-id');
          last_step_progression_item.removeAttr('data-variant-sku');
          last_step_progression_item.removeAttr('data-product-title');

          // Met à jour le tableau d'items sélectionnés
          selected_step_progression_items = selector_step_progression_wrapper.find('.step-progression-item.selected');          
        }
      }
    });

    // Supprime les dots en trop par rapport au nombre de saveurs maximum
    selector_step_progressions.each(function() {
      var selector_step_progression = $(this),
    	  selector_step_progression_inner = selector_step_progression.find('.selector-step-progression--inner');
      
      for (var i = 0; i < nb_items_difference; i++) {
        var last_step_progression_item = selector_step_progression_inner.children().last();   
        
        // Supprime un item de la barre de progression
        last_step_progression_item.remove();
      }

      // Met à jour leur propriété "z-index"
      updateStepProgressionItemsOrder(selector_step_progression);
    });
  }

  // Met à jour les infos de la barre de progression (#SoShape)
  function updateStepProgressionBar(section_page, new_item_variant, old_item_variant) {
    var selector_step_progressions = $('.selector-step-progression'),       
        nb_items_selected_texts = $('.nb-items-selected'),
        nb_items_selected_value = 0,
        new_step = new_item_variant.data('step'),
        old_step = old_item_variant.data('step'),
        new_nb_items_max = new_item_variant.data('nb-items-max');
    
    selector_step_progressions.each(function() {
      var selector_step_progression = $(this),
          nb_items_selected = selector_step_progression.parent().find('.step-progression-item.selected').length,
          new_nb_items_selected = nb_items_selected * new_step;
      
      selector_step_progression.data('step', new_step);
      selector_step_progression.attr('data-step', new_step);
      selector_step_progression.data('nb-items-max', new_nb_items_max);
      selector_step_progression.attr('data-nb-items-max', new_nb_items_max); 
      selector_step_progression.data('nb-items-selected', new_nb_items_selected);
      selector_step_progression.attr('data-nb-items-selected', new_nb_items_selected);
      nb_items_selected_value = new_nb_items_selected;

      // Met à jour le nombre d'item sélectionnés par catégorie
      var nb_cat_items_selected_text = selector_step_progression.find('.nb-cat-items-selected'),
          nb_cat_items_selected = selector_step_progression.find('.step-progression-item.selected').length,
          new_nb_cat_items_selected = nb_cat_items_selected * new_step;

      nb_cat_items_selected_text.text(new_nb_cat_items_selected);
    });

    // Met à jour le nombre d'item sélectionnés
    nb_items_selected_texts.each(function() {
      var nb_items_selected_text = $(this);

      nb_items_selected_text.text(nb_items_selected_value);
    });
  }
  
  // Upgrade un challenge (#SoShape)
  function upgradeChallenge(new_item_variant, old_item_variant) {
    var section_page = new_item_variant.closest('.section__page');
    
    updateFlavorItemsQuantity(section_page, new_item_variant, old_item_variant);
    addStepProgressionItems(section_page, new_item_variant, old_item_variant);
    updateStepProgressionBar(section_page, new_item_variant, old_item_variant);
    
    // Si le nombre d'items sélectionnés est inférieur au nombre maximum d'items sélectionnable
    enableAddButtons(section_page);
    disableNextButton(section_page);
  }
  
  // Downgrade un challenge (#SoShape)
  function downgradeChallenge(new_item_variant, old_item_variant) {
    var section_page = new_item_variant.closest('.section__page');
    
    updateFlavorItemsQuantity(section_page, new_item_variant, old_item_variant);
    deleteStepProgressionItems(section_page, new_item_variant, old_item_variant);
    updateStepProgressionBar(section_page, new_item_variant, old_item_variant);
    
    // Si le nombre d'items sélectionnés est inférieur au nombre maximum d'items sélectionnable
    var selector_step_progression = $('.selector-step-progression').eq(0),
    	nb_meals = parseInt(selector_step_progression.attr('data-nb-meals')),
      nb_items_selected = parseInt(selector_step_progression.attr('data-nb-items-selected'));
    
    if(nb_items_selected < nb_meals) {
      enableAddButtons(section_page);
      disableNextButton(section_page);
    } else {
      disableAddButtons(section_page);
      enableNextButton(section_page);
    }
  }
  
  // Upgrade ou downgrade un challenge (#SoShape)
  function upgradeOrDowngradeChallenge($this) {
    var new_item_variant = $this.closest('.item-variant');
    
    if(new_item_variant.length == 0) {
      new_item_variant = $('.list-variants').first().find('.item-variant').last();
    }
    
    var old_item_variant = new_item_variant.parent().siblings().first().find('.item-variant'),
    	old_nb_items_max = parseInt(old_item_variant.data('nb-items-max')),
    	new_nb_items_max = parseInt(new_item_variant.data('nb-items-max'));
    
    if(new_nb_items_max > old_nb_items_max) {
      upgradeChallenge(new_item_variant, old_item_variant);
    } else {
      downgradeChallenge(new_item_variant, old_item_variant);
    }
  }
  
  // Au clic sur un item variant challenge dans le sélecteur
  function _clickItemOptionSelectorListener($this, e) {
    e.preventDefault();
    selectOption($this);
    upgradeOrDowngradeChallenge($this);
    updateNextButton($this);
  }
  
  // Au clic sur un bouton pour upgrader un challenge
  function _clickUpgradeChallengeListener($this, e) {
    e.preventDefault();
    closeModal($this);
    
    if(window.innerWidth < 1025) {
      scrollToTop();
    }
    
    selectOption($this);
    upgradeOrDowngradeChallenge($this);
    updateNextButton($this);
  }
  
  // Au clic sur un item variant challenge dans le sélecteur
  $(document).on('click', '[data-item-action="select-option-selector"]:not(.selected)', function(e) {
    _clickItemOptionSelectorListener($(this), e);
  });
  
  // Au clic sur un bouton pour upgrader un challenge
  $(document).on('click', '[data-action="upgrade-challenge"]', function(e) {
	_clickUpgradeChallengeListener($(this), e);
  });

  /**
   * SNIPPET - LOGIN FORM
   */

  // Affiche le formulaire pour récupérer son mot de passe
  function toggleRecoverForm($this) {
    var title_text = window.languages.passwordRecoverTitle;
    
    if($this.hasClass('login__form--login')) {
      title_text = window.languages.loginTitle;
    }
    
    $('.section__title .title-value span').text(title_text);    
    $('.login-form, .recover-form').toggle();   
    
    return false;
  }

  // Au clic sur le lien "Mot de passe oublié"
  function _toggleRecoverFormListener($this, e) {
    e.preventDefault();
    toggleRecoverForm($this);
  }

  // Au clic sur le lien "Mot de passe oublié"
  $(document).on('click', '[data-action="toggle-recover-form"]', function(e) {
    _toggleRecoverFormListener($(this), e);
  });

  /**
   * SNIPPET - NAVIGATION HORIZONTAL
   */

  // Ouvre une liste de sous-menu
  function openNavigationHorizontalList($this) {
    var header_bar = $this.closest('.section__page.header-bar'),
        header = $this.closest('.header'),
        items_menu = header.find('.navigation-horizontal__list-item'),
        item_menu = $this.closest('.navigation-horizontal__list-item'),
        dropdown_mega_over = item_menu.find('.navigation-horizontal__dropdown--mega-over'),
        color_active = item_menu.data('color-active'),
        filter_active = item_menu.data('filter-active'),
        carousel_sections = $('.custom-section.slick-initialized'),
        sticky_column = $('.column--sticky-desktop').eq(0),
        cart_items = $('.main').find('.list-cart-items:not([data-height-desktop="0"])');

    items_menu.removeClass('navigation-horizontal__list-item--active').attr('aria-expanded', 'false')
      .find('.navigation-horizontal__dropdown-item--active').removeClass('navigation-horizontal__dropdown-item--active').attr('aria-expanded', 'false');

    if(item_menu.hasClass('navigation-horizontal__list-item--expandable')) {
      item_menu.toggleClass('navigation-horizontal__list-item--active').attr('aria-expanded', function(index, attr) {return attr === 'true' ? 'false' : 'true'});
    }

    if(dropdown_mega_over.length) {
      header_bar.addClass('header-bar--transparent');
      header.addClass('header--with-mega-nav-opened');
      header.css('--dropdown-filter-logo-active', filter_active);
      item_menu.css('--dropdown-color-text-active', color_active);
      carousel_sections.find('.slick-list').css('overflow', 'unset');
      sticky_column.css('position', 'unset');
      cart_items.css('overflow', 'unset');
    } else {
      cart_items.css('overflow', 'auto');
      sticky_column.css('position', 'sticky');
      carousel_sections.find('.slick-list').css('overflow', 'hidden');
      header.removeClass('header--with-mega-nav-opened');
      header_bar.removeClass('header-bar--transparent');
    }
    
    $(document).on('mouseover', function(e) {
      if($(e.target).closest('.section__page.header-bar').length === 0) {
        cart_items.css('overflow', 'auto');
        sticky_column.css('position', 'sticky');
        carousel_sections.find('.slick-list').css('overflow', 'hidden');
        item_menu.removeClass('navigation-horizontal__list-item--active').attr('aria-expanded', 'false');
        item_menu.find('.navigation-horizontal__dropdown-item--active').removeClass('navigation-horizontal__dropdown-item--active').attr('aria-expanded', 'false');
        header.removeClass('header--with-mega-nav-opened');
        header_bar.removeClass('header-bar--transparent');
      }
    });

    return false;
  }

  // Ouvre une dropdown de sous-menu
  function openNavigationHorizontalDropdown($this) {
    var item_menu = $this.closest('.navigation-horizontal__dropdown-item'),
        window_width = window.innerWidth,
        right_edge = $this[0].getBoundingClientRect().right,
        nested_menus = item_menu.closest('.navigation-horizontal__dropdown').find('.navigation-horizontal__dropdown'),
        should_open_left = false;

    item_menu.toggleClass('navigation-horizontal__dropdown-item--active').attr('aria-expanded', function(index, attr) {return attr === 'true' ? 'false' : 'true'});
    item_menu.siblings().removeClass('navigation-horizontal__dropdown-item--active').attr('aria-expanded', 'false');

    // Afin d'éviter les problèmes de hors écran, on vérifie tous les enfants et si au moins un d'entre eux sort de l'écran, on les ouvre à gauche à la place
    nested_menus.each(function(index, item) {
      if ((right_edge + item_menu.offsetWidth) > window_width) {
        should_open_left = true;
        return false;
      }
    });

    if(should_open_left) {
      nested_menus.addClass('navigation-horizontal__dropdown--left');
    } else {
      nested_menus.removeClass('navigation-horizontal__dropdown--left');
    }

    return false;
  }

  // Change l'image du méga menu
  function changeNavigationHorizontalImage($this) {
    var dropdown_mega = $this.closest('.navigation-horizontal__dropdown--mega'),
        dropdown_image_container = dropdown_mega.find('.navigation-horizontal__image'),
        dropdown_image = dropdown_image_container.find('img');
        image_src = $this.attr('data-src');

    dropdown_image.attr('src', image_src);
  }

  // Au clic sur un item de menu dépliant
  function _clickNavigationHorizontalListListener($this, e) {
    e.preventDefault();
    openNavigationHorizontalList($this);
  }

  // Au clic sur un item de menu dépliant d'une dropdown
  function _clickNavigationHorizontalDropdownListener($this, e) {
    e.preventDefault();
    openNavigationHorizontalDropdown($this);
  }

  // Au survol d'un lien dans un méga menu
  function _hoverNavigationHorizontalMegaMenuListener($this, e) {
    e.preventDefault();
    changeNavigationHorizontalImage($this);
  }

  // Au clic ou au hover sur un item de menu dépliant d'une liste
  $(document).on('mouseover', '.navigation-horizontal__list-item > .navigation-horizontal__list-link', function(e) {
	_clickNavigationHorizontalListListener($(this), e);
  });

  // Au clic ou au hover sur un item de menu dépliant d'une dropdown
  $(document).on('mouseover', '.navigation-horizontal__dropdown-item--expandable > .navigation-horizontal__dropdown-link', function(e) {
	_clickNavigationHorizontalDropdownListener($(this), e);
  });

  // Au survol d'un lien dans un méga menu
  $(document).on('mouseenter', '.dropdown-column__list-link[data-src]', function(e) {
	_hoverNavigationHorizontalMegaMenuListener($(this), e);
  });

  /**
   * SNIPPET - NAVIGATION SIDEBAR
   */

  // Ouvre ou ferme le menu latéral
  function toggleNavigationSidebar() {
    var html = $('html'),
        page_overlay = $('.page__overlay'),
        navigation_sidebar = $('.section__page.navigation-sidebar'),
        sidebar_contents = navigation_sidebar.find('.sidebar__contents'),
    	sidebar_height = navigation_sidebar.height(),
        sidebar_header_height = navigation_sidebar.find('.sidebar__header').height(),
        sidebar_footer_height = navigation_sidebar.find('.sidebar__footer').height(),
        sidebar_contents_height = sidebar_height - sidebar_header_height - sidebar_footer_height;

    if(Modernizr.touchevents) {
      bouncefix.add('sidebar__header');
      bouncefix.add('sidebar__contents');
    }
    
    // On doit effectuer des calculs supplémentaires pour nous assurer que le contenu complet de la barre latérale est visible
    sidebar_contents.css('max-height', sidebar_contents_height + 'px');
    
    navigation_sidebar.toggleClass('sidebar--open');
    page_overlay.toggleClass('page__overlay--open');
    html.toggleClass('no-scroll');

    if(navigation_sidebar.hasClass('sidebar--open')) {
      // Cela permet de corriger un problème sur Safari où la liste peut ne pas être focalisée
      navigation_sidebar.one('transitionend webkitTransitionEnd oTransitionEnd', function() {
        $('.navigation-sidebar__list--active').focus();
      });
      
      page_overlay.bind('click', function() {
        closeNavigationSidebar();
      });
    } else {
      page_overlay.off('click');
    }

    return false;
  }

  // Ferme le menu latéral
  function closeNavigationSidebar() {
    var html = $('html'),
        page_overlay = $('.page__overlay'),
        navigation_sidebar = $('.section__page.navigation-sidebar');
    
    navigation_sidebar.removeClass('sidebar--open');
    page_overlay.removeClass('page__overlay--open').off('click');
    html.removeClass('no-scroll');
  };

  // Ouvre la dropdown du menu mobile
  function openNextDropdown($this) {
    var item_menu = $this.closest('.navigation-sidebar__item');

    item_menu.toggleClass('navigation-sidebar__item--active').attr('aria-expanded', function(index, attr) {return attr === 'true' ? 'false' : 'true'});
    item_menu.siblings().removeClass('navigation-sidebar__item--active').attr('aria-expanded', 'false')
    .find('.navigation-sidebar__item--active').removeClass('navigation-sidebar__item--active').attr('aria-expanded', 'false');

    $(document).on('click', function(e) {
      if ($(e.target).closest('.navigation-sidebar__dropdowns').length === 0) {
        item_menu.removeClass('navigation-sidebar__item--active').attr('aria-expanded', 'false');
        item_menu.find('.navigation-sidebar__item--active').removeClass('navigation-sidebar__item--active').attr('aria-expanded', 'false');
      }
    });

    return false;
  };

  // Ouvre la liste du menu mobile
  function openNextLevel($this) {
    var navigation_sidebar = $('.section__page.navigation-sidebar'),
        navigation_sidebar_current = navigation_sidebar.find('.sidebar__current-title'),
        current_level = $this.closest('.navigation-sidebar__list'),
        sub_nav = $this.attr('data-open-nav'),
        next_level = navigation_sidebar.find('[data-nav-for="' + sub_nav + '"]');

    next_level.addClass('navigation-sidebar__list--active');
    current_level.addClass('navigation-sidebar__list--hidden');

    $('[data-action="close-navigation-sidebar"]').hide();
    $('[data-action="rewind-navigation-sidebar"]').show();

    current_level = next_level;
    navigation_sidebar_current.text(next_level.attr('data-nav-name'));

    return false;
  };

  // Revient au niveau parent du menu mobile
  function rewindNavigationSidebar($this) {
    var navigation_sidebar = $('.section__page.navigation-sidebar'),
        navigation_sidebar_current = navigation_sidebar.find('.sidebar__current-title'),
        current_level = navigation_sidebar.find('.navigation-sidebar__list.navigation-sidebar__list--active:not(.navigation-sidebar__list--hidden)'),
        parent_level = navigation_sidebar.find('[data-nav-for="' + current_level.attr('data-parent-nav') + '"]');

    current_level.removeClass('navigation-sidebar__list--active');
    parent_level.removeClass('navigation-sidebar__list--hidden');

    // Si le niveau parent n'a pas de parent, cela signifie que l'on est de retour au premier
    if (!parent_level.attr('data-parent-nav')) {
      $('[data-action="close-navigation-sidebar"]').show();
      $('[data-action="rewind-navigation-sidebar"]').hide();
      navigation_sidebar_current.text('');
    } else {
      navigation_sidebar_current.text(parent_level.attr('data-nav-name'));
    }

    current_level = parent_level;

    return false;
  };

  // Au clic sur le bouton d'ouverture ou de fermeture du menu latéral
  function _toggleNavigationSidebarListener($this, e) {
    if($this.attr('href') != '#' && window.innerWidth > 1200) {
      // Au clic sur le bouton "Shop" sur desktop
    } else {
      e.preventDefault();
      toggleNavigationSidebar();
    }
  }
  
  // Au clic sur un item de menu dépliant d'une dropdown
  function _clickMenuMobileDropdownItemListener($this, e) {
    e.preventDefault();
    openNextDropdown($this);
  }
  
  // Au clic sur un item de menu dépliant d'une liste
  function _clickMenuMobileListItemListener($this, e) {
    e.preventDefault();
    openNextLevel($this);
  }
  
  // Au clic sur le bouton "Retour" d'un item de menu dépliant d'une liste
  function _clickMenuMobileRewindListItemListener($this, e) {
    e.preventDefault();
    rewindNavigationSidebar($this);
  }

  // Au clic sur le bouton d'ouverture ou de fermeture du menu latéral
  // $(document).on('click', '[data-action="open-navigation-sidebar"], [data-action="close-navigation-sidebar"]', function(e) {
	// _toggleNavigationSidebarListener($(this), e);
  // });

  // Au clic sur un item de menu dépliant d'une dropdown
  $(document).on('click', '.navigation-sidebar__dropdowns .navigation-sidebar__item--expandable > .navigation-sidebar__link', function(e) {
	_clickMenuMobileDropdownItemListener($(this), e);
  });

  // Au clic sur un item de menu dépliant d'une liste
  $(document).on('click', '.navigation-sidebar__lists .navigation-sidebar__item--expandable > .navigation-sidebar__link', function(e) {
	_clickMenuMobileListItemListener($(this), e);
  });

  // Au clic sur le bouton "Retour" d'un item de menu dépliant d'une liste
  $(document).on('click', '[data-action="rewind-navigation-sidebar"]', function(e) {
	_clickMenuMobileRewindListItemListener($(this), e);
  });
  
  /**
   * SNIPPET - ORDER TRACKING FORM
   */
  
  // Affiche le statut d'une commande
  // function displayOrderStatus($this, e) {
  //   var order_tracking_container = $this.closest('.order-tracking-form'),
  //       order_tracking_form = order_tracking_container.find('.order-tracking__form'),
  //       order_name = order_tracking_container.find('.order-tracking__number').val(),        
  //       order_tracking_orders = order_tracking_container.find('.order-tracking__orders'),
  //       order_tracking_messages = order_tracking_container.find('.order-tracking__message'),
  //       order_tracking_message_text = '';
    
  //   e.preventDefault();
    
  //   if(order_name == '') {
  //     order_name = order_tracking_container.find('.order-tracking__number').attr('placeholder');
  //   }  
    
  //   if(order_tracking_orders.length) {
  //     var order = order_tracking_orders.find('.customer-order[data-order-name="' + order_name + '"]');
      
  //     if(order.length) {
  //     	var order_status_inner = order.find('.order__status--inner'),        
  //           tracking_link = order_status_inner.find('a'),
  //           tracking_link_html = '';
        
  //       if(tracking_link.length) {
  //         tracking_link_html = tracking_link[0].outerHTML;
  //       }           
            
  //       order_tracking_message_text = order_status_inner.data('order-tracking-message') + tracking_link_html;
  //     } else {
  //   	order_tracking_message_text = window.languages.orderNotFound;
  //     }
  //   } else {
  //     order_tracking_message_text = window.languages.noOrders;
  //   } 
      
  //   order_tracking_messages.each(function() {
  //     var order_tracking_message = $(this);
      
  //     order_tracking_message.html(order_tracking_message_text);
  //     order_tracking_message.show();
  //   });
  // }
  
  // // Au clic sur le bouton "Go" pour suivre une commande
  // function _clickOrderTrackingListener($this, e) {
  //   displayOrderStatus($this, e);
  // }
  
  // // Au clic sur le bouton "Go" pour suivre une commande
  // $(document).on('click', '.order-tracking-form__submit .button', function(e) {
  //   _clickOrderTrackingListener($(this), e);
  // });
  
  /**
   * SNIPPET - PASSWORD FORM
   */

  // Affiche le formulaire pour saisir le mot de passe du site
  function toggleStorefontPasswordForm($this) {
    var storefront_password_form = $('.password__storefront-form');
    
    storefront_password_form.slideDown();
  }

  // Au clic sur le lien pour afficher le formulaire de mot de passe du site
  function _toggleStorefontPasswordFormListener($this, e) {
    e.preventDefault();
    toggleStorefontPasswordForm($this);
  }

  // Au clic sur le lien pour afficher le formulaire de mot de passe du site
  $(document).on('click', '.password__admin-link [data-action="storefront-password"]', function(e) {
    _toggleStorefontPasswordFormListener($(this), e);
  });
  
  /**
   * SNIPPET - PRODUCT COMPARE
   */
  
  // Au changement de slide du carousel de comparaison de produit
  function _productCompareSlideChangeListener(e, $this, animate) {
    startProductCompareBars(e, $this, animate);
  }
  
  // Au changement de slide du carousel de comparaison de produit (pour reset le slide précédent)
  $('.carousel--products-compare').on('beforeChange', function(e) {
	_productCompareSlideChangeListener(e, $(this), false);
  });
  
  // Au changement de slide du carousel de comparaison de produit (pour animer le slide suivant)
  $('.carousel--products-compare').on('afterChange swipe', function(e) {
	_productCompareSlideChangeListener(e, $(this), true);
  });
  
  /**
   * SNIPPET - PRODUCT FORM
   */
  
  // Au clic sur le bouton - de la quantité dans le product form 
  function _clickProductFormSubQuantityListener($this) {
    subQuantity($this);
    updateSubscriptionPrices($this);
  }
  
  // Au clic sur le bouton + de la quantité dans le product form 
  function _clickProductFormAddQuantityListener($this) {
    addQuantity($this);
    updateSubscriptionPrices($this);
  }  
  
  // Au clic sur le bouton d'ajout au panier dans le product form
  function _clickProductFormAddToCartListener($this, e) {
    e.preventDefault();
    addToCartFromProductForm($this);
  }  
  
  // Au clic sur le bouton - de la quantité dans le product form
  $(document).on('click', '.product-form [data-action="sub-product"]', function(e) {
	_clickProductFormSubQuantityListener($(this));
  });
  
  // Au clic sur le bouton + de la quantité dans le product form
  $(document).on('click', '.product-form [data-action="add-product"]', function(e) {
	_clickProductFormAddQuantityListener($(this));
  });
  
  // Au clic sur le bouton d'ajout au panier dans le product form
  $(document).on('click', '.product-form [data-action="add-to-cart"]', function(e) {
	_clickProductFormAddToCartListener($(this), e);
  });
  
  /**
   * SNIPPET - VIDEO
   */
  
  // Lance ou arrête une vidéo
  function playVideo(video, video_button, unmute_click, enlarge_click) {    
    if(video.paused) {
      video.play();
      video_button.removeClass('active');
    } else {
      if(unmute_click == 'false' && enlarge_click == 'false') {
        video.pause();
        video_button.addClass('active');
      }
    }
  }
  
  // Met le son ou en muet sur une vidéo
  function unmuteVideo(video_wrapper, video, enlarge_click) {
    var section_snippet_inner = video_wrapper.closest('.section__snippet--inner');
    
    if(video.muted) {
      video.muted = false;
    } else {
      if(enlarge_click == 'false') {
        video.muted = true;
      } else if(section_snippet_inner.hasClass('larger')) {
        video.muted = true;
      }
    }
  }
  
  // Agrandit ou rétrécit une vidéo
  function enlargeVideo(video_wrapper, video) {  
    var section_snippet_inner = video_wrapper.closest('.section__snippet--inner');
    
    if(!section_snippet_inner.hasClass('larger')) {
      section_snippet_inner.addClass('larger');

      if(window.innerWidth < 500) {
        if(video.requestFullscreen) {
          video.requestFullscreen();
        } else if(video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if(video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if(video.msRequestFullscreen) { 
          video.msRequestFullscreen();
        } else {
          video.webkitEnterFullscreen();
        }
      }
    } else {
      section_snippet_inner.removeClass('larger');
    }
  } 
  
  // Lance ou arrête / Met le son ou en muet / Agrandit ou rétrécit une vidéo
  function handleVideo($this) {
    var video_wrapper = $this.closest('.video-wrapper'),
    	video_tag = video_wrapper.find('video'),
        video = video_tag.get(0),
        video_button = video_wrapper.find('button'),
        play_click = video_tag.attr('data-play-click'),
        unmute_click = video_tag.attr('data-unmute-click'),
        enlarge_click = video_tag.attr('data-enlarge-click');
    
    if(play_click == 'true') {
      playVideo(video, video_button, unmute_click, enlarge_click);
    }
    
    if(unmute_click == 'true') {
      unmuteVideo(video_wrapper, video, enlarge_click);
    }
    
    if(enlarge_click == 'true') {
      enlargeVideo(video_wrapper, video);
    }
  }
  
  // Sort du mode plein écran sur une vidéo
  function exitFullScreen() { 
    var fullscreen = $(document).get(0).fullscreen;

    if(!fullscreen) {
      $('video').each(function() {
        var video_tag = $(this);
        
        video_tag.closest('.section__snippet--inner').removeClass('larger');
        video_tag.get(0).muted = true;
      });
    }
  }
  
  // Au clic sur une vidéo native
  function _clickVideoFileListener($this, e) {
    handleVideo($this);
  }
  
  // A la sortie du mode plein écran sur une vidéo
  function _exitVideoFullScreenListener() {
    exitFullScreen();
  }
  
  // Au clic sur une vidéo native
  $(document).on('click', '.video-file', function(e) {
    _clickVideoFileListener($(this), e);
  });
  
  // A la sortie du mode plein écran sur une vidéo
  $(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange webkitendfullscreen', function() {
    _exitVideoFullScreenListener();
  });

  /**
   *  SNIPPET - ELKAD PRODUCT AND SELECTOR CARD
   */
  const updateQuickAddToCart = (productCard = null) => {
    // Get cart data
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      const cart = data;
      const cartItems = cart.items;
  
      // Update quick add to cart
      const quickAddToCartItems = productCard ? productCard.querySelectorAll('.elkad-quick-add-to-cart:not(.elkad-quick-add-to-cart--only-change-input)') : document.querySelectorAll('.elkad-quick-add-to-cart:not(.elkad-quick-add-to-cart--only-change-input)');
      quickAddToCartItems.forEach(quickAddToCartItem => {
        const quickAddToCartQuantityContainer = quickAddToCartItem.querySelector('.elkad-quick-add-to-cart__quantity-container');
        const quickAddToCartAddButton = quickAddToCartItem.querySelector('.elkad-quick-add-to-cart__add-button');
        const quickAddToCartInput = quickAddToCartItem.querySelector('.elkad-quick-add-to-cart__input');
        const quickAddToCartRemove = quickAddToCartItem.querySelector(".elkad-quick-add-to-cart__remove");
        const quickAddToCartDecrease = quickAddToCartItem.querySelector(".elkad-quick-add-to-cart__decrease");

        if (quickAddToCartItem.querySelector("input[name='id']")) {
          const quickAddToCartVariantId = quickAddToCartItem.querySelector("input[name='id']").value;
          const quickAddToCartVariant = cartItems.find(item => item.variant_id == quickAddToCartVariantId);

          if (quickAddToCartVariant) {
            quickAddToCartInput.classList.remove('hide');
            quickAddToCartInput.value = quickAddToCartVariant.quantity;

            if (quickAddToCartVariant.quantity == 0) {
              quickAddToCartQuantityContainer.classList.add('hide');
              quickAddToCartAddButton.classList.remove('hide');
            } else {
              quickAddToCartQuantityContainer.classList.remove('hide');
              quickAddToCartAddButton.classList.add('hide');
            }

            if (quickAddToCartVariant.quantity <= 1) {
              quickAddToCartRemove.classList.remove('hide');
              quickAddToCartDecrease.classList.add('hide');
            } else {
              quickAddToCartRemove.classList.add('hide');
              quickAddToCartDecrease.classList.remove('hide');
            }
          } else {
            quickAddToCartInput.value = 0;

            quickAddToCartRemove.classList.remove('hide');
            quickAddToCartDecrease.classList.add('hide');

            quickAddToCartQuantityContainer.classList.add('hide');
            quickAddToCartAddButton.classList.remove('hide');
          }
        }
      });
    })
    .catch(error => console.error('Error:', error));
  };

  if (document.querySelector('.elkad-quick-add-to-cart')) {
    updateQuickAddToCart();
  }
  
  const convertNumberToPrice = (number) => {
    const price = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(number / 100);

    return price.replace(" ", "");
  }
  
  const getSelectedItemsCount = () => {
    const selectedItems = document.querySelectorAll('.elkad-product-card--selected .elkad-quick-add-to-cart__input');
    let total = 0;
  
    selectedItems.forEach((item) => {
      const selectorGridIncludesPromo = item.closest('.elkad-selecteur__inner__slider__item__products-group__grid').classList.contains('elkad-selecteur__inner__slider__item__products-group__grid--products-in-promo');
      
      if (selectorGridIncludesPromo) {
        total += parseInt(item.value);
      }
    });
  
    return total;
  }
  
  const getSelectedItemsPrice = () => {
    const selectedItems = document.querySelectorAll('.elkad-product-card--selected');
  
    const activeDiscounts = getActiveDiscountTags();
    const lastActiveDiscount = activeDiscounts[activeDiscounts.length - 1];
  
    let total = {
      regular: 0,
      compare_at_price: 0,
      discounts: 0
    };
  
    selectedItems.forEach((item) => {
      const selectorGridIncludesPromo = item.closest('.elkad-selecteur__inner__slider__item__products-group__grid').classList.contains('elkad-selecteur__inner__slider__item__products-group__grid--products-in-promo');
      
      const discountPercent = lastActiveDiscount && selectorGridIncludesPromo ? lastActiveDiscount.pourcentage_de_reduction : 0;

      const itemJson = JSON.parse(item.getAttribute('data-variant-json'));
      const sourcePrice = item.getAttribute('data-variant-price') ? item.getAttribute('data-variant-price') : itemJson.price;
      const item_quantity = parseInt(item.querySelector('.elkad-quick-add-to-cart__input').value);
  
      const itemPrice = sourcePrice * item_quantity;
      const itemCompareAtPrice = itemJson.compare_at_price ? (itemJson.compare_at_price * item_quantity) : itemPrice;

      for (let i = 0; i < item_quantity; i++) {
        total.discounts += Math.floor(sourcePrice * (discountPercent / 100));
      }
      total.regular += itemPrice;
      total.compare_at_price += itemCompareAtPrice;
    });

    total.regular = total.regular - total.discounts;
    
    return total;
  }
  
  const toggleDiscountTag = () => {
    const activeDiscounts = getActiveDiscountTags();
    const lastActiveDiscount = activeDiscounts[activeDiscounts.length - 1];
  
    if (lastActiveDiscount) {
      const discountTitle = lastActiveDiscount.nom_du_label_promo;
      const htmlTag = `<span class="label product-label label--on-sale product-label label--selector-discount">${discountTitle}</span>`;
      const selectorGrids = document.querySelectorAll('.elkad-selecteur__inner__slider__item__products-group__grid.elkad-selecteur__inner__slider__item__products-group__grid--products-in-promo');
  
      selectorGrids.forEach((selectorGrid) => {
        const allSelectorCards = selectorGrid.querySelectorAll('.elkad-product-card.elkad-product-card--selector:not(.elkad-product-card--unavailable)');
  
        allSelectorCards.forEach((card) => {
          const labelContainers = card.querySelectorAll(".labels--inner.product-labels--inner");
          labelContainers.forEach((labelContainer) => {
            const discountTag = labelContainer.querySelector('.label--selector-discount');
    
            if (discountTag) {
              discountTag.innerHTML = discountTitle;
            } else {
              labelContainer.insertAdjacentHTML('beforeend', htmlTag);
            }
          });
        });
      });
    } else {
      const discountTags = document.querySelectorAll('.label--selector-discount');
  
      discountTags.forEach((tag) => {
        tag.remove();
      });
    }
  }
  
  const updatePriceInCards = () => {
    const selectorGrids = document.querySelectorAll('.elkad-selecteur__inner__slider__item__products-group__grid.elkad-selecteur__inner__slider__item__products-group__grid--products-in-promo');
  
    selectorGrids.forEach((selectorGrid) => {
      const allSelectorCards = selectorGrid.querySelectorAll('.elkad-product-card.elkad-product-card--selector:not(.elkad-product-card--unavailable)');
      const activeDiscounts = getActiveDiscountTags();
      const lastActiveDiscount = activeDiscounts[activeDiscounts.length - 1];
      
      allSelectorCards.forEach((card) => {
        const itemJson = JSON.parse(card.getAttribute('data-variant-json'));
        const sourcePrice = card.getAttribute('data-variant-price') ? card.getAttribute('data-variant-price') : itemJson.price;
       
        const itemPrice = lastActiveDiscount ? sourcePrice - Math.floor(sourcePrice * (lastActiveDiscount.pourcentage_de_reduction / 100)) : sourcePrice;
        const itemCompareAtPrice = itemJson.compare_at_price ? itemJson.compare_at_price : sourcePrice;
  
        const cardPrice = card.querySelector('.prices.product-price .product-price--value.product-price--new');
        const cardCompareAtPrice = card.querySelector('.prices.product-price .product-price--value.product-price--old');
  
        if (cardCompareAtPrice && cardPrice) {
          cardPrice.innerHTML = convertNumberToPrice(itemPrice);
          cardCompareAtPrice.innerHTML = convertNumberToPrice(itemCompareAtPrice);
  
          if (!lastActiveDiscount && itemCompareAtPrice <= itemPrice) {
            cardPrice.classList.remove('product-price--new');
            cardCompareAtPrice.remove();
          }
        } else {
          const cardPrices = card.querySelector('.prices.product-price');
          cardPrices.innerHTML = '';
          const htmlPrice = `<span class="product-price--value ${itemCompareAtPrice > 0 && itemCompareAtPrice > itemPrice ? "product-price--new" : ""}">${convertNumberToPrice(itemPrice)}</span>`;
  
          cardPrices.insertAdjacentHTML('beforeend', htmlPrice);

          if (itemCompareAtPrice > 0 && itemCompareAtPrice > itemPrice) {
            const htmlCompareAtPrice = `<span class="product-price--value product-price--old">${convertNumberToPrice(itemCompareAtPrice)}</span>`;
  
            cardPrices.insertAdjacentHTML('beforeend', htmlCompareAtPrice);
          }
        }
      });
    });
  }
  
  const updateTotalSelectedItemsInfos = (selectorGrid, selectorBottomBar, selectorGridIncludesPromo) => {
    const selectorBottomBarTotalSelected = selectorBottomBar.querySelector('.elkad-selector-bottom-bar__form__detail__choices--current');
    const selectorBottomBarTotalOnceRegularPrice = selectorBottomBar.querySelector('.elkad-selector-bottom-bar__submit__price--once .elkad-selector-bottom-bar__submit__price');
    const selectorBottomBarTotalOnceComparePrice = selectorBottomBar.querySelector('.elkad-selector-bottom-bar__submit__price--once .elkad-selector-bottom-bar__submit__old-price');
    const selectorBottomBarTotalSubscriptionRegularPrice = selectorBottomBar.querySelector('.elkad-selector-bottom-bar__submit__price--subscription .elkad-selector-bottom-bar__submit__price');
    const selectorBottomBarTotalSubscriptionComparePrice = selectorBottomBar.querySelector('.elkad-selector-bottom-bar__submit__price--subscription .elkad-selector-bottom-bar__submit__old-price');
  
    const totalCount = getSelectedItemsCount();
    const totalPrice = getSelectedItemsPrice();
    
    selectorGrid.setAttribute('data-total-selected-items', totalCount);
  
    selectorBottomBarTotalSelected.innerHTML = totalCount;
    selectorBottomBarTotalOnceRegularPrice.innerHTML = convertNumberToPrice(totalPrice.regular);
    selectorBottomBarTotalSubscriptionComparePrice.innerHTML = convertNumberToPrice(totalPrice.compare_at_price);
    selectorBottomBarTotalSubscriptionRegularPrice.innerHTML = convertNumberToPrice(totalPrice.regular * 0.9);
  
    if (totalPrice.compare_at_price > 0 && totalPrice.compare_at_price > totalPrice.regular) {
      selectorBottomBarTotalOnceComparePrice.classList.remove('hide');
      selectorBottomBarTotalOnceComparePrice.innerHTML = convertNumberToPrice(totalPrice.compare_at_price);
    } else {
      selectorBottomBarTotalOnceComparePrice.classList.add('hide');
    }
  }
  
  const getActiveDiscountTags = () => {
    const totalCount = getSelectedItemsCount();
  
    return ELKAD_SELECTEUR_PALIERS.filter((palier) => totalCount >= palier.nombre_de_produits_a_atteindre_pour_la_reduction);
  }
  
  const updateSelectedDiscountTags = (selectorBottomBar, totalCount) => {
    ELKAD_SELECTEUR_PALIERS.forEach((palier, index) => {
      const palierTag = selectorBottomBar.querySelectorAll(`.elkad-selector-bottom-bar__jauge__discount`)[index];
      if (totalCount >= palier.nombre_de_produits_a_atteindre_pour_la_reduction) {
        palierTag.classList.add('elkad-selector-bottom-bar__jauge__discount--active');
      } else {
        palierTag.classList.remove('elkad-selector-bottom-bar__jauge__discount--active');
      }
    });
  }
  
  const updateSelectedJauges = (selectorBottomBar) => {
    const totalCount = getSelectedItemsCount();
    const selectorJauges = selectorBottomBar.querySelectorAll('.elkad-selector-bottom-bar__jauge__step');
  
    selectorJauges.forEach((jauge, index) => {
      if (totalCount >= (index + 1)) {
        jauge.classList.add('elkad-selector-bottom-bar__jauge__step--active');
      } else {
        jauge.classList.remove('elkad-selector-bottom-bar__jauge__step--active');
      }
    });
  
    updateSelectedDiscountTags(selectorBottomBar, totalCount);
  }
  
  const toggleSelectedBorder = (productCard) => {
    const quantityInput = productCard.querySelector('.elkad-quick-add-to-cart__input');

    if (quantityInput.value >= 1) {
      productCard.classList.add('elkad-product-card--selected');
    } else {
      productCard.classList.remove('elkad-product-card--selected');
    }
  }
  
  const activateSubmitButton = (button, totalSelectedItems) => {
    if (totalSelectedItems <= 0) {
      button.classList.add('elkad-selector-bottom-bar__submit--disabled');
    } else {
      button.classList.remove('elkad-selector-bottom-bar__submit--disabled');
    }
  }

  const formatMoney = (price) => {
    return (price / 100).toFixed(2).replace(".", ",") + "€";
  }
  
  const initVariantsToggler = () => {
    const allVariantsInVariantSelectorDropdown = document.querySelectorAll('.elkad-product-card__variants-selector__list__item, .elkad-product-card-detailed__variants-selector__list__item');
    allVariantsInVariantSelectorDropdown.forEach(variant => {
      variant.addEventListener('click', () => {
        const variantProductCard = variant.closest('.elkad-product-card') || variant.closest('.elkad-product-card-detailed');
        const formInputId = variantProductCard.querySelector('form.elkad-quick-add-to-cart input[name="id"]');
        const variantSelector = variantProductCard.querySelector('.elkad-product-card__variants-selector') || variantProductCard.querySelector('.elkad-product-card-detailed__variants-selector');
        const selectedVariant = variantSelector.querySelector('.elkad-product-card__variants-selector__active') || variantSelector.querySelector('.elkad-product-card-detailed__variants-selector__active');
        const selectedVariantText = variantSelector.querySelector('.elkad-product-card__variants-selector__active__text') || variantSelector.querySelector('.elkad-product-card-detailed__variants-selector__active__text');
  
        // Update the quick add to cart form data based on the selected variant
        selectedVariantText.innerHTML = variant.innerHTML;
        selectedVariant.setAttribute('data-variant-id', variant.getAttribute('data-variant-id'));
        variantProductCard.setAttribute('data-variant-id', variant.getAttribute('data-variant-id'));
        if(formInputId) formInputId.value = variant.getAttribute('data-variant-id');
  
        // Update the product card image based on the selected variant
        const productCardImage = variantProductCard.querySelector('.elkad-product-card__header__image img') || variantProductCard.querySelector('.elkad-product-card-detailed__header__image img');
        const newImageSrc = variant.getAttribute('data-variant-image');
  
        if (newImageSrc) {
          productCardImage.setAttribute('src', newImageSrc);

          // Update the sticky bar images (ONLY FOR BILAN PERSO RESULT PAGE) ==> SECTION : section-result-recap
          const recap_section_sticky_bar = document.querySelector('.section-result-recap__sticky-bar__left');

          if (recap_section_sticky_bar) {
            const recap_section_content = document.querySelector('.section-result-recap__content__products');
            const recap_section_this_variant_product_card = variantProductCard.closest('.elkad-section-api--api-section-product-card');

            if (recap_section_this_variant_product_card && recap_section_content) {
              const variant_index = Array.from(recap_section_content.children).indexOf(recap_section_this_variant_product_card);
              const recap_section_sticky_bar_image = recap_section_sticky_bar.querySelectorAll('img')[variant_index];
              
              if (recap_section_sticky_bar_image) {
                recap_section_sticky_bar_image.setAttribute('src', newImageSrc);
              }
            }
          }
        }
  
        // Update the links to the product page based on the selected variant
        const productCardLink = variantProductCard.querySelectorAll('a');
  
        productCardLink.forEach(link => {
          const oldHref = link.getAttribute('href');
          const newHref = oldHref.split('?variant=')[0] + '?variant=' + variant.getAttribute('data-variant-id');
          
          link.setAttribute('href', newHref);
        });

        // Update the product card description based on the selected variant
        const productCardDescription = variantProductCard.querySelector('.elkad-product-card__info') || variantProductCard.querySelector('.elkad-product-card-detailed__info');
        const newDescription = variant.getAttribute('data-variant-description');
  
        if (newDescription) {
          productCardDescription.innerHTML = decodeURIComponent(newDescription);
        }
  
        // Update the price based on the selected variant
        const productCardPrice = variantProductCard.querySelector('.elkad-product-card__price .prices') || variantProductCard.querySelector('.elkad-product-card-detailed__price .prices');

        if (productCardPrice) {
          const new_price = variant.getAttribute('data-variant-price');
          const new_compare_at_price = variant.getAttribute('data-variant-compare-at-price');
          
          const price_html = `
            <span class="product-price--value${new_compare_at_price != "" ? " product-price--new" : ""}" data-money-convertible="" data-unformatted-value="${new_price}">${formatMoney(new_price)}</span>
            ${new_compare_at_price != "" ? `<span class="product-price--value product-price--old" data-money-convertible="" data-unformatted-value="${new_compare_at_price}">${formatMoney(new_compare_at_price)}</span>` : ''}`

          productCardPrice.innerHTML = price_html;

          const price_changed_event = new CustomEvent('elkad:product-card:price_changed', {
            detail: {
              price: new_price,
              compare_at_price: new_compare_at_price
            }
          });
          document.dispatchEvent(price_changed_event);
        }

        // Update the product card title based on the selected variant
        const productCardTitle = variantProductCard.querySelector('.elkad-product-card__title') || variantProductCard.querySelector('.elkad-product-card-detailed__title');
        const newTitle = variant.getAttribute('data-variant-title');

        if (newTitle) {
          productCardTitle.innerHTML = newTitle;
        }

        // Update the product card subtitle based on the selected variant
        const productCardSubtitle = variantProductCard.querySelector('.elkad-product-card__subtitle') || variantProductCard.querySelector('.elkad-product-card-detailed__subtitle');
        const newSubtitle = variant.getAttribute('data-variant-subtitle');

        if (newSubtitle) {
          productCardSubtitle.innerHTML = newSubtitle;
        }
  
        // Update the card status class based on the selected variant
        const product_card_quantity = variantProductCard.querySelector('.elkad-product-card-detailed__quantity__input');

        if (variant.classList.contains("elkad-product-card__variants-selector__list__item--unavailable")) {
          variantProductCard.classList.add('elkad-product-card--unavailable');
        } else {
          variantProductCard.classList.remove('elkad-product-card--unavailable');
        }

        if (variant.classList.contains("elkad-product-card-detailed__variants-selector__list__item--unavailable")) {
          variantProductCard.classList.add('elkad-product-card-detailed--unavailable');

          // update the quantity to 0
          if (product_card_quantity) {
            product_card_quantity.innerHTML = "0";
          }

          // update the price
          if (productCardPrice) {
            const new_price = variant.getAttribute('data-variant-price');
            const new_compare_at_price = variant.getAttribute('data-variant-compare-at-price');
            
            const price_html = `
              <span class="product-price--value${new_compare_at_price != "" ? " product-price--new" : ""}" data-money-convertible="" data-unformatted-value="${new_price}">${formatMoney(new_price)}</span>
              ${new_compare_at_price != "" ? `<span class="product-price--value product-price--old" data-money-convertible="" data-unformatted-value="${new_compare_at_price}">${formatMoney(new_compare_at_price)}</span>` : ''}`
  
            productCardPrice.innerHTML = price_html;

            const price_changed_event = new CustomEvent('elkad:product-card:price_changed', {
              detail: {
                price: new_price,
                compare_at_price: new_compare_at_price
              }
            });
            document.dispatchEvent(price_changed_event);
          }
        } else {
          variantProductCard.classList.remove('elkad-product-card-detailed--unavailable');

          // update the quantity to 1
          if (product_card_quantity) {
            product_card_quantity.innerHTML = "1";
          }

          // update the price
          if (productCardPrice) {
            const new_price = variant.getAttribute('data-variant-price');
            const new_compare_at_price = variant.getAttribute('data-variant-compare-at-price');
            
            const price_html = `
              <span class="product-price--value${new_compare_at_price != "" ? " product-price--new" : ""}" data-money-convertible="" data-unformatted-value="${new_price}">${formatMoney(new_price)}</span>
              ${new_compare_at_price != "" ? `<span class="product-price--value product-price--old" data-money-convertible="" data-unformatted-value="${new_compare_at_price}">${formatMoney(new_compare_at_price)}</span>` : ''}`
  
            productCardPrice.innerHTML = price_html;

            const price_changed_event = new CustomEvent('elkad:product-card:price_changed', {
              detail: {
                price: new_price,
                compare_at_price: new_compare_at_price
              }
            });
            document.dispatchEvent(price_changed_event);
          }
        }
  
        // Update the labels based on the selected variant
        const allLabels = variantProductCard.querySelectorAll('.elkad-product-card__header__labels:not(.hide)') || variantProductCard.querySelectorAll('.elkad-product-card-detailed__header__labels:not(.hide)');
  
        allLabels.forEach(label => {
          label.classList.add("hide");
        });
  
        const productCardLabel = variantProductCard.querySelector('.elkad-product-card__header__labels[data-variant-id="' + variant.getAttribute('data-variant-id') + '"]') || variantProductCard.querySelector('.elkad-product-card-detailed__header__labels[data-variant-id="' + variant.getAttribute('data-variant-id') + '"]');
  
        if (productCardLabel) {
          productCardLabel.classList.remove("hide");
        }
  
        // Display previous hidden item and hide the selected one in the dropdown
        if (variantSelector.querySelector('.elkad-product-card__variants-selector__list__item.hide')) {
          variantSelector.querySelector('.elkad-product-card__variants-selector__list__item.hide').classList.remove('hide');
        } else if (variantSelector.querySelector('.elkad-product-card-detailed__variants-selector__list__item.hide')) {
          variantSelector.querySelector('.elkad-product-card-detailed__variants-selector__list__item.hide').classList.remove('hide');
        }
        variant.classList.add('hide');
  
        updateQuickAddToCart(variantProductCard);
  
        variantSelector.removeAttribute('open');
      });
    });
  
    const allDetails = [...document.querySelectorAll('.elkad-product-card details'), ...document.querySelectorAll('.elkad-product-card-detailed details')];
    document.addEventListener('click', function(e) {
      if (!allDetails.some(f => f.contains(e.target))) {
        allDetails.forEach(f => f.removeAttribute('open'));
      } else {
        allDetails.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '');
      }
    });
  
    const allDetailsTogglers = document.querySelectorAll(".elkad-product-card__variants-selector__active__arrow-button, .elkad-product-card-detailed__variants-selector__active__arrow-button");
    allDetailsTogglers.forEach(toggler => {
      toggler.addEventListener('click', () => {
        const details = toggler.closest('.elkad-product-card__variants-selector') || toggler.closest('.elkad-product-card-detailed__variants-selector');
        details.toggleAttribute('open');
      });
    });
  };

  const initChallengePreselection = () => {
    const challenge_preselection = localStorage.getItem('elkad-challenge-preselection');

    if (!challenge_preselection) return;

    const preselected_items = JSON.parse(challenge_preselection).items;

    for (let item of preselected_items) {
      const product_card = document.querySelector(`[data-page-handle="addons"] .elkad-item-product-selector[data-variant-id="${item.variant_id}"]`);

      if (!product_card) continue;

      for (let i = 0; i < item.quantity; i++) {
        const add_button = product_card.querySelector('[data-action="add-addon"]');
        add_button.click();
      }
    };

    localStorage.removeItem('elkad-challenge-preselection');
  }

  const initQuickAddToCart = async () => {
    const allQuickAddToCartForms = document.querySelectorAll('.elkad-quick-add-to-cart:not([data-init="true"])');

    window.addEventListener('quantityChanged', (e) => {
      const triggeringElement = $(e.detail.triggeringElement);
      
      const product_item = document.querySelectorAll('.elkad-item-product-selector');

      product_item.forEach((item) => {
        const quantity = item.querySelector('.elkad-quick-add-to-cart__input').value;

        if (quantity > 0) {
          item.classList.add('elkad-item-product-selector--selected');
        } else {
          item.classList.remove('elkad-item-product-selector--selected');
        }
      });

      if (triggeringElement.attr("data-action") == "select-shaker") {
        _clickShakerSelectListener(triggeringElement);
      }

      if (triggeringElement.attr("data-action") == "add-addon") {
        _clickProductItemAddQuantityListener(triggeringElement);
      }

      if (triggeringElement.attr("data-action") == "sub-addon") {
        _clickProductItemSubQuantityListener(triggeringElement);
      }

      if (triggeringElement.attr("data-action") == "sub-product" && triggeringElement.hasClass("elkad-quick-add-to-cart__remove")) {
        _clickProductItemFlavorSubQuantityListener(triggeringElement);
      }
    });
  
    const debounce = (func, wait) => {
      let timeout;
  
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
  
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };
  
    const updateCart = async (form, method) => {
      let quantity = form.querySelector('.elkad-quick-add-to-cart__input').value;
      const variant_id = form.querySelector('input[name="id"]').value;
      const add_to_cart_button = $(form).find('.elkad-quick-add-to-cart__submit');
  
      if (method == "add" && quantity == 1) {
        addVariantToCart(add_to_cart_button, variant_id, 1, {}, 0);
      } else if (method == "remove") {
        const response = await fetch("/cart/change.js", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variant_id,
            quantity: 0
          })
        });
  
        if (response.ok) {
          renderCartSidebar();
        }
      } else {
        const response = await fetch("/cart/change.js", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variant_id,
            quantity: quantity
          })
        });
  
        if (response.ok) {
          productAddedDrawer(null, true);
        }
      }
    };
  
    const quantityValidator = async (input) => {
      if (input.value < 0) {
        input.value = 0;
      }
    };
  
    const updateVisibilityState = async (btn) => {
      const parent = btn.closest('.elkad-quick-add-to-cart');
  
      await quantityValidator(parent.querySelector('.elkad-quick-add-to-cart__input')); 
  
      const quantity_container = parent.querySelector('.elkad-quick-add-to-cart__quantity-container');
      const add_button = parent.querySelector('.elkad-quick-add-to-cart__add-button');
      const input = parent.querySelector('.elkad-quick-add-to-cart__input');
      const remove = parent.querySelector('.elkad-quick-add-to-cart__remove');
      const decrease = parent.querySelector('.elkad-quick-add-to-cart__decrease');
  
      if (input.value <= 1) {
        remove.classList.remove('hide');
        decrease.classList.add('hide');
      } else {
        remove.classList.add('hide');
        decrease.classList.remove('hide');
      }

      if (input.value == 0) {
        quantity_container.classList.add('hide');
        add_button.classList.remove('hide');
      } else {
        quantity_container.classList.remove('hide');
        add_button.classList.add('hide');
      }
  
      const method = btn.classList.contains("elkad-quick-add-to-cart__add") || btn.classList.contains("elkad-quick-add-to-cart__add-button") ? "add" : btn.classList.contains("elkad-quick-add-to-cart__remove") ? "remove" : "change";
  
      if (!parent.classList.contains('elkad-quick-add-to-cart--only-change-input')) {
        await updateCart(parent, method);
      }
    }
  
    const addOneQuantityToInput = async (btn) => {
      const input = btn.closest('.elkad-quick-add-to-cart').querySelector('.elkad-quick-add-to-cart__input');
      const valueToAdd = btn.getAttribute("data-step") ? parseInt(btn.getAttribute("data-step")) : 1;
      input.value = parseInt(input.value) + valueToAdd;
    }
  
    const decreaseOneQuantityToInput = (btn) => {
      const input = btn.closest('.elkad-quick-add-to-cart').querySelector('.elkad-quick-add-to-cart__input');
      const valueToRemove = btn.getAttribute("data-step") ? parseInt(btn.getAttribute("data-step")) : 1;
      input.value = parseInt(input.value) - valueToRemove;
    }
  
    const removeAllQuantityToInput = (btn) => {
      const input = btn.closest('.elkad-quick-add-to-cart').querySelector('.elkad-quick-add-to-cart__input');
      input.value = 0;
    }
  
    const addLoadStateToButton = (btn) => {
      const loader = `
      <div class="elkad-loader rotate">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path fill="currentColor" d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"/>
        </svg>
      </div>`;
  
      btn.innerHTML = loader;
    }
  
    const removeLoadStateToButton = (btn) => {
      const defaultText = btn.getAttribute("data-text");
  
      if (defaultText == "remove") {
        btn.innerHTML = `<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3.47387C12 2.60187 11.2514 1.89227 10.3315 1.89227H9.32402V1.42803C9.32402 0.640759 8.64804 0 7.8175 0L4.78211 0C3.95157 0 3.27559 0.640759 3.27559 1.42803V1.89227H2.26814C1.34821 1.89227 0.599609 2.60187 0.599609 3.47387C0.599609 4.05461 0.931081 4.56121 1.42456 4.83482V12.0544C1.42456 13.0376 2.26814 13.8372 3.30539 13.8372H9.29422C10.3315 13.8372 11.175 13.0376 11.175 12.0544V4.83482C11.6685 4.55945 12 4.05284 12 3.47387ZM4.57913 1.42803C4.57913 1.32212 4.67038 1.23562 4.78211 1.23562H7.8175C7.92923 1.23562 8.02048 1.32212 8.02048 1.42803V1.89227H4.57913V1.42803ZM2.26628 3.12789H10.3315C10.5326 3.12789 10.6965 3.28323 10.6965 3.47387C10.6965 3.66451 10.54 3.81101 10.3445 3.81808H2.25511C2.05957 3.81101 1.90315 3.66098 1.90315 3.47387C1.90315 3.28676 2.06702 3.12789 2.26628 3.12789ZM9.29422 12.5998H3.30539C2.98695 12.5998 2.7281 12.3545 2.7281 12.0526V5.0537H9.8715V12.0544C9.8715 12.3562 9.61266 12.6016 9.29422 12.6016V12.5998Z" fill="currentColor"></path>
        <path d="M4.35197 6.10925C3.99256 6.10925 3.7002 6.38639 3.7002 6.72706V11.2353C3.7002 11.576 3.99256 11.8531 4.35197 11.8531C4.71137 11.8531 5.00374 11.576 5.00374 11.2353V6.72706C5.00374 6.38639 4.71137 6.10925 4.35197 6.10925Z" fill="currentColor"></path>
        <path d="M6.32755 6.10925C5.96815 6.10925 5.67578 6.38639 5.67578 6.72706V11.2353C5.67578 11.576 5.96815 11.8531 6.32755 11.8531C6.68696 11.8531 6.97932 11.576 6.97932 11.2353V6.72706C6.97932 6.38639 6.68696 6.10925 6.32755 6.10925Z" fill="currentColor"></path>
        <path d="M8.30802 6.10925C7.94862 6.10925 7.65625 6.38639 7.65625 6.72706V11.2353C7.65625 11.576 7.94862 11.8531 8.30802 11.8531C8.66742 11.8531 8.95979 11.576 8.95979 11.2353V6.72706C8.95979 6.38639 8.66742 6.10925 8.30802 6.10925Z" fill="currentColor"></path>
      </svg>`;
        return;
      }
  
      btn.innerHTML = defaultText;
    }

    const checkIfYouCanAddMoreProductsInSlide = (productCard) => {
      const slide = productCard.closest(".elkad-selecteur__inner__slider__item[data-max-quantity]");

      if (!slide) return true;

      const selectedItems = slide.querySelectorAll('.elkad-product-card--selected .elkad-quick-add-to-cart__input');
      let totalSelectedItems = 0;

      selectedItems.forEach((item) => {
        totalSelectedItems += parseInt(item.value);
      });

      const maxItems = parseInt(slide.getAttribute("data-max-quantity"));
      const dataStep = parseInt(productCard.querySelector('.elkad-quick-add-to-cart__add').getAttribute("data-step"));

      if (totalSelectedItems + dataStep > maxItems) {
        const allProductCardsInSlide = slide.querySelectorAll('.elkad-product-card');

        allProductCardsInSlide.forEach((card) => {
          const addButton = card.querySelectorAll('.elkad-quick-add-to-cart__add, .elkad-quick-add-to-cart__add-button');

          addButton.forEach((button) => {
            button.setAttribute('disabled', 'disabled');
          });
        });

        return false;
      } else {
        const allProductCardsInSlide = slide.querySelectorAll('.elkad-product-card');

        allProductCardsInSlide.forEach((card) => {
          const addButton = card.querySelectorAll('.elkad-quick-add-to-cart__add, .elkad-quick-add-to-cart__add-button');

          addButton.forEach((button) => {
            button.removeAttribute('disabled');
          });
        });

        return true;
      }
    };

    const updateData = (selectorCard, palierUnlocked = false, freeGiftPalierToUnlock) => {
      const referenceProductData = JSON.parse(selectorCard.getAttribute('data-reference-product'));
      const defaultData = JSON.parse(selectorCard.getAttribute('data-variant-json'));
      const matchingVariantDataInReferenceProduct = referenceProductData ? referenceProductData.variants.find(variant => variant.sku == defaultData.sku) : null;

      if (matchingVariantDataInReferenceProduct) {
        const newVariantId = palierUnlocked ? defaultData.id : matchingVariantDataInReferenceProduct.id;
        const newVariantPrice = palierUnlocked ? defaultData.price : matchingVariantDataInReferenceProduct.price;
        const newVariantPriceToDisplay = newVariantPrice == 0 ? selectorCard.getAttribute("data-free-text") : convertNumberToPrice(newVariantPrice);

        selectorCard.setAttribute('data-variant-id', newVariantId);
        selectorCard.setAttribute('data-variant-price', newVariantPrice);
        selectorCard.querySelector(".product-price--value").innerHTML = newVariantPriceToDisplay;
        selectorCard.setAttribute('data-gift-unlocked', palierUnlocked);
        selectorCard.setAttribute('data-gift-minimum-products-in-pack', freeGiftPalierToUnlock.nombre_de_produits_a_atteindre_pour_la_reduction)
      }
    }

    const updateFreeGiftSelectorCardsForSelector = () => {
      const allFreeGiftGrids = document.querySelectorAll(".elkad-selecteur__inner__slider__item__products-group__grid[data-free-gift-palier-to-unlock]");

      allFreeGiftGrids.forEach((grid) => {
        const freeGiftPalierToUnlock = JSON.parse(grid.getAttribute("data-free-gift-palier-to-unlock"));
        const freeGiftCards = grid.querySelectorAll(".elkad-product-card");
        const palierUnlocked = getSelectedItemsCount() >= freeGiftPalierToUnlock.nombre_de_produits_a_atteindre_pour_la_reduction;

        freeGiftCards.forEach((card) => {
          updateData(card, palierUnlocked, freeGiftPalierToUnlock);
        });
      });
    }

    updateFreeGiftSelectorCardsForSelector();

    const updateSelector = (productCard, selectorGridIncludesPromo) => {
      const selectorGrid = document.querySelector('.elkad-selecteur__inner__slider__item__products-group__grid.elkad-selecteur__inner__slider__item__products-group__grid--products-in-promo');
      const selectorBottomBar = document.querySelector('.elkad-selector-bottom-bar');
      const selectorBottomBarSubmit = selectorBottomBar.querySelector('.elkad-selector-bottom-bar__submit');

      toggleSelectedBorder(productCard);
      if (selectorGridIncludesPromo) {
        updateSelectedJauges(selectorBottomBar);
      }
      updateTotalSelectedItemsInfos(selectorGrid, selectorBottomBar, selectorGridIncludesPromo);
      if (selectorGridIncludesPromo) {
        toggleDiscountTag();
        updatePriceInCards();
      }
      updateFreeGiftSelectorCardsForSelector();
      activateSubmitButton(selectorBottomBarSubmit, getSelectedItemsCount());
    }
  
    initChallengePreselection();

    allQuickAddToCartForms.forEach(async (allQuickAddToCartForm) => {
      const allQuickAddToCartAdd = allQuickAddToCartForm.querySelectorAll('.elkad-quick-add-to-cart__add, .elkad-quick-add-to-cart__add-button');
      const allQuickAddToCartDecrease = allQuickAddToCartForm.querySelectorAll('.elkad-quick-add-to-cart__decrease');
      const allQuickAddToCartRemove = allQuickAddToCartForm.querySelectorAll('.elkad-quick-add-to-cart__remove');
      const allQuickAddToCartInputs = allQuickAddToCartForm.querySelectorAll('.elkad-quick-add-to-cart__input');

      for (let btn of allQuickAddToCartAdd) {
        const productCard = btn.closest('.elkad-product-card');
    
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
  
          // Create custom event on quantity changed
          const quantityChangedEvent = new CustomEvent('quantityChanged', {
            bubbles: true,
            cancelable: true,
            detail: { triggeringElement: btn }
          });
  
          if (productCard) {
            productCard.classList.add('elkad-product-card--loading');
          }
          addLoadStateToButton(btn);
    
          await addOneQuantityToInput(btn);
          await updateVisibilityState(btn);
  
          if (productCard) {
            productCard.classList.remove('elkad-product-card--loading');
          }
          removeLoadStateToButton(btn);
  
          if (productCard && productCard.classList.contains('elkad-product-card--selector')) {
            const selectorGridIncludesPromo = productCard.closest('.elkad-selecteur__inner__slider__item__products-group__grid').classList.contains('elkad-selecteur__inner__slider__item__products-group__grid--products-in-promo');
            
            updateSelector(productCard, selectorGridIncludesPromo);
          }
          
          if (productCard) {
            checkIfYouCanAddMoreProductsInSlide(productCard);
          }
  
          window.dispatchEvent(quantityChangedEvent);
        });
      };
    
      for (let btn of allQuickAddToCartRemove) {
        const productCard = btn.closest('.elkad-product-card');
    
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
  
          // Create custom event on quantity changed
          const quantityChangedEvent = new CustomEvent('quantityChanged', {
            bubbles: true,
            cancelable: true,
            detail: { triggeringElement: btn }
          });
          
          if (productCard) {
            productCard.classList.add('elkad-product-card--loading');
          }
          addLoadStateToButton(btn);
    
          await removeAllQuantityToInput(btn);
          await updateVisibilityState(btn);
  
          if (productCard) {
            productCard.classList.remove('elkad-product-card--loading');
          }
          removeLoadStateToButton(btn);
  
          if (productCard && productCard.classList.contains('elkad-product-card--selector')) {
            const selectorGridIncludesPromo = productCard.closest('.elkad-selecteur__inner__slider__item__products-group__grid').classList.contains('elkad-selecteur__inner__slider__item__products-group__grid--products-in-promo');
            
            updateSelector(productCard, selectorGridIncludesPromo);
          }
  
          if (productCard) {
            checkIfYouCanAddMoreProductsInSlide(productCard);
          }
  
          window.dispatchEvent(quantityChangedEvent);
        });
      };
    
      for (let btn of allQuickAddToCartDecrease) {
        const productCard = btn.closest('.elkad-product-card');
    
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
  
          // Create custom event on quantity changed
          const quantityChangedEvent = new CustomEvent('quantityChanged', {
            bubbles: true,
            cancelable: true,
            detail: { triggeringElement: btn }
          });
  
          if(productCard) {
            productCard.classList.add('elkad-product-card--loading');
          }
          
          addLoadStateToButton(btn);
    
          await decreaseOneQuantityToInput(btn);
          await updateVisibilityState(btn);
  
          if (productCard) {
            productCard.classList.remove('elkad-product-card--loading');
          }
          removeLoadStateToButton(btn);
  
          if (productCard && productCard.classList.contains('elkad-product-card--selector')) {
            const selectorGridIncludesPromo = productCard.closest('.elkad-selecteur__inner__slider__item__products-group__grid').classList.contains('elkad-selecteur__inner__slider__item__products-group__grid--products-in-promo');
            
            updateSelector(productCard, selectorGridIncludesPromo);
          }
  
          if (productCard) {
            checkIfYouCanAddMoreProductsInSlide(productCard);
          }
  
          window.dispatchEvent(quantityChangedEvent);
        });
      };
    
      for (let input of allQuickAddToCartInputs) {
        const productCard = input.closest('.elkad-product-card');
    
        input.addEventListener('change', debounce(async (e) => {
          e.preventDefault();
  
          // Create custom event on quantity changed
          const quantityChangedEvent = new CustomEvent('quantityChanged', {
            bubbles: true,
            cancelable: true,
            detail: { triggeringElement: btn }
          });
          
          if (productCard) {
            productCard.classList.add('elkad-product-card--loading');
          }
    
          await updateVisibilityState(input);
  
          if (productCard) {
            productCard.classList.remove('elkad-product-card--loading');
          }
          
          if (productCard && productCard.classList.contains('elkad-product-card--selector')) {
            const selectorGridIncludesPromo = productCard.closest('.elkad-selecteur__inner__slider__item__products-group__grid').classList.contains('elkad-selecteur__inner__slider__item__products-group__grid--products-in-promo');
            
            updateSelector(productCard, selectorGridIncludesPromo);
          }
  
          window.dispatchEvent(quantityChangedEvent);
        }, 300));
      };
  
      allQuickAddToCartForm.setAttribute('data-init', 'true');
    }); 
  };

  initQuickAddToCart()
  
  const initProductCard = () => {
    initVariantsToggler();
  }
  
  initProductCard();

  /**
   * SECTION - ELKAD PRODUCT RECOMMENDATIONS
   */

  // const initHorizontalDrag = () => {
  //   const slider = document.querySelector(".product-recommendations .elkad-product-grid__products")
  //   let isDown = false;
  //   let startX;
  //   let scrollLeft;
  
  //   slider.addEventListener('mousedown', (e) => {
  //     isDown = true;
  //     slider.classList.add('active');
  //     startX = e.pageX - slider.offsetLeft;
  //     scrollLeft = slider.scrollLeft;
  //   });
  //   slider.addEventListener('mouseleave', () => {
  //     isDown = false;
  //     slider.classList.remove('active');
  //   });
  //   slider.addEventListener('mouseup', () => {
  //     isDown = false;
  //     slider.classList.remove('active');
  //   });
  //   slider.addEventListener('mousemove', (e) => {
  //     if(!isDown) return;
  //     e.preventDefault();
  //     const x = e.pageX - slider.offsetLeft;
  //     const walk = (x - startX) * 2; //scroll-fast
  //     slider.scrollLeft = scrollLeft - walk;
  //   });
  // };

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
  
    observer.unobserve(productRecommendationsSection);
  
    const url = productRecommendationsSection.dataset.url;
  
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
  
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          initQuickAddToCart();
          updateQuickAddToCart();
          initProductCard();

          const productRecommendationsLoadedEvent = new CustomEvent('elkad-product-recommendations-loaded', {
            bubbles: true,
            cancelable: true
          });
          document.dispatchEvent(productRecommendationsLoadedEvent);
        }
      })
      .catch(e => {
        console.error(e);
      });
  };
  
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  
  if (productRecommendationsSection) {
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  
    observer.observe(productRecommendationsSection);
  }
  

  /**
   * SNIPPET - ELKAD PRODUCT FORM
   */
  const elkadInitProductForm = () => {
    const elkadProductForm = document.querySelectorAll('.elkad-product-form');

    elkadProductForm.forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const add_to_cart_button = $(form).find('.elkad-product-form__submit');
        const variant_id = document.querySelector('.elkad-product-card-expanded__variants-selector__grid input[name="id"]:checked').value;
        const quantity = form.querySelector('input[name="quantity"]').value;
        const selling_plan_checked = form.querySelector('.elkad-product-form__selling-plans__toggle__input:checked');
        const selling_plan = selling_plan_checked ? form.querySelector('input[name="selling_plan"]:checked').value : 0;

        addVariantToCart(add_to_cart_button, variant_id, quantity, {}, selling_plan);
      }
    )});
    
    // Add mutationObserver to .elkad-selecteur-wrapper if it exists
    // If there is a mutation on its child with class .elkad-selector-bottom-bar, initSelectorForm will be called
    const elkadYotpoWidget = document.querySelector('.yotpo.bottomLine');

    if (elkadYotpoWidget) {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            const yotpoWidget = document.querySelector(".yotpo-bottomline.pull-left.star-clickable > a");

            if (yotpoWidget) {
              yotpoWidget.href = "#section--avis-produit";
            }
          });
        });
      });

      observer.observe(elkadYotpoWidget, { childList: true, subtree: true });
    }
  };

  elkadInitProductForm();

  
  // Detect when .elkad-product-header__inner__right children with class .elkad-product-card-expanded has changed, 
  // after it changed and once .elkad-product-header__inner__right do not have .elkad-product-header__inner__right--loading class anymore, 
  // load elkadInitProductForm
  const elkadProductHeaderRight = document.querySelector('.elkad-product-header__inner__right');

  if (elkadProductHeaderRight) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          for(let i = 0; i < mutation.addedNodes.length; i++) {
            if(mutation.addedNodes[i].nodeType === Node.ELEMENT_NODE && mutation.addedNodes[i].classList.contains('elkad-product-card-expanded')) {
              elkadInitProductForm();
            }
          }
        }
      });
    });

    observer.observe(elkadProductHeaderRight, { childList: true, subtree: true });
  }

  const elkadProductCardDetailedForms = document.querySelectorAll('[data-elkad-product-card-detailed-form]');

  elkadProductCardDetailedForms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const add_to_cart_button = $(form).find('.elkad-product-card-detailed__add-to-cart');
      const variant_id = form.querySelector('input[name="id"]').value;
      const quantity = 1;
      const selling_plan = form.querySelector('input[name="selling_plan"]') ? form.querySelector('input[name="selling_plan"]').value : 0;

      addVariantToCart(add_to_cart_button, variant_id, quantity, {}, selling_plan);
    }
  )});


  /**
   * PAGE - ELKAD RESULTAT BILAN PERSO
   */
  document.addEventListener("bilan-perso:all-cards-added", async (e) => {
    const allCards = document.querySelectorAll('.elkad-product-card-detailed');

    for (let card of allCards) {
      const elkadProductCardDetailedForm = card.querySelector('[data-elkad-product-card-detailed-form]');

      if (!elkadProductCardDetailedForm) continue;

      elkadProductCardDetailedForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const add_to_cart_button = $(elkadProductCardDetailedForm).find('.elkad-product-card-detailed__add-to-cart');
        const variant_id = card.querySelector(".elkad-product-card-detailed__variants-selector__active") ? card.querySelector(".elkad-product-card-detailed__variants-selector__active").getAttribute("data-variant-id") : elkadProductCardDetailedForm.querySelector('input[name="id"]').value;
        const quantity = 1;
        const selling_plan = elkadProductCardDetailedForm.querySelector('input[name="selling_plan"]') ? elkadProductCardDetailedForm.querySelector('input[name="selling_plan"]').value : 0;

        addVariantToCart(add_to_cart_button, variant_id, quantity, {}, selling_plan);
      });
    };

    initProductCard();
  });

  document.addEventListener("bilan-perso:add-selection-to-cart", async (e) => {
    Shopify.queue = [];

    for (let item of e.detail.user_selection.items) {
      addVariantToQueue(item.variant_id, item.quantity, {}, 0);
    }

    const add_to_cart_button = $(e.detail.submit_button_selector);

    Shopify.moveAlong(add_to_cart_button);
  });


  /**
   * SECTION - ELKAD SELECTOR
   */

  const elkadAddSelectedItemsToCart = async (timestamp, elkadSelectorSubmitButton) => {
    if (elkadSelectorSubmitButton) {
      const selectedItems = document.querySelectorAll(".elkad-product-card--selected");

      selectedItems.forEach((item) => {
        const itemData = item.getAttribute("data-variant-json");
        const itemDataJson = JSON.parse(itemData);

        if (itemDataJson.sku == 'NO_SHAKER') return;

        // const itemSelector = item.querySelector(".elkad-product-card__variants-selector__active");
        // const item_id = itemSelector ? itemSelector.getAttribute("data-variant-id") : itemDataJson.id;
        const item_id = item.getAttribute("data-variant-id") ? item.getAttribute("data-variant-id") : itemDataJson.id;

        const item_quantity = Number(item.querySelector(".elkad-quick-add-to-cart__input").value);

        let properties = {
          id: timestamp
        };

        if (item.getAttribute("data-gift-unlocked") == "true") {
          properties["_CX_SOSHAPE"] = item.getAttribute("data-gift-minimum-products-in-pack");
        }

        const selling_plan = document.querySelector(".elkad-selector-bottom-bar__form__detail__subscription__selling-plans__toggle__input:checked") && itemDataJson.selling_plan_allocations[document.querySelector("input.elkad-selector-bottom-bar__form__detail__subscription__selling-plans__options__item__input[name='selling_plan']:checked").getAttribute("data-position")] ? itemDataJson.selling_plan_allocations[document.querySelector("input.elkad-selector-bottom-bar__form__detail__subscription__selling-plans__options__item__input[name='selling_plan']:checked").getAttribute("data-position")].selling_plan_id : 0;

        // On sauvegarde le nom du bundle pour #Smartrr
        if(selling_plan != 0 && typeof SmartrrBundleInformation !== 'undefined') {
          var bundle = SmartrrBundleInformation;

          if(typeof bundle !== 'undefined') {
            var bundle_info = {
                items: [],
                date: new Date().getTime(),
                page: window.location.toString(),
                bundle: {
                  name: bundle.name,
                  slug: bundle.slug
                }
              };
            
            properties["Bundle"] = bundle.name;
          }
        }
        
        // On sauvegarde le contenu du bundle pour #Smartrr
        if(typeof bundle_info !== 'undefined') {
          bundle_info.items.push({
            id: item_id,
            quantity: item_quantity,
            selling_plan: selling_plan,
          });
        }

        // On sauvegarde le nom du bundle pour #Smartrr
        if(typeof bundle_info !== 'undefined') {
          properties["_smartrr_info"] = JSON.stringify(bundle_info);
        }

        addVariantToQueue(item_id, item_quantity, properties, selling_plan);
      });
    }
  }

  const initSelectorForm = () => {
    const elkadSelectorSubmitButton = document.querySelector('.elkad-selector-bottom-bar__submit');

    if (elkadSelectorSubmitButton) {
      elkadSelectorSubmitButton.addEventListener('click', async (e) => {
        const button = e.target.hasAttribute('data-elkad-button-action') ? e.target : e.target.closest('[data-elkad-button-action]');
        if (button.getAttribute('data-elkad-button-action') == 'add_to_cart') {
          e.preventDefault();
    
          const timestamp = $.now();
      
          Shopify.queue = [];
      
          elkadAddSelectedItemsToCart(timestamp, button);
      
          Shopify.moveAlong($('.elkad-selector-bottom-bar__form .elkad-selector-bottom-bar__submit'));
        }
      });
    }
  }

  initSelectorForm();

  // Add mutationObserver to .elkad-selecteur-wrapper if it exists
  // If there is a mutation on its child with class .elkad-selector-bottom-bar, initSelectorForm will be called
  const elkadSelectorWrapper = document.querySelector('.elkad-selecteur-wrapper');

  if (elkadSelectorWrapper) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        // If mutation.addedNodes has class .elkad-selector-bottom-bar, initSelectorForm will be called
        mutation.addedNodes.forEach(node => {
          if (node.classList && node.classList.contains('elkad-selector-bottom-bar')) {
            initSelectorForm();
          }
        });
      });
    });

    observer.observe(elkadSelectorWrapper, { childList: true, subtree: true });
  }

  /**
   * CART - ELKAD PACK IN CART
   */

  const elkadInitPackInCart = () => {
    const packs = document.querySelectorAll('.elkad-pack-snack-cart');
  
    packs.forEach((pack) => {
      const subscriptionCheckbox = pack.querySelector('.js-elkad-subscription-checkbox-for-pack');
  
      if (!subscriptionCheckbox) return;
  
      subscriptionCheckbox.addEventListener('change', async (e) => {
        const productsInPack = pack.querySelectorAll('.item-cart');
  
        changeCartItemsSellingPlan(productsInPack, false);
      });
  
      const subscriptionSelect = pack.querySelector('.js-elkad-subscription-select-for-pack');
  
      if (!subscriptionSelect) return;
  
      subscriptionSelect.addEventListener('change', async (e) => {
        const productsInPack = pack.querySelectorAll('.item-cart');
  
        productsInPack.forEach((product) => {
          const subscriptionInput = product.querySelector('[data-smartrr-selling-plans-select]');
  
          if (subscriptionInput) {
            subscriptionInput.selectedIndex = subscriptionSelect.selectedIndex;
          }
        });
  
        changeCartItemsSellingPlan(productsInPack, true);
      });
    });
  };

  elkadInitPackInCart();

  const elkadGiftForPackInCart = () => {
    const packs = document.querySelectorAll('.elkad-pack-snack-cart');

    packs.forEach((pack) => {    
      const allNonGiftItemsInPack = pack.querySelectorAll('.item-cart-wrapper:not([data-minimum-quantity-for-gift])');  
      const allGiftItemsInPack = pack.querySelectorAll('.item-cart-wrapper[data-minimum-quantity-for-gift]');
      let packQuantity = 0;

      allNonGiftItemsInPack.forEach((item) => {
        packQuantity += parseInt(item.getAttribute('data-item-quantity'));
      });

      allGiftItemsInPack.forEach((giftItem) => {
        const minimumQuantityForGift = parseInt(giftItem.getAttribute("data-minimum-quantity-for-gift"));

        if (packQuantity < minimumQuantityForGift) {
          removeProduct($(giftItem).find('[data-action="remove-product"]'));
        }
      });
    });
  }

  elkadGiftForPackInCart();
  
  /**
   * ----------------------------------------------------------------------------------------------------
   * APPS
   * ----------------------------------------------------------------------------------------------------
   */
  
  /**
   * APP - ACCESSIBILITY TOOL
   */

  // Affiche et ouvre le widget d'accessibilité (#SoShape)
  function showAndOpenAccessibilityTool($this) {
    var tool = $('.aa-cc-body-fix-compliance-part');
    
    if(tool.length){
      tool.toggle();
      tool.find('.aa-cc-fix-icon-body')[0].click();
    }
  }
  
  // Au clic sur le lien "Accessibility Tool"
  function _clickOpenAccessibilityToolListener($this, e) {
    e.preventDefault();
    showAndOpenAccessibilityTool($this);
  }
  
  // Au clic sur le lien "Accessibility Tool"
  $(document).on('click', '[href="#open_accessibility_tool"]', function(e) {
    _clickOpenAccessibilityToolListener($(this), e);
  });

  /**
   * APP - GORGIAS
   */

  // Affiche et ouvre le chat Gorgias (#SoShape)
  function openGorgiasChat($this) {
    $('#gorgias-chat-container').find('#chat-button')[0].contentDocument.querySelector('#mountHere').querySelector('button').click();
  }
  
  // Au clic sur un lien qui ouvre le chat
  function _clickOpenGorgiasListener($this, e) {
    e.preventDefault();
    openGorgiasChat($this);
  }

  // Au clic sur un lien qui ouvre le chat
  $(document).on('click', '[data-action="open-gorgias"]', function(e) {
    _clickOpenGorgiasListener($(this), e);
  });

  /**
   * APP - KLAVIYO
   */

  // Ouvre une popup Klaviyo (#SoShape)
  function openKlaviyoPopup($this) {   
    var kl_on_site = window._klOnsite || [],
        form_id = $this.data('form');
       
    kl_on_site.push(['openForm', form_id]);
  }
  
  // Au clic sur un lien qui affiche une popup de Klaviyo
  function _clickOpenKlaviyoPopupListener($this, e) {
    e.preventDefault();
    openKlaviyoPopup($this);
  }
  
  // Au clic sur un lien qui affiche une popup de Klaviyo
  $(document).on('click', '[href="#open_klaviyo_popup"]', function(e) {
    _clickOpenKlaviyoPopupListener($(this), e);
  });

  // Mettre à jour le panier lorsqu'un rdv est ajouté au panier avec l'app Easy Appointments
  class CartWatcher {
    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
      });
    }
  
    async fetchCart() {
      const response = await fetch('/cart.js');
      return response.json();
    }
  
    storeCart(cart) {
      localStorage.setItem('cart', JSON.stringify(cart));
    }
  
   storedCart() {
      return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }
  
   findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
      };
  
      oldCart.items.forEach(oi => {
        const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
        if (!ni) return;
        let quantity = ni.quantity - oi.quantity;
        let item = { ...ni };
        item.quantity = Math.abs(quantity);
        quantity > 0
          ? result.added.push(item)
          : result.removed.push(item)
      });
  
      return result;
    }
  
    async emitCartChanges() {
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();
      const changes = this.findCartChanges(oldCart, newCart);
  
      const event = new CustomEvent("cart_changed", { detail: changes });
      window.dispatchEvent(event);
  
      this.storeCart(newCart);
    }
  
   observeCartChanges() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }
  }
  
  const myCartWatcher = new CartWatcher;
  myCartWatcher.init();
  window.addEventListener("cart_changed", e => {  
    const addedItems = e.detail.added;
    const addedItemsContainsEventProperty = addedItems.some(item => item.properties["_Event #"]);
  
    if (!addedItemsContainsEventProperty) return;
  
    productAddedDrawer();

    const easyAppointmentClose = document.querySelector('.servicify-modal-close');

    if (easyAppointmentClose) {
      easyAppointmentClose.click();
    }
  });
  
}(jQuery));